
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire0300"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire0300"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
// ============================================================
// MAIN - IMPORTS
// ============================================================
var $f233fb7ce3af900a$exports = {};
!function(t, n) {
    $f233fb7ce3af900a$exports = n();
}($f233fb7ce3af900a$exports, function() {
    function t(t, n) {
        for(var r = 0; r < n.length; r++){
            var i = n[r];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, "symbol" == typeof (e = function(t, n) {
                if ("object" != typeof t || null === t) return t;
                var r = t[Symbol.toPrimitive];
                if (void 0 !== r) {
                    var i = r.call(t, "string");
                    if ("object" != typeof i) return i;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return String(t);
            }(i.key)) ? e : String(e), i);
        }
        var e;
    }
    function n(n, r, i) {
        return r && t(n.prototype, r), i && t(n, i), Object.defineProperty(n, "prototype", {
            writable: !1
        }), n;
    }
    function r() {
        return r = Object.assign ? Object.assign.bind() : function(t) {
            for(var n = 1; n < arguments.length; n++){
                var r = arguments[n];
                for(var i in r)Object.prototype.hasOwnProperty.call(r, i) && (t[i] = r[i]);
            }
            return t;
        }, r.apply(this, arguments);
    }
    function i(t, n) {
        t.prototype = Object.create(n.prototype), t.prototype.constructor = t, o(t, n);
    }
    function e(t) {
        return e = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
            return t.__proto__ || Object.getPrototypeOf(t);
        }, e(t);
    }
    function o(t, n) {
        return o = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, n) {
            return t.__proto__ = n, t;
        }, o(t, n);
    }
    function u() {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
        } catch (t) {
            return !1;
        }
    }
    function s(t, n, r) {
        return s = u() ? Reflect.construct.bind() : function(t, n, r) {
            var i = [
                null
            ];
            i.push.apply(i, n);
            var e = new (Function.bind.apply(t, i));
            return r && o(e, r.prototype), e;
        }, s.apply(null, arguments);
    }
    function f(t) {
        var n = "function" == typeof Map ? new Map : void 0;
        return f = function(t) {
            if (null === t || -1 === Function.toString.call(t).indexOf("[native code]")) return t;
            if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
            if (void 0 !== n) {
                if (n.has(t)) return n.get(t);
                n.set(t, r);
            }
            function r() {
                return s(t, arguments, e(this).constructor);
            }
            return r.prototype = Object.create(t.prototype, {
                constructor: {
                    value: r,
                    enumerable: !1,
                    writable: !0,
                    configurable: !0
                }
            }), o(r, t);
        }, f(t);
    }
    function c(t) {
        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t;
    }
    var a, h = function() {
        this.before = void 0, this.beforeLeave = void 0, this.leave = void 0, this.afterLeave = void 0, this.beforeEnter = void 0, this.enter = void 0, this.afterEnter = void 0, this.after = void 0;
    };
    !function(t) {
        t[t.off = 0] = "off", t[t.error = 1] = "error", t[t.warning = 2] = "warning", t[t.info = 3] = "info", t[t.debug = 4] = "debug";
    }(a || (a = {}));
    var v = a.off, d = /*#__PURE__*/ function() {
        function t(t) {
            this.t = void 0, this.t = t;
        }
        t.getLevel = function() {
            return v;
        }, t.setLevel = function(t) {
            return v = a[t];
        };
        var n = t.prototype;
        return n.error = function() {
            this.i(console.error, a.error, [].slice.call(arguments));
        }, n.warn = function() {
            this.i(console.warn, a.warning, [].slice.call(arguments));
        }, n.info = function() {
            this.i(console.info, a.info, [].slice.call(arguments));
        }, n.debug = function() {
            this.i(console.log, a.debug, [].slice.call(arguments));
        }, n.i = function(n, r, i) {
            r <= t.getLevel() && n.apply(console, [
                "[" + this.t + "] "
            ].concat(i));
        }, t;
    }();
    function l(t) {
        return t.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");
    }
    function p(t) {
        return t && t.sensitive ? "" : "i";
    }
    var m = {
        container: "container",
        history: "history",
        namespace: "namespace",
        prefix: "data-barba",
        prevent: "prevent",
        wrapper: "wrapper"
    }, w = /*#__PURE__*/ function() {
        function t() {
            this.o = m, this.u = void 0, this.h = {
                after: null,
                before: null,
                parent: null
            };
        }
        var n = t.prototype;
        return n.toString = function(t) {
            return t.outerHTML;
        }, n.toDocument = function(t) {
            return this.u || (this.u = new DOMParser), this.u.parseFromString(t, "text/html");
        }, n.toElement = function(t) {
            var n = document.createElement("div");
            return n.innerHTML = t, n;
        }, n.getHtml = function(t) {
            return void 0 === t && (t = document), this.toString(t.documentElement);
        }, n.getWrapper = function(t) {
            return void 0 === t && (t = document), t.querySelector("[" + this.o.prefix + '="' + this.o.wrapper + '"]');
        }, n.getContainer = function(t) {
            return void 0 === t && (t = document), t.querySelector("[" + this.o.prefix + '="' + this.o.container + '"]');
        }, n.removeContainer = function(t) {
            document.body.contains(t) && (this.v(t), t.parentNode.removeChild(t));
        }, n.addContainer = function(t, n) {
            var r = this.getContainer() || this.h.before;
            r ? this.l(t, r) : this.h.after ? this.h.after.parentNode.insertBefore(t, this.h.after) : this.h.parent ? this.h.parent.appendChild(t) : n.appendChild(t);
        }, n.getSibling = function() {
            return this.h;
        }, n.getNamespace = function(t) {
            void 0 === t && (t = document);
            var n = t.querySelector("[" + this.o.prefix + "-" + this.o.namespace + "]");
            return n ? n.getAttribute(this.o.prefix + "-" + this.o.namespace) : null;
        }, n.getHref = function(t) {
            if (t.tagName && "a" === t.tagName.toLowerCase()) {
                if ("string" == typeof t.href) return t.href;
                var n = t.getAttribute("href") || t.getAttribute("xlink:href");
                if (n) return this.resolveUrl(n.baseVal || n);
            }
            return null;
        }, n.resolveUrl = function() {
            var t = [].slice.call(arguments).length;
            if (0 === t) throw new Error("resolveUrl requires at least one argument; got none.");
            var n = document.createElement("base");
            if (n.href = arguments[0], 1 === t) return n.href;
            var r = document.getElementsByTagName("head")[0];
            r.insertBefore(n, r.firstChild);
            for(var i, e = document.createElement("a"), o = 1; o < t; o++)e.href = arguments[o], n.href = i = e.href;
            return r.removeChild(n), i;
        }, n.l = function(t, n) {
            n.parentNode.insertBefore(t, n.nextSibling);
        }, n.v = function(t) {
            return this.h = {
                after: t.nextElementSibling,
                before: t.previousElementSibling,
                parent: t.parentElement
            }, this.h;
        }, t;
    }(), b = new w, y = /*#__PURE__*/ function() {
        function t() {
            this.p = void 0, this.m = [], this.P = -1;
        }
        var i = t.prototype;
        return i.init = function(t, n) {
            this.p = "barba";
            var r = {
                data: {},
                ns: n,
                scroll: {
                    x: window.scrollX,
                    y: window.scrollY
                },
                url: t
            };
            this.P = 0, this.m.push(r);
            var i = {
                from: this.p,
                index: this.P,
                states: [].concat(this.m)
            };
            window.history && window.history.replaceState(i, "", t);
        }, i.change = function(t, n, r) {
            if (r && r.state) {
                var i = r.state, e = i.index;
                n = this.g(this.P - e), this.replace(i.states), this.P = e;
            } else this.add(t, n);
            return n;
        }, i.add = function(t, n, r, i) {
            var e = null != r ? r : this.R(n), o = {
                data: null != i ? i : {},
                ns: "tmp",
                scroll: {
                    x: window.scrollX,
                    y: window.scrollY
                },
                url: t
            };
            switch(e){
                case "push":
                    this.P = this.size, this.m.push(o);
                    break;
                case "replace":
                    this.set(this.P, o);
            }
            var u = {
                from: this.p,
                index: this.P,
                states: [].concat(this.m)
            };
            switch(e){
                case "push":
                    window.history && window.history.pushState(u, "", t);
                    break;
                case "replace":
                    window.history && window.history.replaceState(u, "", t);
            }
        }, i.store = function(t, n) {
            var i = n || this.P, e = this.get(i);
            e.data = r({}, e.data, t), this.set(i, e);
            var o = {
                from: this.p,
                index: this.P,
                states: [].concat(this.m)
            };
            window.history.replaceState(o, "");
        }, i.update = function(t, n) {
            var i = n || this.P, e = r({}, this.get(i), t);
            this.set(i, e);
        }, i.remove = function(t) {
            t ? this.m.splice(t, 1) : this.m.pop(), this.P--;
        }, i.clear = function() {
            this.m = [], this.P = -1;
        }, i.replace = function(t) {
            this.m = t;
        }, i.get = function(t) {
            return this.m[t];
        }, i.set = function(t, n) {
            return this.m[t] = n;
        }, i.R = function(t) {
            var n = "push", r = t, i = m.prefix + "-" + m.history;
            return r.hasAttribute && r.hasAttribute(i) && (n = r.getAttribute(i)), n;
        }, i.g = function(t) {
            return Math.abs(t) > 1 ? t > 0 ? "forward" : "back" : 0 === t ? "popstate" : t > 0 ? "back" : "forward";
        }, n(t, [
            {
                key: "current",
                get: function() {
                    return this.m[this.P];
                }
            },
            {
                key: "previous",
                get: function() {
                    return this.P < 1 ? null : this.m[this.P - 1];
                }
            },
            {
                key: "size",
                get: function() {
                    return this.m.length;
                }
            }
        ]), t;
    }(), P = new y, g = function(t, n) {
        try {
            var r = function() {
                if (!n.next.html) return Promise.resolve(t).then(function(t) {
                    var r = n.next;
                    if (t) {
                        var i = b.toElement(t.html);
                        r.namespace = b.getNamespace(i), r.container = b.getContainer(i), r.url = t.url, r.html = t.html, P.update({
                            ns: r.namespace
                        });
                        var e = b.toDocument(t.html);
                        document.title = e.title;
                    }
                });
            }();
            return Promise.resolve(r && r.then ? r.then(function() {}) : void 0);
        } catch (t) {
            return Promise.reject(t);
        }
    }, E = function t(n, r, i) {
        return n instanceof RegExp ? function(t, n) {
            if (!n) return t;
            for(var r = /\((?:\?<(.*?)>)?(?!\?)/g, i = 0, e = r.exec(t.source); e;)n.push({
                name: e[1] || i++,
                prefix: "",
                suffix: "",
                modifier: "",
                pattern: ""
            }), e = r.exec(t.source);
            return t;
        }(n, r) : Array.isArray(n) ? function(n, r, i) {
            var e = n.map(function(n) {
                return t(n, r, i).source;
            });
            return new RegExp("(?:".concat(e.join("|"), ")"), p(i));
        }(n, r, i) : function(t, n, r) {
            return function(t, n, r) {
                void 0 === r && (r = {});
                for(var i = r.strict, e = void 0 !== i && i, o = r.start, u = void 0 === o || o, s = r.end, f = void 0 === s || s, c = r.encode, a = void 0 === c ? function(t) {
                    return t;
                } : c, h = r.delimiter, v = void 0 === h ? "/#?" : h, d = r.endsWith, m = "[".concat(l(void 0 === d ? "" : d), "]|$"), w = "[".concat(l(v), "]"), b = u ? "^" : "", y = 0, P = t; y < P.length; y++){
                    var g = P[y];
                    if ("string" == typeof g) b += l(a(g));
                    else {
                        var E = l(a(g.prefix)), x = l(a(g.suffix));
                        if (g.pattern) {
                            if (n && n.push(g), E || x) {
                                if ("+" === g.modifier || "*" === g.modifier) {
                                    var R = "*" === g.modifier ? "?" : "";
                                    b += "(?:".concat(E, "((?:").concat(g.pattern, ")(?:").concat(x).concat(E, "(?:").concat(g.pattern, "))*)").concat(x, ")").concat(R);
                                } else b += "(?:".concat(E, "(").concat(g.pattern, ")").concat(x, ")").concat(g.modifier);
                            } else b += "+" === g.modifier || "*" === g.modifier ? "((?:".concat(g.pattern, ")").concat(g.modifier, ")") : "(".concat(g.pattern, ")").concat(g.modifier);
                        } else b += "(?:".concat(E).concat(x, ")").concat(g.modifier);
                    }
                }
                if (f) e || (b += "".concat(w, "?")), b += r.endsWith ? "(?=".concat(m, ")") : "$";
                else {
                    var k = t[t.length - 1], O = "string" == typeof k ? w.indexOf(k[k.length - 1]) > -1 : void 0 === k;
                    e || (b += "(?:".concat(w, "(?=").concat(m, "))?")), O || (b += "(?=".concat(w, "|").concat(m, ")"));
                }
                return new RegExp(b, p(r));
            }(function(t, n) {
                void 0 === n && (n = {});
                for(var r = function(t) {
                    for(var n = [], r = 0; r < t.length;){
                        var i = t[r];
                        if ("*" !== i && "+" !== i && "?" !== i) {
                            if ("\\" !== i) {
                                if ("{" !== i) {
                                    if ("}" !== i) {
                                        if (":" !== i) {
                                            if ("(" !== i) n.push({
                                                type: "CHAR",
                                                index: r,
                                                value: t[r++]
                                            });
                                            else {
                                                var e = 1, o = "";
                                                if ("?" === t[s = r + 1]) throw new TypeError('Pattern cannot start with "?" at '.concat(s));
                                                for(; s < t.length;)if ("\\" !== t[s]) {
                                                    if (")" === t[s]) {
                                                        if (0 == --e) {
                                                            s++;
                                                            break;
                                                        }
                                                    } else if ("(" === t[s] && (e++, "?" !== t[s + 1])) throw new TypeError("Capturing groups are not allowed at ".concat(s));
                                                    o += t[s++];
                                                } else o += t[s++] + t[s++];
                                                if (e) throw new TypeError("Unbalanced pattern at ".concat(r));
                                                if (!o) throw new TypeError("Missing pattern at ".concat(r));
                                                n.push({
                                                    type: "PATTERN",
                                                    index: r,
                                                    value: o
                                                }), r = s;
                                            }
                                        } else {
                                            for(var u = "", s = r + 1; s < t.length;){
                                                var f = t.charCodeAt(s);
                                                if (!(f >= 48 && f <= 57 || f >= 65 && f <= 90 || f >= 97 && f <= 122 || 95 === f)) break;
                                                u += t[s++];
                                            }
                                            if (!u) throw new TypeError("Missing parameter name at ".concat(r));
                                            n.push({
                                                type: "NAME",
                                                index: r,
                                                value: u
                                            }), r = s;
                                        }
                                    } else n.push({
                                        type: "CLOSE",
                                        index: r,
                                        value: t[r++]
                                    });
                                } else n.push({
                                    type: "OPEN",
                                    index: r,
                                    value: t[r++]
                                });
                            } else n.push({
                                type: "ESCAPED_CHAR",
                                index: r++,
                                value: t[r++]
                            });
                        } else n.push({
                            type: "MODIFIER",
                            index: r,
                            value: t[r++]
                        });
                    }
                    return n.push({
                        type: "END",
                        index: r,
                        value: ""
                    }), n;
                }(t), i = n.prefixes, e = void 0 === i ? "./" : i, o = "[^".concat(l(n.delimiter || "/#?"), "]+?"), u = [], s = 0, f = 0, c = "", a = function(t) {
                    if (f < r.length && r[f].type === t) return r[f++].value;
                }, h = function(t) {
                    var n = a(t);
                    if (void 0 !== n) return n;
                    var i = r[f], e = i.index;
                    throw new TypeError("Unexpected ".concat(i.type, " at ").concat(e, ", expected ").concat(t));
                }, v = function() {
                    for(var t, n = ""; t = a("CHAR") || a("ESCAPED_CHAR");)n += t;
                    return n;
                }; f < r.length;){
                    var d = a("CHAR"), p = a("NAME"), m = a("PATTERN");
                    if (p || m) -1 === e.indexOf(b = d || "") && (c += b, b = ""), c && (u.push(c), c = ""), u.push({
                        name: p || s++,
                        prefix: b,
                        suffix: "",
                        pattern: m || o,
                        modifier: a("MODIFIER") || ""
                    });
                    else {
                        var w = d || a("ESCAPED_CHAR");
                        if (w) c += w;
                        else if (c && (u.push(c), c = ""), a("OPEN")) {
                            var b = v(), y = a("NAME") || "", P = a("PATTERN") || "", g = v();
                            h("CLOSE"), u.push({
                                name: y || (P ? s++ : ""),
                                pattern: y && !P ? o : P,
                                prefix: b,
                                suffix: g,
                                modifier: a("MODIFIER") || ""
                            });
                        } else h("END");
                    }
                }
                return u;
            }(t, r), n, r);
        }(n, r, i);
    }, x = {
        __proto__: null,
        update: g,
        nextTick: function() {
            return new Promise(function(t) {
                window.requestAnimationFrame(t);
            });
        },
        pathToRegexp: E
    }, R = function() {
        return window.location.origin;
    }, k = function(t) {
        return void 0 === t && (t = window.location.href), O(t).port;
    }, O = function(t) {
        var n, r = t.match(/:\d+/);
        if (null === r) /^http/.test(t) && (n = 80), /^https/.test(t) && (n = 443);
        else {
            var i = r[0].substring(1);
            n = parseInt(i, 10);
        }
        var e, o = t.replace(R(), ""), u = {}, s = o.indexOf("#");
        s >= 0 && (e = o.slice(s + 1), o = o.slice(0, s));
        var f = o.indexOf("?");
        return f >= 0 && (u = T(o.slice(f + 1)), o = o.slice(0, f)), {
            hash: e,
            path: o,
            port: n,
            query: u
        };
    }, T = function(t) {
        return t.split("&").reduce(function(t, n) {
            var r = n.split("=");
            return t[r[0]] = r[1], t;
        }, {});
    }, A = function(t) {
        return void 0 === t && (t = window.location.href), t.replace(/(\/#.*|\/|#.*)$/, "");
    }, j = {
        __proto__: null,
        getHref: function() {
            return window.location.href;
        },
        getAbsoluteHref: function(t, n) {
            return void 0 === n && (n = document.baseURI), new URL(t, n).href;
        },
        getOrigin: R,
        getPort: k,
        getPath: function(t) {
            return void 0 === t && (t = window.location.href), O(t).path;
        },
        getQuery: function(t, n) {
            return void 0 === n && (n = !1), n ? JSON.stringify(O(t).query) : O(t).query;
        },
        getHash: function(t) {
            return O(t).hash;
        },
        parse: O,
        parseQuery: T,
        clean: A
    };
    function M(t, n, i, e, o) {
        return void 0 === n && (n = 2e3), new Promise(function(u, s) {
            var f = new XMLHttpRequest;
            f.onreadystatechange = function() {
                if (f.readyState === XMLHttpRequest.DONE) {
                    if (200 === f.status) {
                        var n = "" !== f.responseURL && f.responseURL !== t ? f.responseURL : t;
                        u({
                            html: f.responseText,
                            url: r({
                                href: n
                            }, O(n))
                        }), e.update(t, {
                            status: "fulfilled",
                            target: n
                        });
                    } else if (f.status) {
                        var o = {
                            status: f.status,
                            statusText: f.statusText
                        };
                        i(t, o), s(o), e.update(t, {
                            status: "rejected"
                        });
                    }
                }
            }, f.ontimeout = function() {
                var r = new Error("Timeout error [" + n + "]");
                i(t, r), s(r), e.update(t, {
                    status: "rejected"
                });
            }, f.onerror = function() {
                var n = new Error("Fetch error");
                i(t, n), s(n), e.update(t, {
                    status: "rejected"
                });
            }, f.open("GET", t), f.timeout = n, f.setRequestHeader("Accept", "text/html,application/xhtml+xml,application/xml"), f.setRequestHeader("x-barba", "yes"), o.all().forEach(function(t, n) {
                f.setRequestHeader(n, t);
            }), f.send();
        });
    }
    function N(t) {
        return !!t && ("object" == typeof t || "function" == typeof t) && "function" == typeof t.then;
    }
    function S(t, n) {
        return void 0 === n && (n = {}), function() {
            var r = arguments, i = !1, e = new Promise(function(e, o) {
                n.async = function() {
                    return i = !0, function(t, n) {
                        t ? o(t) : e(n);
                    };
                };
                var u = t.apply(n, [].slice.call(r));
                i || (N(u) ? u.then(e, o) : e(u));
            });
            return e;
        };
    }
    var C = /*#__PURE__*/ function(t) {
        function n() {
            var n;
            return (n = t.call(this) || this).logger = new d("@barba/core"), n.all = [
                "ready",
                "page",
                "reset",
                "currentAdded",
                "currentRemoved",
                "nextAdded",
                "nextRemoved",
                "beforeOnce",
                "once",
                "afterOnce",
                "before",
                "beforeLeave",
                "leave",
                "afterLeave",
                "beforeEnter",
                "enter",
                "afterEnter",
                "after"
            ], n.registered = new Map, n.init(), n;
        }
        i(n, t);
        var r = n.prototype;
        return r.init = function() {
            var t = this;
            this.registered.clear(), this.all.forEach(function(n) {
                t[n] || (t[n] = function(r, i) {
                    t.registered.has(n) || t.registered.set(n, new Set), t.registered.get(n).add({
                        ctx: i || {},
                        fn: r
                    });
                });
            });
        }, r.do = function(t) {
            var n = arguments, r = this;
            if (this.registered.has(t)) {
                var i = Promise.resolve();
                return this.registered.get(t).forEach(function(t) {
                    i = i.then(function() {
                        return S(t.fn, t.ctx).apply(void 0, [].slice.call(n, 1));
                    });
                }), i.catch(function(n) {
                    r.logger.debug("Hook error [" + t + "]"), r.logger.error(n);
                });
            }
            return Promise.resolve();
        }, r.clear = function() {
            var t = this;
            this.all.forEach(function(n) {
                delete t[n];
            }), this.init();
        }, r.help = function() {
            this.logger.info("Available hooks: " + this.all.join(","));
            var t = [];
            this.registered.forEach(function(n, r) {
                return t.push(r);
            }), this.logger.info("Registered hooks: " + t.join(","));
        }, n;
    }(h), L = new C, H = /*#__PURE__*/ function() {
        function t(t) {
            if (this.k = void 0, this.O = [], "boolean" == typeof t) this.k = t;
            else {
                var n = Array.isArray(t) ? t : [
                    t
                ];
                this.O = n.map(function(t) {
                    return E(t);
                });
            }
        }
        return t.prototype.checkHref = function(t) {
            if ("boolean" == typeof this.k) return this.k;
            var n = O(t).path;
            return this.O.some(function(t) {
                return null !== t.exec(n);
            });
        }, t;
    }(), _ = /*#__PURE__*/ function(t) {
        function n(n) {
            var r;
            return (r = t.call(this, n) || this).T = new Map, r;
        }
        i(n, t);
        var e = n.prototype;
        return e.set = function(t, n, r, i, e) {
            return this.T.set(t, {
                action: r,
                request: n,
                status: i,
                target: null != e ? e : t
            }), {
                action: r,
                request: n,
                status: i,
                target: e
            };
        }, e.get = function(t) {
            return this.T.get(t);
        }, e.getRequest = function(t) {
            return this.T.get(t).request;
        }, e.getAction = function(t) {
            return this.T.get(t).action;
        }, e.getStatus = function(t) {
            return this.T.get(t).status;
        }, e.getTarget = function(t) {
            return this.T.get(t).target;
        }, e.has = function(t) {
            return !this.checkHref(t) && this.T.has(t);
        }, e.delete = function(t) {
            return this.T.delete(t);
        }, e.update = function(t, n) {
            var i = r({}, this.T.get(t), n);
            return this.T.set(t, i), i;
        }, n;
    }(H), D = /*#__PURE__*/ function() {
        function t() {
            this.A = new Map;
        }
        var n = t.prototype;
        return n.set = function(t, n) {
            return this.A.set(t, n), {
                name: n
            };
        }, n.get = function(t) {
            return this.A.get(t);
        }, n.all = function() {
            return this.A;
        }, n.has = function(t) {
            return this.A.has(t);
        }, n.delete = function(t) {
            return this.A.delete(t);
        }, n.clear = function() {
            return this.A.clear();
        }, t;
    }(), B = function() {
        return !window.history.pushState;
    }, q = function(t) {
        return !t.el || !t.href;
    }, F = function(t) {
        var n = t.event;
        return n.which > 1 || n.metaKey || n.ctrlKey || n.shiftKey || n.altKey;
    }, I = function(t) {
        var n = t.el;
        return n.hasAttribute("target") && "_blank" === n.target;
    }, U = function(t) {
        var n = t.el;
        return void 0 !== n.protocol && window.location.protocol !== n.protocol || void 0 !== n.hostname && window.location.hostname !== n.hostname;
    }, $ = function(t) {
        var n = t.el;
        return void 0 !== n.port && k() !== k(n.href);
    }, Q = function(t) {
        var n = t.el;
        return n.getAttribute && "string" == typeof n.getAttribute("download");
    }, X = function(t) {
        return t.el.hasAttribute(m.prefix + "-" + m.prevent);
    }, z = function(t) {
        return Boolean(t.el.closest("[" + m.prefix + "-" + m.prevent + '="all"]'));
    }, G = function(t) {
        var n = t.href;
        return A(n) === A() && k(n) === k();
    }, J = /*#__PURE__*/ function(t) {
        function n(n) {
            var r;
            return (r = t.call(this, n) || this).suite = [], r.tests = new Map, r.init(), r;
        }
        i(n, t);
        var r = n.prototype;
        return r.init = function() {
            this.add("pushState", B), this.add("exists", q), this.add("newTab", F), this.add("blank", I), this.add("corsDomain", U), this.add("corsPort", $), this.add("download", Q), this.add("preventSelf", X), this.add("preventAll", z), this.add("sameUrl", G, !1);
        }, r.add = function(t, n, r) {
            void 0 === r && (r = !0), this.tests.set(t, n), r && this.suite.push(t);
        }, r.run = function(t, n, r, i) {
            return this.tests.get(t)({
                el: n,
                event: r,
                href: i
            });
        }, r.checkLink = function(t, n, r) {
            var i = this;
            return this.suite.some(function(e) {
                return i.run(e, t, n, r);
            });
        }, n;
    }(H), W = /*#__PURE__*/ function(t) {
        function n(r, i) {
            var e;
            return void 0 === i && (i = "Barba error"), (e = t.call.apply(t, [
                this
            ].concat([].slice.call(arguments, 2))) || this).error = void 0, e.label = void 0, e.error = r, e.label = i, Error.captureStackTrace && Error.captureStackTrace(c(e), n), e.name = "BarbaError", e;
        }
        return i(n, t), n;
    }(/*#__PURE__*/ f(Error)), K = /*#__PURE__*/ function() {
        function t(t) {
            void 0 === t && (t = []), this.logger = new d("@barba/core"), this.all = [], this.page = [], this.once = [], this.j = [
                {
                    name: "namespace",
                    type: "strings"
                },
                {
                    name: "custom",
                    type: "function"
                }
            ], t && (this.all = this.all.concat(t)), this.update();
        }
        var n = t.prototype;
        return n.add = function(t, n) {
            "rule" === t ? this.j.splice(n.position || 0, 0, n.value) : this.all.push(n), this.update();
        }, n.resolve = function(t, n) {
            var r = this;
            void 0 === n && (n = {});
            var i = n.once ? this.once : this.page;
            i = i.filter(n.self ? function(t) {
                return t.name && "self" === t.name;
            } : function(t) {
                return !t.name || "self" !== t.name;
            });
            var e = new Map, o = i.find(function(i) {
                var o = !0, u = {};
                return n.self && "self" === i.name ? (e.set(i, u), !0) : (r.j.reverse().forEach(function(n) {
                    o && (o = r.M(i, n, t, u), i.from && i.to && (o = r.M(i, n, t, u, "from") && r.M(i, n, t, u, "to")), i.from && !i.to && (o = r.M(i, n, t, u, "from")), !i.from && i.to && (o = r.M(i, n, t, u, "to")));
                }), e.set(i, u), o);
            }), u = e.get(o), s = [];
            if (s.push(n.once ? "once" : "page"), n.self && s.push("self"), u) {
                var f, c = [
                    o
                ];
                Object.keys(u).length > 0 && c.push(u), (f = this.logger).info.apply(f, [
                    "Transition found [" + s.join(",") + "]"
                ].concat(c));
            } else this.logger.info("No transition found [" + s.join(",") + "]");
            return o;
        }, n.update = function() {
            var t = this;
            this.all = this.all.map(function(n) {
                return t.N(n);
            }).sort(function(t, n) {
                return t.priority - n.priority;
            }).reverse().map(function(t) {
                return delete t.priority, t;
            }), this.page = this.all.filter(function(t) {
                return void 0 !== t.leave || void 0 !== t.enter;
            }), this.once = this.all.filter(function(t) {
                return void 0 !== t.once;
            });
        }, n.M = function(t, n, r, i, e) {
            var o = !0, u = !1, s = t, f = n.name, c = f, a = f, h = f, v = e ? s[e] : s, d = "to" === e ? r.next : r.current;
            if (e ? v && v[f] : v[f]) {
                switch(n.type){
                    case "strings":
                    default:
                        var l = Array.isArray(v[c]) ? v[c] : [
                            v[c]
                        ];
                        d[c] && -1 !== l.indexOf(d[c]) && (u = !0), -1 === l.indexOf(d[c]) && (o = !1);
                        break;
                    case "object":
                        var p = Array.isArray(v[a]) ? v[a] : [
                            v[a]
                        ];
                        d[a] ? (d[a].name && -1 !== p.indexOf(d[a].name) && (u = !0), -1 === p.indexOf(d[a].name) && (o = !1)) : o = !1;
                        break;
                    case "function":
                        v[h](r) ? u = !0 : o = !1;
                }
                u && (e ? (i[e] = i[e] || {}, i[e][f] = s[e][f]) : i[f] = s[f]);
            }
            return o;
        }, n.S = function(t, n, r) {
            var i = 0;
            return (t[n] || t.from && t.from[n] || t.to && t.to[n]) && (i += Math.pow(10, r), t.from && t.from[n] && (i += 1), t.to && t.to[n] && (i += 2)), i;
        }, n.N = function(t) {
            var n = this;
            t.priority = 0;
            var r = 0;
            return this.j.forEach(function(i, e) {
                r += n.S(t, i.name, e + 1);
            }), t.priority = r, t;
        }, t;
    }();
    function V(t, n) {
        try {
            var r = t();
        } catch (t) {
            return n(t);
        }
        return r && r.then ? r.then(void 0, n) : r;
    }
    var Y = /*#__PURE__*/ function() {
        function t(t) {
            void 0 === t && (t = []), this.logger = new d("@barba/core"), this.store = void 0, this.C = !1, this.store = new K(t);
        }
        var r = t.prototype;
        return r.get = function(t, n) {
            return this.store.resolve(t, n);
        }, r.doOnce = function(t) {
            var n = t.data, r = t.transition;
            try {
                var i = function() {
                    e.C = !1;
                }, e = this, o = r || {};
                e.C = !0;
                var u = V(function() {
                    return Promise.resolve(e.L("beforeOnce", n, o)).then(function() {
                        return Promise.resolve(e.once(n, o)).then(function() {
                            return Promise.resolve(e.L("afterOnce", n, o)).then(function() {});
                        });
                    });
                }, function(t) {
                    e.C = !1, e.logger.debug("Transition error [before/after/once]"), e.logger.error(t);
                });
                return Promise.resolve(u && u.then ? u.then(i) : i());
            } catch (t) {
                return Promise.reject(t);
            }
        }, r.doPage = function(t) {
            var n = t.data, r = t.transition, i = t.page, e = t.wrapper;
            try {
                var o = function(t) {
                    u.C = !1;
                }, u = this, s = r || {}, f = !0 === s.sync || !1;
                u.C = !0;
                var c = V(function() {
                    function t() {
                        return Promise.resolve(u.L("before", n, s)).then(function() {
                            function t(t) {
                                return Promise.resolve(u.remove(n)).then(function() {
                                    return Promise.resolve(u.L("after", n, s)).then(function() {});
                                });
                            }
                            var r = function() {
                                if (f) return V(function() {
                                    return Promise.resolve(u.add(n, e)).then(function() {
                                        return Promise.resolve(u.L("beforeLeave", n, s)).then(function() {
                                            return Promise.resolve(u.L("beforeEnter", n, s)).then(function() {
                                                return Promise.resolve(Promise.all([
                                                    u.leave(n, s),
                                                    u.enter(n, s)
                                                ])).then(function() {
                                                    return Promise.resolve(u.L("afterLeave", n, s)).then(function() {
                                                        return Promise.resolve(u.L("afterEnter", n, s)).then(function() {});
                                                    });
                                                });
                                            });
                                        });
                                    });
                                }, function(t) {
                                    if (u.H(t)) throw new W(t, "Transition error [sync]");
                                });
                                var t = function(t) {
                                    return V(function() {
                                        var t = function() {
                                            if (!1 !== r) return Promise.resolve(u.add(n, e)).then(function() {
                                                return Promise.resolve(u.L("beforeEnter", n, s)).then(function() {
                                                    return Promise.resolve(u.enter(n, s, r)).then(function() {
                                                        return Promise.resolve(u.L("afterEnter", n, s)).then(function() {});
                                                    });
                                                });
                                            });
                                        }();
                                        if (t && t.then) return t.then(function() {});
                                    }, function(t) {
                                        if (u.H(t)) throw new W(t, "Transition error [before/after/enter]");
                                    });
                                }, r = !1, o = V(function() {
                                    return Promise.resolve(u.L("beforeLeave", n, s)).then(function() {
                                        return Promise.resolve(Promise.all([
                                            u.leave(n, s),
                                            g(i, n)
                                        ]).then(function(t) {
                                            return t[0];
                                        })).then(function(t) {
                                            return r = t, Promise.resolve(u.L("afterLeave", n, s)).then(function() {});
                                        });
                                    });
                                }, function(t) {
                                    if (u.H(t)) throw new W(t, "Transition error [before/after/leave]");
                                });
                                return o && o.then ? o.then(t) : t();
                            }();
                            return r && r.then ? r.then(t) : t();
                        });
                    }
                    var r = function() {
                        if (f) return Promise.resolve(g(i, n)).then(function() {});
                    }();
                    return r && r.then ? r.then(t) : t();
                }, function(t) {
                    if (u.C = !1, t.name && "BarbaError" === t.name) throw u.logger.debug(t.label), u.logger.error(t.error), t;
                    throw u.logger.debug("Transition error [page]"), u.logger.error(t), t;
                });
                return Promise.resolve(c && c.then ? c.then(o) : o());
            } catch (t) {
                return Promise.reject(t);
            }
        }, r.once = function(t, n) {
            try {
                return Promise.resolve(L.do("once", t, n)).then(function() {
                    return n.once ? S(n.once, n)(t) : Promise.resolve();
                });
            } catch (t) {
                return Promise.reject(t);
            }
        }, r.leave = function(t, n) {
            try {
                return Promise.resolve(L.do("leave", t, n)).then(function() {
                    return n.leave ? S(n.leave, n)(t) : Promise.resolve();
                });
            } catch (t) {
                return Promise.reject(t);
            }
        }, r.enter = function(t, n, r) {
            try {
                return Promise.resolve(L.do("enter", t, n)).then(function() {
                    return n.enter ? S(n.enter, n)(t, r) : Promise.resolve();
                });
            } catch (t) {
                return Promise.reject(t);
            }
        }, r.add = function(t, n) {
            try {
                return b.addContainer(t.next.container, n), L.do("nextAdded", t), Promise.resolve();
            } catch (t) {
                return Promise.reject(t);
            }
        }, r.remove = function(t) {
            try {
                return b.removeContainer(t.current.container), L.do("currentRemoved", t), Promise.resolve();
            } catch (t) {
                return Promise.reject(t);
            }
        }, r.H = function(t) {
            return t.message ? !/Timeout error|Fetch error/.test(t.message) : !t.status;
        }, r.L = function(t, n, r) {
            try {
                return Promise.resolve(L.do(t, n, r)).then(function() {
                    return r[t] ? S(r[t], r)(n) : Promise.resolve();
                });
            } catch (t) {
                return Promise.reject(t);
            }
        }, n(t, [
            {
                key: "isRunning",
                get: function() {
                    return this.C;
                },
                set: function(t) {
                    this.C = t;
                }
            },
            {
                key: "hasOnce",
                get: function() {
                    return this.store.once.length > 0;
                }
            },
            {
                key: "hasSelf",
                get: function() {
                    return this.store.all.some(function(t) {
                        return "self" === t.name;
                    });
                }
            },
            {
                key: "shouldWait",
                get: function() {
                    return this.store.all.some(function(t) {
                        return t.to && !t.to.route || t.sync;
                    });
                }
            }
        ]), t;
    }(), Z = /*#__PURE__*/ function() {
        function t(t) {
            var n = this;
            this.names = [
                "beforeLeave",
                "afterLeave",
                "beforeEnter",
                "afterEnter"
            ], this.byNamespace = new Map, 0 !== t.length && (t.forEach(function(t) {
                n.byNamespace.set(t.namespace, t);
            }), this.names.forEach(function(t) {
                L[t](n._(t));
            }));
        }
        return t.prototype._ = function(t) {
            var n = this;
            return function(r) {
                var i = t.match(/enter/i) ? r.next : r.current, e = n.byNamespace.get(i.namespace);
                return e && e[t] ? S(e[t], e)(r) : Promise.resolve();
            };
        }, t;
    }();
    Element.prototype.matches || (Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector), Element.prototype.closest || (Element.prototype.closest = function(t) {
        var n = this;
        do {
            if (n.matches(t)) return n;
            n = n.parentElement || n.parentNode;
        }while (null !== n && 1 === n.nodeType);
        return null;
    });
    var tt = {
        container: null,
        html: "",
        namespace: "",
        url: {
            hash: "",
            href: "",
            path: "",
            port: null,
            query: {}
        }
    }, nt = /*#__PURE__*/ function() {
        function t() {
            this.version = "2.10.3", this.schemaPage = tt, this.Logger = d, this.logger = new d("@barba/core"), this.plugins = [], this.timeout = void 0, this.cacheIgnore = void 0, this.cacheFirstPage = void 0, this.prefetchIgnore = void 0, this.preventRunning = void 0, this.hooks = L, this.cache = void 0, this.headers = void 0, this.prevent = void 0, this.transitions = void 0, this.views = void 0, this.dom = b, this.helpers = x, this.history = P, this.request = M, this.url = j, this.D = void 0, this.B = void 0, this.q = void 0, this.F = void 0;
        }
        var i = t.prototype;
        return i.use = function(t, n) {
            var r = this.plugins;
            r.indexOf(t) > -1 ? this.logger.warn("Plugin [" + t.name + "] already installed.") : "function" == typeof t.install ? (t.install(this, n), r.push(t)) : this.logger.warn("Plugin [" + t.name + '] has no "install" method.');
        }, i.init = function(t) {
            var n = void 0 === t ? {} : t, i = n.transitions, e = void 0 === i ? [] : i, o = n.views, u = void 0 === o ? [] : o, s = n.schema, f = void 0 === s ? m : s, c = n.requestError, a = n.timeout, h = void 0 === a ? 2e3 : a, v = n.cacheIgnore, l = void 0 !== v && v, p = n.cacheFirstPage, w = void 0 !== p && p, b = n.prefetchIgnore, y = void 0 !== b && b, P = n.preventRunning, g = void 0 !== P && P, E = n.prevent, x = void 0 === E ? null : E, R = n.debug, k = n.logLevel;
            if (d.setLevel(!0 === (void 0 !== R && R) ? "debug" : void 0 === k ? "off" : k), this.logger.info(this.version), Object.keys(f).forEach(function(t) {
                m[t] && (m[t] = f[t]);
            }), this.B = c, this.timeout = h, this.cacheIgnore = l, this.cacheFirstPage = w, this.prefetchIgnore = y, this.preventRunning = g, this.q = this.dom.getWrapper(), !this.q) throw new Error("[@barba/core] No Barba wrapper found");
            this.I();
            var O = this.data.current;
            if (!O.container) throw new Error("[@barba/core] No Barba container found");
            if (this.cache = new _(l), this.headers = new D, this.prevent = new J(y), this.transitions = new Y(e), this.views = new Z(u), null !== x) {
                if ("function" != typeof x) throw new Error("[@barba/core] Prevent should be a function");
                this.prevent.add("preventCustom", x);
            }
            this.history.init(O.url.href, O.namespace), w && this.cache.set(O.url.href, Promise.resolve({
                html: O.html,
                url: O.url
            }), "init", "fulfilled"), this.U = this.U.bind(this), this.$ = this.$.bind(this), this.X = this.X.bind(this), this.G(), this.plugins.forEach(function(t) {
                return t.init();
            });
            var T = this.data;
            T.trigger = "barba", T.next = T.current, T.current = r({}, this.schemaPage), this.hooks.do("ready", T), this.once(T), this.I();
        }, i.destroy = function() {
            this.I(), this.J(), this.history.clear(), this.hooks.clear(), this.plugins = [];
        }, i.force = function(t) {
            window.location.assign(t);
        }, i.go = function(t, n, r) {
            var i;
            if (void 0 === n && (n = "barba"), this.F = null, this.transitions.isRunning) this.force(t);
            else if (!(i = "popstate" === n ? this.history.current && this.url.getPath(this.history.current.url) === this.url.getPath(t) && this.url.getQuery(this.history.current.url, !0) === this.url.getQuery(t, !0) : this.prevent.run("sameUrl", null, null, t)) || this.transitions.hasSelf) return n = this.history.change(this.cache.has(t) ? this.cache.get(t).target : t, n, r), r && (r.stopPropagation(), r.preventDefault()), this.page(t, n, null != r ? r : void 0, i);
        }, i.once = function(t) {
            try {
                var n = this;
                return Promise.resolve(n.hooks.do("beforeEnter", t)).then(function() {
                    function r() {
                        return Promise.resolve(n.hooks.do("afterEnter", t)).then(function() {});
                    }
                    var i = function() {
                        if (n.transitions.hasOnce) {
                            var r = n.transitions.get(t, {
                                once: !0
                            });
                            return Promise.resolve(n.transitions.doOnce({
                                transition: r,
                                data: t
                            })).then(function() {});
                        }
                    }();
                    return i && i.then ? i.then(r) : r();
                });
            } catch (t) {
                return Promise.reject(t);
            }
        }, i.page = function(t, n, i, e) {
            try {
                var o, u = function() {
                    var t = s.data;
                    return Promise.resolve(s.hooks.do("page", t)).then(function() {
                        var n = function(n, r) {
                            try {
                                var i = (u = s.transitions.get(t, {
                                    once: !1,
                                    self: e
                                }), Promise.resolve(s.transitions.doPage({
                                    data: t,
                                    page: o,
                                    transition: u,
                                    wrapper: s.q
                                })).then(function() {
                                    s.I();
                                }));
                            } catch (t) {
                                return r();
                            }
                            var u;
                            return i && i.then ? i.then(void 0, r) : i;
                        }(0, function() {
                            0 === d.getLevel() && s.force(t.next.url.href);
                        });
                        if (n && n.then) return n.then(function() {});
                    });
                }, s = this;
                if (s.data.next.url = r({
                    href: t
                }, s.url.parse(t)), s.data.trigger = n, s.data.event = i, s.cache.has(t)) o = s.cache.update(t, {
                    action: "click"
                }).request;
                else {
                    var f = s.request(t, s.timeout, s.onRequestError.bind(s, n), s.cache, s.headers);
                    f.then(function(r) {
                        r.url.href !== t && s.history.add(r.url.href, n, "replace");
                    }), o = s.cache.set(t, f, "click", "pending").request;
                }
                var c = function() {
                    if (s.transitions.shouldWait) return Promise.resolve(g(o, s.data)).then(function() {});
                }();
                return Promise.resolve(c && c.then ? c.then(u) : u());
            } catch (t) {
                return Promise.reject(t);
            }
        }, i.onRequestError = function(t) {
            this.transitions.isRunning = !1;
            var n = [].slice.call(arguments, 1), r = n[0], i = n[1], e = this.cache.getAction(r);
            return this.cache.delete(r), this.B && !1 === this.B(t, e, r, i) || "click" === e && this.force(r), !1;
        }, i.prefetch = function(t) {
            var n = this;
            t = this.url.getAbsoluteHref(t), this.cache.has(t) || this.cache.set(t, this.request(t, this.timeout, this.onRequestError.bind(this, "barba"), this.cache, this.headers).catch(function(t) {
                n.logger.error(t);
            }), "prefetch", "pending");
        }, i.G = function() {
            !0 !== this.prefetchIgnore && (document.addEventListener("mouseover", this.U), document.addEventListener("touchstart", this.U)), document.addEventListener("click", this.$), window.addEventListener("popstate", this.X);
        }, i.J = function() {
            !0 !== this.prefetchIgnore && (document.removeEventListener("mouseover", this.U), document.removeEventListener("touchstart", this.U)), document.removeEventListener("click", this.$), window.removeEventListener("popstate", this.X);
        }, i.U = function(t) {
            var n = this, r = this.W(t);
            if (r) {
                var i = this.url.getAbsoluteHref(this.dom.getHref(r));
                this.prevent.checkHref(i) || this.cache.has(i) || this.cache.set(i, this.request(i, this.timeout, this.onRequestError.bind(this, r), this.cache, this.headers).catch(function(t) {
                    n.logger.error(t);
                }), "enter", "pending");
            }
        }, i.$ = function(t) {
            var n = this.W(t);
            if (n) {
                if (this.transitions.isRunning && this.preventRunning) return t.preventDefault(), void t.stopPropagation();
                this.F = t, this.go(this.dom.getHref(n), n, t);
            }
        }, i.X = function(t) {
            this.go(this.url.getHref(), "popstate", t);
        }, i.W = function(t) {
            for(var n = t.target; n && !this.dom.getHref(n);)n = n.parentNode;
            if (n && !this.prevent.checkLink(n, t, this.dom.getHref(n))) return n;
        }, i.I = function() {
            var t = this.url.getHref(), n = {
                container: this.dom.getContainer(),
                html: this.dom.getHtml(),
                namespace: this.dom.getNamespace(),
                url: r({
                    href: t
                }, this.url.parse(t))
            };
            this.D = {
                current: n,
                event: void 0,
                next: r({}, this.schemaPage),
                trigger: void 0
            }, this.hooks.do("reset", this.data);
        }, n(t, [
            {
                key: "data",
                get: function() {
                    return this.D;
                }
            },
            {
                key: "wrapper",
                get: function() {
                    return this.q;
                }
            }
        ]), t;
    }();
    return new nt;
});



var $4AGbv = parcelRequire("4AGbv");

var $iNA1s = parcelRequire("iNA1s");
/*!
 * matrix 3.14.2
 * https://gsap.com
 *
 * Copyright 2008-2025, GreenSock. All rights reserved.
 * Subject to the terms at https://gsap.com/standard-license
 * @author: Jack Doyle, jack@greensock.com
*/ /* eslint-disable */ var $e1498ade04c27c48$var$_doc, $e1498ade04c27c48$var$_win, $e1498ade04c27c48$var$_docElement, $e1498ade04c27c48$var$_body, $e1498ade04c27c48$var$_divContainer, $e1498ade04c27c48$var$_svgContainer, $e1498ade04c27c48$var$_identityMatrix, $e1498ade04c27c48$var$_gEl, $e1498ade04c27c48$var$_transformProp = "transform", $e1498ade04c27c48$var$_transformOriginProp = $e1498ade04c27c48$var$_transformProp + "Origin", $e1498ade04c27c48$var$_hasOffsetBug, $e1498ade04c27c48$export$33c547c3e20d49b1 = function _setDoc(element) {
    var doc = element.ownerDocument || element;
    if (!($e1498ade04c27c48$var$_transformProp in element.style) && "msTransform" in element.style) {
        //to improve compatibility with old Microsoft browsers
        $e1498ade04c27c48$var$_transformProp = "msTransform";
        $e1498ade04c27c48$var$_transformOriginProp = $e1498ade04c27c48$var$_transformProp + "Origin";
    }
    while(doc.parentNode && (doc = doc.parentNode));
    $e1498ade04c27c48$var$_win = window;
    $e1498ade04c27c48$var$_identityMatrix = new $e1498ade04c27c48$export$26e6ecd136a15474();
    if (doc) {
        $e1498ade04c27c48$var$_doc = doc;
        $e1498ade04c27c48$var$_docElement = doc.documentElement;
        $e1498ade04c27c48$var$_body = doc.body;
        $e1498ade04c27c48$var$_gEl = $e1498ade04c27c48$var$_doc.createElementNS("http://www.w3.org/2000/svg", "g"); // prevent any existing CSS from transforming it
        $e1498ade04c27c48$var$_gEl.style.transform = "none"; // now test for the offset reporting bug. Use feature detection instead of browser sniffing to make things more bulletproof and future-proof. Hopefully Safari will fix their bug soon.
        var d1 = doc.createElement("div"), d2 = doc.createElement("div"), root = doc && (doc.body || doc.firstElementChild);
        if (root && root.appendChild) {
            root.appendChild(d1);
            d1.appendChild(d2);
            d1.style.position = "static";
            d1.style.transform = "translate3d(0,0,1px)";
            $e1498ade04c27c48$var$_hasOffsetBug = d2.offsetParent !== d1;
            root.removeChild(d1);
        }
    }
    return doc;
}, $e1498ade04c27c48$var$_forceNonZeroScale = function _forceNonZeroScale(e) {
    // walks up the element's ancestors and finds any that had their scale set to 0 via GSAP, and changes them to 0.0001 to ensure that measurements work. Firefox has a bug that causes it to incorrectly report getBoundingClientRect() when scale is 0.
    var a, cache;
    while(e && e !== $e1498ade04c27c48$var$_body){
        cache = e._gsap;
        cache && cache.uncache && cache.get(e, "x"); // force re-parsing of transforms if necessary
        if (cache && !cache.scaleX && !cache.scaleY && cache.renderTransform) {
            cache.scaleX = cache.scaleY = 1e-4;
            cache.renderTransform(1, cache);
            a ? a.push(cache) : a = [
                cache
            ];
        }
        e = e.parentNode;
    }
    return a;
}, // possible future addition: pass an element to _forceDisplay() and it'll walk up all its ancestors and make sure anything with display: none is set to display: block, and if there's no parentNode, it'll add it to the body. It returns an Array that you can then feed to _revertDisplay() to have it revert all the changes it made.
// _forceDisplay = e => {
// 	let a = [],
// 		parent;
// 	while (e && e !== _body) {
// 		parent = e.parentNode;
// 		(_win.getComputedStyle(e).display === "none" || !parent) && a.push(e, e.style.display, parent) && (e.style.display = "block");
// 		parent || _body.appendChild(e);
// 		e = parent;
// 	}
// 	return a;
// },
// _revertDisplay = a => {
// 	for (let i = 0; i < a.length; i+=3) {
// 		a[i+1] ? (a[i].style.display = a[i+1]) : a[i].style.removeProperty("display");
// 		a[i+2] || a[i].parentNode.removeChild(a[i]);
// 	}
// },
$e1498ade04c27c48$var$_svgTemps = [], //we create 3 elements for SVG, and 3 for other DOM elements and cache them for performance reasons. They get nested in _divContainer and _svgContainer so that just one element is added to the DOM on each successive attempt. Again, performance is key.
$e1498ade04c27c48$var$_divTemps = [], $e1498ade04c27c48$export$ffd2ae2432b6e61c = function _getDocScrollTop() {
    return $e1498ade04c27c48$var$_win.pageYOffset || $e1498ade04c27c48$var$_doc.scrollTop || $e1498ade04c27c48$var$_docElement.scrollTop || $e1498ade04c27c48$var$_body.scrollTop || 0;
}, $e1498ade04c27c48$export$cf8963d945186253 = function _getDocScrollLeft() {
    return $e1498ade04c27c48$var$_win.pageXOffset || $e1498ade04c27c48$var$_doc.scrollLeft || $e1498ade04c27c48$var$_docElement.scrollLeft || $e1498ade04c27c48$var$_body.scrollLeft || 0;
}, $e1498ade04c27c48$var$_svgOwner = function _svgOwner(element) {
    return element.ownerSVGElement || ((element.tagName + "").toLowerCase() === "svg" ? element : null);
}, $e1498ade04c27c48$export$72052b0a226e838 = function _isFixed(element) {
    if ($e1498ade04c27c48$var$_win.getComputedStyle(element).position === "fixed") return true;
    element = element.parentNode;
    if (element && element.nodeType === 1) // avoid document fragments which will throw an error.
    return _isFixed(element);
}, $e1498ade04c27c48$var$_createSibling = function _createSibling(element, i) {
    if (element.parentNode && ($e1498ade04c27c48$var$_doc || $e1498ade04c27c48$export$33c547c3e20d49b1(element))) {
        var svg = $e1498ade04c27c48$var$_svgOwner(element), ns = svg ? svg.getAttribute("xmlns") || "http://www.w3.org/2000/svg" : "http://www.w3.org/1999/xhtml", type = svg ? i ? "rect" : "g" : "div", x = i !== 2 ? 0 : 100, y = i === 3 ? 100 : 0, css = {
            position: "absolute",
            display: "block",
            pointerEvents: "none",
            margin: "0",
            padding: "0"
        }, e = $e1498ade04c27c48$var$_doc.createElementNS ? $e1498ade04c27c48$var$_doc.createElementNS(ns.replace(/^https/, "http"), type) : $e1498ade04c27c48$var$_doc.createElement(type);
        if (i) {
            if (!svg) {
                if (!$e1498ade04c27c48$var$_divContainer) {
                    $e1498ade04c27c48$var$_divContainer = _createSibling(element);
                    Object.assign($e1498ade04c27c48$var$_divContainer.style, css);
                }
                Object.assign(e.style, css, {
                    width: "0.1px",
                    height: "0.1px",
                    top: y + "px",
                    left: x + "px"
                });
                $e1498ade04c27c48$var$_divContainer.appendChild(e);
            } else {
                $e1498ade04c27c48$var$_svgContainer || ($e1498ade04c27c48$var$_svgContainer = _createSibling(element));
                e.setAttribute("width", 0.01);
                e.setAttribute("height", 0.01);
                e.setAttribute("transform", "translate(" + x + "," + y + ")");
                e.setAttribute("fill", "transparent");
                $e1498ade04c27c48$var$_svgContainer.appendChild(e);
            }
        }
        return e;
    }
    throw "Need document and parent.";
}, $e1498ade04c27c48$var$_consolidate = function _consolidate(m) {
    // replaces SVGTransformList.consolidate() because a bug in Firefox causes it to break pointer events. See https://gsap.com/forums/topic/23248-touch-is-not-working-on-draggable-in-firefox-windows-v324/?tab=comments#comment-109800
    var c = new $e1498ade04c27c48$export$26e6ecd136a15474(), i = 0;
    for(; i < m.numberOfItems; i++)c.multiply(m.getItem(i).matrix);
    return c;
}, $e1498ade04c27c48$export$a2b87f76ca5ccbd0 = function _getCTM(svg) {
    var m = svg.getCTM(), transform;
    if (!m) {
        // Firefox returns null for getCTM() on root <svg> elements, so this is a workaround using a <g> that we temporarily append.
        transform = svg.style[$e1498ade04c27c48$var$_transformProp];
        svg.style[$e1498ade04c27c48$var$_transformProp] = "none"; // a bug in Firefox causes css transforms to contaminate the getCTM()
        svg.appendChild($e1498ade04c27c48$var$_gEl);
        m = $e1498ade04c27c48$var$_gEl.getCTM();
        svg.removeChild($e1498ade04c27c48$var$_gEl);
        transform ? svg.style[$e1498ade04c27c48$var$_transformProp] = transform : svg.style.removeProperty($e1498ade04c27c48$var$_transformProp.replace(/([A-Z])/g, "-$1").toLowerCase());
    }
    return m || $e1498ade04c27c48$var$_identityMatrix.clone(); // Firefox will still return null if the <svg> has a width/height of 0 in the browser.
}, $e1498ade04c27c48$var$_placeSiblings = function _placeSiblings(element, adjustGOffset) {
    var svg = $e1498ade04c27c48$var$_svgOwner(element), isRootSVG = element === svg, siblings = svg ? $e1498ade04c27c48$var$_svgTemps : $e1498ade04c27c48$var$_divTemps, parent = element.parentNode, appendToEl = parent && !svg && parent.shadowRoot && parent.shadowRoot.appendChild ? parent.shadowRoot : parent, container, m, b, x, y, cs;
    if (element === $e1498ade04c27c48$var$_win) return element;
    siblings.length || siblings.push($e1498ade04c27c48$var$_createSibling(element, 1), $e1498ade04c27c48$var$_createSibling(element, 2), $e1498ade04c27c48$var$_createSibling(element, 3));
    container = svg ? $e1498ade04c27c48$var$_svgContainer : $e1498ade04c27c48$var$_divContainer;
    if (svg) {
        if (isRootSVG) {
            b = $e1498ade04c27c48$export$a2b87f76ca5ccbd0(element);
            x = -b.e / b.a;
            y = -b.f / b.d;
            m = $e1498ade04c27c48$var$_identityMatrix;
        } else if (element.getBBox) {
            b = element.getBBox();
            m = element.transform ? element.transform.baseVal : {}; // IE11 doesn't follow the spec.
            m = !m.numberOfItems ? $e1498ade04c27c48$var$_identityMatrix : m.numberOfItems > 1 ? $e1498ade04c27c48$var$_consolidate(m) : m.getItem(0).matrix; // don't call m.consolidate().matrix because a bug in Firefox makes pointer events not work when consolidate() is called on the same tick as getBoundingClientRect()! See https://gsap.com/forums/topic/23248-touch-is-not-working-on-draggable-in-firefox-windows-v324/?tab=comments#comment-109800
            x = m.a * b.x + m.c * b.y;
            y = m.b * b.x + m.d * b.y;
        } else {
            // may be a <mask> which has no getBBox() so just use defaults instead of throwing errors.
            m = new $e1498ade04c27c48$export$26e6ecd136a15474();
            x = y = 0;
        }
        if (adjustGOffset && element.tagName.toLowerCase() === "g") x = y = 0;
        (isRootSVG || !element.getBoundingClientRect().width ? svg : parent).appendChild(container); // check getBoundingClientRect().width because things inside a <mask>, for example, may return 0 in which case we need to move the element to the root SVG to properly measure things. An alternative would be to walk up the DOM and see if any ancestor is a nodeName of "mask" and if so, set parent to svg.
        container.setAttribute("transform", "matrix(" + m.a + "," + m.b + "," + m.c + "," + m.d + "," + (m.e + x) + "," + (m.f + y) + ")");
    } else {
        x = y = 0;
        if ($e1498ade04c27c48$var$_hasOffsetBug) {
            // some browsers (like Safari) have a bug that causes them to misreport offset values. When an ancestor element has a transform applied, it's supposed to treat it as if it's position: relative (new context). Safari botches this, so we need to find the closest ancestor (between the element and its offsetParent) that has a transform applied and if one is found, grab its offsetTop/Left and subtract them to compensate.
            m = element.offsetParent;
            b = element;
            while(b && (b = b.parentNode) && b !== m && b.parentNode)if (($e1498ade04c27c48$var$_win.getComputedStyle(b)[$e1498ade04c27c48$var$_transformProp] + "").length > 4) {
                x = b.offsetLeft;
                y = b.offsetTop;
                b = 0;
            }
        }
        cs = $e1498ade04c27c48$var$_win.getComputedStyle(element);
        if (cs.position !== "absolute" && cs.position !== "fixed") {
            m = element.offsetParent;
            while(parent && parent !== m){
                // if there's an ancestor element between the element and its offsetParent that's scrolled, we must factor that in.
                x += parent.scrollLeft || 0;
                y += parent.scrollTop || 0;
                parent = parent.parentNode;
            }
        }
        b = container.style;
        b.top = element.offsetTop - y + "px";
        b.left = element.offsetLeft - x + "px";
        b[$e1498ade04c27c48$var$_transformProp] = cs[$e1498ade04c27c48$var$_transformProp];
        b[$e1498ade04c27c48$var$_transformOriginProp] = cs[$e1498ade04c27c48$var$_transformOriginProp]; // b.border = m.border;
        // b.borderLeftStyle = m.borderLeftStyle;
        // b.borderTopStyle = m.borderTopStyle;
        // b.borderLeftWidth = m.borderLeftWidth;
        // b.borderTopWidth = m.borderTopWidth;
        b.position = cs.position === "fixed" ? "fixed" : "absolute";
        appendToEl.appendChild(container);
    }
    return container;
}, $e1498ade04c27c48$var$_setMatrix = function _setMatrix(m, a, b, c, d, e, f) {
    m.a = a;
    m.b = b;
    m.c = c;
    m.d = d;
    m.e = e;
    m.f = f;
    return m;
};
var $e1498ade04c27c48$export$26e6ecd136a15474 = /*#__PURE__*/ function() {
    function Matrix2D(a, b, c, d, e, f) {
        if (a === void 0) a = 1;
        if (b === void 0) b = 0;
        if (c === void 0) c = 0;
        if (d === void 0) d = 1;
        if (e === void 0) e = 0;
        if (f === void 0) f = 0;
        $e1498ade04c27c48$var$_setMatrix(this, a, b, c, d, e, f);
    }
    var _proto = Matrix2D.prototype;
    _proto.inverse = function inverse() {
        var a = this.a, b = this.b, c = this.c, d = this.d, e = this.e, f = this.f, determinant = a * d - b * c || 1e-10;
        return $e1498ade04c27c48$var$_setMatrix(this, d / determinant, -b / determinant, -c / determinant, a / determinant, (c * f - d * e) / determinant, -(a * f - b * e) / determinant);
    };
    _proto.multiply = function multiply(matrix) {
        var a = this.a, b = this.b, c = this.c, d = this.d, e = this.e, f = this.f, a2 = matrix.a, b2 = matrix.c, c2 = matrix.b, d2 = matrix.d, e2 = matrix.e, f2 = matrix.f;
        return $e1498ade04c27c48$var$_setMatrix(this, a2 * a + c2 * c, a2 * b + c2 * d, b2 * a + d2 * c, b2 * b + d2 * d, e + e2 * a + f2 * c, f + e2 * b + f2 * d);
    };
    _proto.clone = function clone() {
        return new Matrix2D(this.a, this.b, this.c, this.d, this.e, this.f);
    };
    _proto.equals = function equals(matrix) {
        var a = this.a, b = this.b, c = this.c, d = this.d, e = this.e, f = this.f;
        return a === matrix.a && b === matrix.b && c === matrix.c && d === matrix.d && e === matrix.e && f === matrix.f;
    };
    _proto.apply = function apply(point, decoratee) {
        if (decoratee === void 0) decoratee = {};
        var x = point.x, y = point.y, a = this.a, b = this.b, c = this.c, d = this.d, e = this.e, f = this.f;
        decoratee.x = x * a + y * c + e || 0;
        decoratee.y = x * b + y * d + f || 0;
        return decoratee;
    };
    return Matrix2D;
}(); // Feed in an element and it'll return a 2D matrix (optionally inverted) so that you can translate between coordinate spaces.
function $e1498ade04c27c48$export$91a495f99cf781b7(element, inverse, adjustGOffset, includeScrollInFixed) {
    // adjustGOffset is typically used only when grabbing an element's PARENT's global matrix, and it ignores the x/y offset of any SVG <g> elements because they behave in a special way.
    if (!element || !element.parentNode || ($e1498ade04c27c48$var$_doc || $e1498ade04c27c48$export$33c547c3e20d49b1(element)).documentElement === element) return new $e1498ade04c27c48$export$26e6ecd136a15474();
    var zeroScales = $e1498ade04c27c48$var$_forceNonZeroScale(element), svg = $e1498ade04c27c48$var$_svgOwner(element), temps = svg ? $e1498ade04c27c48$var$_svgTemps : $e1498ade04c27c48$var$_divTemps, container = $e1498ade04c27c48$var$_placeSiblings(element, adjustGOffset), b1 = temps[0].getBoundingClientRect(), b2 = temps[1].getBoundingClientRect(), b3 = temps[2].getBoundingClientRect(), parent = container.parentNode, isFixed = !includeScrollInFixed && $e1498ade04c27c48$export$72052b0a226e838(element), m = new $e1498ade04c27c48$export$26e6ecd136a15474((b2.left - b1.left) / 100, (b2.top - b1.top) / 100, (b3.left - b1.left) / 100, (b3.top - b1.top) / 100, b1.left + (isFixed ? 0 : $e1498ade04c27c48$export$cf8963d945186253()), b1.top + (isFixed ? 0 : $e1498ade04c27c48$export$ffd2ae2432b6e61c()));
    parent.removeChild(container);
    if (zeroScales) {
        b1 = zeroScales.length;
        while(b1--){
            b2 = zeroScales[b1];
            b2.scaleX = b2.scaleY = 0;
            b2.renderTransform(1, b2);
        }
    }
    return inverse ? m.inverse() : m;
}
 // export function getMatrix(element) {
 // 	_doc || _setDoc(element);
 // 	let m = (_win.getComputedStyle(element)[_transformProp] + "").substr(7).match(/[-.]*\d+[.e\-+]*\d*[e\-\+]*\d*/g),
 // 		is2D = m && m.length === 6;
 // 	return !m || m.length < 6 ? new Matrix2D() : new Matrix2D(+m[0], +m[1], +m[is2D ? 2 : 4], +m[is2D ? 3 : 5], +m[is2D ? 4 : 12], +m[is2D ? 5 : 13]);
 // }


function $5a019fe42b4630c1$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $5a019fe42b4630c1$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $5a019fe42b4630c1$var$gsap, $5a019fe42b4630c1$var$_win, $5a019fe42b4630c1$var$_doc, $5a019fe42b4630c1$var$_docElement, $5a019fe42b4630c1$var$_body, $5a019fe42b4630c1$var$_tempDiv, $5a019fe42b4630c1$var$_placeholderDiv, $5a019fe42b4630c1$var$_coreInitted, $5a019fe42b4630c1$var$_checkPrefix, $5a019fe42b4630c1$var$_toArray, $5a019fe42b4630c1$var$_supportsPassive, $5a019fe42b4630c1$var$_isTouchDevice, $5a019fe42b4630c1$var$_touchEventLookup, $5a019fe42b4630c1$var$_isMultiTouching, $5a019fe42b4630c1$var$_isAndroid, $5a019fe42b4630c1$var$InertiaPlugin, $5a019fe42b4630c1$var$_defaultCursor, $5a019fe42b4630c1$var$_supportsPointer, $5a019fe42b4630c1$var$_context, $5a019fe42b4630c1$var$_getStyleSaver, $5a019fe42b4630c1$var$_dragCount = 0, $5a019fe42b4630c1$var$_windowExists = function _windowExists() {
    return typeof window !== "undefined";
}, $5a019fe42b4630c1$var$_getGSAP = function _getGSAP() {
    return $5a019fe42b4630c1$var$gsap || $5a019fe42b4630c1$var$_windowExists() && ($5a019fe42b4630c1$var$gsap = window.gsap) && $5a019fe42b4630c1$var$gsap.registerPlugin && $5a019fe42b4630c1$var$gsap;
}, $5a019fe42b4630c1$var$_isFunction = function _isFunction(value) {
    return typeof value === "function";
}, $5a019fe42b4630c1$var$_isObject = function _isObject(value) {
    return typeof value === "object";
}, $5a019fe42b4630c1$var$_isUndefined = function _isUndefined(value) {
    return typeof value === "undefined";
}, $5a019fe42b4630c1$var$_emptyFunc = function _emptyFunc() {
    return false;
}, $5a019fe42b4630c1$var$_transformProp = "transform", $5a019fe42b4630c1$var$_transformOriginProp = "transformOrigin", $5a019fe42b4630c1$var$_round = function _round(value) {
    return Math.round(value * 10000) / 10000;
}, $5a019fe42b4630c1$var$_isArray = Array.isArray, $5a019fe42b4630c1$var$_createElement = function _createElement(type, ns) {
    var e = $5a019fe42b4630c1$var$_doc.createElementNS ? $5a019fe42b4630c1$var$_doc.createElementNS((ns || "http://www.w3.org/1999/xhtml").replace(/^https/, "http"), type) : $5a019fe42b4630c1$var$_doc.createElement(type); //some servers swap in https for http in the namespace which can break things, making "style" inaccessible.
    return e.style ? e : $5a019fe42b4630c1$var$_doc.createElement(type); //some environments won't allow access to the element's style when created with a namespace in which case we default to the standard createElement() to work around the issue. Also note that when GSAP is embedded directly inside an SVG file, createElement() won't allow access to the style object in Firefox (see https://gsap.com/forums/topic/20215-problem-using-tweenmax-in-standalone-self-containing-svg-file-err-cannot-set-property-csstext-of-undefined/).
}, $5a019fe42b4630c1$var$_RAD2DEG = 180 / Math.PI, $5a019fe42b4630c1$var$_bigNum = 1e20, $5a019fe42b4630c1$var$_identityMatrix = new (0, $e1498ade04c27c48$export$26e6ecd136a15474)(), $5a019fe42b4630c1$var$_getTime = Date.now || function() {
    return new Date().getTime();
}, $5a019fe42b4630c1$var$_renderQueue = [], $5a019fe42b4630c1$var$_lookup = {}, //when a Draggable is created, the target gets a unique _gsDragID property that allows gets associated with the Draggable instance for quick lookups in Draggable.get(). This avoids circular references that could cause gc problems.
$5a019fe42b4630c1$var$_lookupCount = 0, $5a019fe42b4630c1$var$_clickableTagExp = /^(?:a|input|textarea|button|select)$/i, $5a019fe42b4630c1$var$_lastDragTime = 0, $5a019fe42b4630c1$var$_temp1 = {}, // a simple object we reuse and populate (usually x/y properties) to conserve memory and improve performance.
$5a019fe42b4630c1$var$_windowProxy = {}, //memory/performance optimization - we reuse this object during autoScroll to store window-related bounds/offsets.
$5a019fe42b4630c1$var$_copy = function _copy(obj, factor) {
    var copy = {}, p;
    for(p in obj)copy[p] = factor ? obj[p] * factor : obj[p];
    return copy;
}, $5a019fe42b4630c1$var$_extend = function _extend(obj, defaults) {
    for(var p in defaults)if (!(p in obj)) obj[p] = defaults[p];
    return obj;
}, $5a019fe42b4630c1$var$_setTouchActionForAllDescendants = function _setTouchActionForAllDescendants(elements, value) {
    var i = elements.length, children;
    while(i--){
        value ? elements[i].style.touchAction = value : elements[i].style.removeProperty("touch-action");
        children = elements[i].children;
        children && children.length && _setTouchActionForAllDescendants(children, value);
    }
}, $5a019fe42b4630c1$var$_renderQueueTick = function _renderQueueTick() {
    return $5a019fe42b4630c1$var$_renderQueue.forEach(function(func) {
        return func();
    });
}, $5a019fe42b4630c1$var$_addToRenderQueue = function _addToRenderQueue(func) {
    $5a019fe42b4630c1$var$_renderQueue.push(func);
    if ($5a019fe42b4630c1$var$_renderQueue.length === 1) $5a019fe42b4630c1$var$gsap.ticker.add($5a019fe42b4630c1$var$_renderQueueTick);
}, $5a019fe42b4630c1$var$_renderQueueTimeout = function _renderQueueTimeout() {
    return !$5a019fe42b4630c1$var$_renderQueue.length && $5a019fe42b4630c1$var$gsap.ticker.remove($5a019fe42b4630c1$var$_renderQueueTick);
}, $5a019fe42b4630c1$var$_removeFromRenderQueue = function _removeFromRenderQueue(func) {
    var i = $5a019fe42b4630c1$var$_renderQueue.length;
    while(i--)if ($5a019fe42b4630c1$var$_renderQueue[i] === func) $5a019fe42b4630c1$var$_renderQueue.splice(i, 1);
    $5a019fe42b4630c1$var$gsap.to($5a019fe42b4630c1$var$_renderQueueTimeout, {
        overwrite: true,
        delay: 15,
        duration: 0,
        onComplete: $5a019fe42b4630c1$var$_renderQueueTimeout,
        data: "_draggable"
    }); //remove the "tick" listener only after the render queue is empty for 15 seconds (to improve performance). Adding/removing it constantly for every click/touch wouldn't deliver optimal speed, and we also don't want the ticker to keep calling the render method when things are idle for long periods of time (we want to improve battery life on mobile devices).
}, $5a019fe42b4630c1$var$_setDefaults = function _setDefaults(obj, defaults) {
    for(var p in defaults)if (!(p in obj)) obj[p] = defaults[p];
    return obj;
}, $5a019fe42b4630c1$var$_addListener = function _addListener(element, type, func, capture) {
    if (element.addEventListener) {
        var touchType = $5a019fe42b4630c1$var$_touchEventLookup[type];
        capture = capture || ($5a019fe42b4630c1$var$_supportsPassive ? {
            passive: false
        } : null);
        element.addEventListener(touchType || type, func, capture);
        touchType && type !== touchType && element.addEventListener(type, func, capture); //some browsers actually support both, so must we. But pointer events cover all.
    }
}, $5a019fe42b4630c1$var$_removeListener = function _removeListener(element, type, func, capture) {
    if (element.removeEventListener) {
        var touchType = $5a019fe42b4630c1$var$_touchEventLookup[type];
        element.removeEventListener(touchType || type, func, capture);
        touchType && type !== touchType && element.removeEventListener(type, func, capture);
    }
}, $5a019fe42b4630c1$var$_preventDefault = function _preventDefault(event) {
    event.preventDefault && event.preventDefault();
    event.preventManipulation && event.preventManipulation(); //for some Microsoft browsers
}, $5a019fe42b4630c1$var$_hasTouchID = function _hasTouchID(list, ID) {
    var i = list.length;
    while(i--){
        if (list[i].identifier === ID) return true;
    }
}, $5a019fe42b4630c1$var$_onMultiTouchDocumentEnd = function _onMultiTouchDocumentEnd(event) {
    $5a019fe42b4630c1$var$_isMultiTouching = event.touches && $5a019fe42b4630c1$var$_dragCount < event.touches.length;
    $5a019fe42b4630c1$var$_removeListener(event.target, "touchend", _onMultiTouchDocumentEnd);
}, $5a019fe42b4630c1$var$_onMultiTouchDocument = function _onMultiTouchDocument(event) {
    $5a019fe42b4630c1$var$_isMultiTouching = event.touches && $5a019fe42b4630c1$var$_dragCount < event.touches.length;
    $5a019fe42b4630c1$var$_addListener(event.target, "touchend", $5a019fe42b4630c1$var$_onMultiTouchDocumentEnd);
}, $5a019fe42b4630c1$var$_getDocScrollTop = function _getDocScrollTop(doc) {
    return $5a019fe42b4630c1$var$_win.pageYOffset || doc.scrollTop || doc.documentElement.scrollTop || doc.body.scrollTop || 0;
}, $5a019fe42b4630c1$var$_getDocScrollLeft = function _getDocScrollLeft(doc) {
    return $5a019fe42b4630c1$var$_win.pageXOffset || doc.scrollLeft || doc.documentElement.scrollLeft || doc.body.scrollLeft || 0;
}, $5a019fe42b4630c1$var$_addScrollListener = function _addScrollListener(e, callback) {
    $5a019fe42b4630c1$var$_addListener(e, "scroll", callback);
    if (!$5a019fe42b4630c1$var$_isRoot(e.parentNode)) _addScrollListener(e.parentNode, callback);
}, $5a019fe42b4630c1$var$_removeScrollListener = function _removeScrollListener(e, callback) {
    $5a019fe42b4630c1$var$_removeListener(e, "scroll", callback);
    if (!$5a019fe42b4630c1$var$_isRoot(e.parentNode)) _removeScrollListener(e.parentNode, callback);
}, $5a019fe42b4630c1$var$_isRoot = function _isRoot(e) {
    return !!(!e || e === $5a019fe42b4630c1$var$_docElement || e.nodeType === 9 || e === $5a019fe42b4630c1$var$_doc.body || e === $5a019fe42b4630c1$var$_win || !e.nodeType || !e.parentNode);
}, $5a019fe42b4630c1$var$_getMaxScroll = function _getMaxScroll(element, axis) {
    var dim = axis === "x" ? "Width" : "Height", scroll = "scroll" + dim, client = "client" + dim;
    return Math.max(0, $5a019fe42b4630c1$var$_isRoot(element) ? Math.max($5a019fe42b4630c1$var$_docElement[scroll], $5a019fe42b4630c1$var$_body[scroll]) - ($5a019fe42b4630c1$var$_win["inner" + dim] || $5a019fe42b4630c1$var$_docElement[client] || $5a019fe42b4630c1$var$_body[client]) : element[scroll] - element[client]);
}, $5a019fe42b4630c1$var$_recordMaxScrolls = function _recordMaxScrolls(e, skipCurrent) {
    //records _gsMaxScrollX and _gsMaxScrollY properties for the element and all ancestors up the chain so that we can cap it, otherwise dragging beyond the edges with autoScroll on can endlessly scroll.
    var x = $5a019fe42b4630c1$var$_getMaxScroll(e, "x"), y = $5a019fe42b4630c1$var$_getMaxScroll(e, "y");
    if ($5a019fe42b4630c1$var$_isRoot(e)) e = $5a019fe42b4630c1$var$_windowProxy;
    else _recordMaxScrolls(e.parentNode, skipCurrent);
    e._gsMaxScrollX = x;
    e._gsMaxScrollY = y;
    if (!skipCurrent) {
        e._gsScrollX = e.scrollLeft || 0;
        e._gsScrollY = e.scrollTop || 0;
    }
}, $5a019fe42b4630c1$var$_setStyle = function _setStyle(element, property, value) {
    var style = element.style;
    if (!style) return;
    if ($5a019fe42b4630c1$var$_isUndefined(style[property])) property = $5a019fe42b4630c1$var$_checkPrefix(property, element) || property;
    if (value == null) style.removeProperty && style.removeProperty(property.replace(/([A-Z])/g, "-$1").toLowerCase());
    else style[property] = value;
}, $5a019fe42b4630c1$var$_getComputedStyle = function _getComputedStyle(element) {
    return $5a019fe42b4630c1$var$_win.getComputedStyle(element instanceof Element ? element : element.host || (element.parentNode || {}).host || element);
}, //the "host" stuff helps to accommodate ShadowDom objects.
$5a019fe42b4630c1$var$_tempRect = {}, //reuse to reduce garbage collection tasks
$5a019fe42b4630c1$var$_parseRect = function _parseRect(e) {
    //accepts a DOM element, a mouse event, or a rectangle object and returns the corresponding rectangle with left, right, width, height, top, and bottom properties
    if (e === $5a019fe42b4630c1$var$_win) {
        $5a019fe42b4630c1$var$_tempRect.left = $5a019fe42b4630c1$var$_tempRect.top = 0;
        $5a019fe42b4630c1$var$_tempRect.width = $5a019fe42b4630c1$var$_tempRect.right = $5a019fe42b4630c1$var$_docElement.clientWidth || e.innerWidth || $5a019fe42b4630c1$var$_body.clientWidth || 0;
        $5a019fe42b4630c1$var$_tempRect.height = $5a019fe42b4630c1$var$_tempRect.bottom = (e.innerHeight || 0) - 20 < $5a019fe42b4630c1$var$_docElement.clientHeight ? $5a019fe42b4630c1$var$_docElement.clientHeight : e.innerHeight || $5a019fe42b4630c1$var$_body.clientHeight || 0;
        return $5a019fe42b4630c1$var$_tempRect;
    }
    var doc = e.ownerDocument || $5a019fe42b4630c1$var$_doc, r = !$5a019fe42b4630c1$var$_isUndefined(e.pageX) ? {
        left: e.pageX - $5a019fe42b4630c1$var$_getDocScrollLeft(doc),
        top: e.pageY - $5a019fe42b4630c1$var$_getDocScrollTop(doc),
        right: e.pageX - $5a019fe42b4630c1$var$_getDocScrollLeft(doc) + 1,
        bottom: e.pageY - $5a019fe42b4630c1$var$_getDocScrollTop(doc) + 1
    } : !e.nodeType && !$5a019fe42b4630c1$var$_isUndefined(e.left) && !$5a019fe42b4630c1$var$_isUndefined(e.top) ? e : $5a019fe42b4630c1$var$_toArray(e)[0].getBoundingClientRect();
    if ($5a019fe42b4630c1$var$_isUndefined(r.right) && !$5a019fe42b4630c1$var$_isUndefined(r.width)) {
        r.right = r.left + r.width;
        r.bottom = r.top + r.height;
    } else if ($5a019fe42b4630c1$var$_isUndefined(r.width)) //some browsers don't include width and height properties. We can't just set them directly on r because some browsers throw errors, so create a new generic object.
    r = {
        width: r.right - r.left,
        height: r.bottom - r.top,
        right: r.right,
        left: r.left,
        bottom: r.bottom,
        top: r.top
    };
    return r;
}, $5a019fe42b4630c1$var$_dispatchEvent = function _dispatchEvent(target, type, callbackName) {
    var vars = target.vars, callback = vars[callbackName], listeners = target._listeners[type], result;
    if ($5a019fe42b4630c1$var$_isFunction(callback)) result = callback.apply(vars.callbackScope || target, vars[callbackName + "Params"] || [
        target.pointerEvent
    ]);
    if (listeners && target.dispatchEvent(type) === false) result = false;
    return result;
}, $5a019fe42b4630c1$var$_getBounds = function _getBounds(target, context) {
    //accepts any of the following: a DOM element, jQuery object, selector text, or an object defining bounds as {top, left, width, height} or {minX, maxX, minY, maxY}. Returns an object with left, top, width, and height properties.
    var e = $5a019fe42b4630c1$var$_toArray(target)[0], top, left, offset;
    if (!e.nodeType && e !== $5a019fe42b4630c1$var$_win) {
        if (!$5a019fe42b4630c1$var$_isUndefined(target.left)) {
            offset = {
                x: 0,
                y: 0
            }; //_getOffsetTransformOrigin(context); //the bounds should be relative to the origin
            return {
                left: target.left - offset.x,
                top: target.top - offset.y,
                width: target.width,
                height: target.height
            };
        }
        left = target.min || target.minX || target.minRotation || 0;
        top = target.min || target.minY || 0;
        return {
            left: left,
            top: top,
            width: (target.max || target.maxX || target.maxRotation || 0) - left,
            height: (target.max || target.maxY || 0) - top
        };
    }
    return $5a019fe42b4630c1$var$_getElementBounds(e, context);
}, $5a019fe42b4630c1$var$_point1 = {}, //we reuse to minimize garbage collection tasks.
$5a019fe42b4630c1$var$_getElementBounds = function _getElementBounds(element, context) {
    context = $5a019fe42b4630c1$var$_toArray(context)[0];
    var isSVG = element.getBBox && element.ownerSVGElement, doc = element.ownerDocument || $5a019fe42b4630c1$var$_doc, left, right, top, bottom, matrix, p1, p2, p3, p4, bbox, width, height, cs;
    if (element === $5a019fe42b4630c1$var$_win) {
        top = $5a019fe42b4630c1$var$_getDocScrollTop(doc);
        left = $5a019fe42b4630c1$var$_getDocScrollLeft(doc);
        right = left + (doc.documentElement.clientWidth || element.innerWidth || doc.body.clientWidth || 0);
        bottom = top + ((element.innerHeight || 0) - 20 < doc.documentElement.clientHeight ? doc.documentElement.clientHeight : element.innerHeight || doc.body.clientHeight || 0); //some browsers (like Firefox) ignore absolutely positioned elements, and collapse the height of the documentElement, so it could be 8px, for example, if you have just an absolutely positioned div. In that case, we use the innerHeight to resolve this.
    } else if (context === $5a019fe42b4630c1$var$_win || $5a019fe42b4630c1$var$_isUndefined(context)) return element.getBoundingClientRect();
    else {
        left = top = 0;
        if (isSVG) {
            bbox = element.getBBox();
            width = bbox.width;
            height = bbox.height;
        } else {
            if (element.viewBox && (bbox = element.viewBox.baseVal)) {
                left = bbox.x || 0;
                top = bbox.y || 0;
                width = bbox.width;
                height = bbox.height;
            }
            if (!width) {
                cs = $5a019fe42b4630c1$var$_getComputedStyle(element);
                bbox = cs.boxSizing === "border-box";
                width = (parseFloat(cs.width) || element.clientWidth || 0) + (bbox ? 0 : parseFloat(cs.borderLeftWidth) + parseFloat(cs.borderRightWidth));
                height = (parseFloat(cs.height) || element.clientHeight || 0) + (bbox ? 0 : parseFloat(cs.borderTopWidth) + parseFloat(cs.borderBottomWidth));
            }
        }
        right = width;
        bottom = height;
    }
    if (element === context) return {
        left: left,
        top: top,
        width: right - left,
        height: bottom - top
    };
    matrix = (0, $e1498ade04c27c48$export$91a495f99cf781b7)(context, true).multiply((0, $e1498ade04c27c48$export$91a495f99cf781b7)(element));
    p1 = matrix.apply({
        x: left,
        y: top
    });
    p2 = matrix.apply({
        x: right,
        y: top
    });
    p3 = matrix.apply({
        x: right,
        y: bottom
    });
    p4 = matrix.apply({
        x: left,
        y: bottom
    });
    left = Math.min(p1.x, p2.x, p3.x, p4.x);
    top = Math.min(p1.y, p2.y, p3.y, p4.y);
    return {
        left: left,
        top: top,
        width: Math.max(p1.x, p2.x, p3.x, p4.x) - left,
        height: Math.max(p1.y, p2.y, p3.y, p4.y) - top
    };
}, $5a019fe42b4630c1$var$_parseInertia = function _parseInertia(draggable, snap, max, min, factor, forceZeroVelocity) {
    var vars = {}, a, i, l;
    if (snap) {
        if (factor !== 1 && snap instanceof Array) {
            //some data must be altered to make sense, like if the user passes in an array of rotational values in degrees, we must convert it to radians. Or for scrollLeft and scrollTop, we invert the values.
            vars.end = a = [];
            l = snap.length;
            if ($5a019fe42b4630c1$var$_isObject(snap[0])) //if the array is populated with objects, like points ({x:100, y:200}), make copies before multiplying by the factor, otherwise we'll mess up the originals and the user may reuse it elsewhere.
            for(i = 0; i < l; i++)a[i] = $5a019fe42b4630c1$var$_copy(snap[i], factor);
            else for(i = 0; i < l; i++)a[i] = snap[i] * factor;
            max += 1.1; //allow 1.1 pixels of wiggle room when snapping in order to work around some browser inconsistencies in the way bounds are reported which can make them roughly a pixel off. For example, if "snap:[-$('#menu').width(), 0]" was defined and #menu had a wrapper that was used as the bounds, some browsers would be one pixel off, making the minimum -752 for example when snap was [-753,0], thus instead of snapping to -753, it would snap to 0 since -753 was below the minimum.
            min -= 1.1;
        } else if ($5a019fe42b4630c1$var$_isFunction(snap)) vars.end = function(value) {
            var result = snap.call(draggable, value), copy, p;
            if (factor !== 1) {
                if ($5a019fe42b4630c1$var$_isObject(result)) {
                    copy = {};
                    for(p in result)copy[p] = result[p] * factor;
                    result = copy;
                } else result *= factor;
            }
            return result; //we need to ensure that we can scope the function call to the Draggable instance itself so that users can access important values like maxX, minX, maxY, minY, x, and y from within that function.
        };
        else vars.end = snap;
    }
    if (max || max === 0) vars.max = max;
    if (min || min === 0) vars.min = min;
    if (forceZeroVelocity) vars.velocity = 0;
    return vars;
}, $5a019fe42b4630c1$var$_isClickable = function _isClickable(element) {
    //sometimes it's convenient to mark an element as clickable by adding a data-clickable="true" attribute (in which case we won't preventDefault() the mouse/touch event). This method checks if the element is an <a>, <input>, or <button> or has the data-clickable or contentEditable attribute set to true (or any of its parent elements).
    var data;
    return !element || !element.getAttribute || element === $5a019fe42b4630c1$var$_body ? false : (data = element.getAttribute("data-clickable")) === "true" || data !== "false" && ($5a019fe42b4630c1$var$_clickableTagExp.test(element.nodeName + "") || element.getAttribute("contentEditable") === "true") ? true : _isClickable(element.parentNode);
}, $5a019fe42b4630c1$var$_setSelectable = function _setSelectable(elements, selectable) {
    var i = elements.length, e;
    while(i--){
        e = elements[i];
        e.ondragstart = e.onselectstart = selectable ? null : $5a019fe42b4630c1$var$_emptyFunc;
        $5a019fe42b4630c1$var$gsap.set(e, {
            lazy: true,
            userSelect: selectable ? "text" : "none"
        });
    }
}, $5a019fe42b4630c1$var$_isFixed = function _isFixed(element) {
    if ($5a019fe42b4630c1$var$_getComputedStyle(element).position === "fixed") return true;
    element = element.parentNode;
    if (element && element.nodeType === 1) // avoid document fragments which will throw an error.
    return _isFixed(element);
}, $5a019fe42b4630c1$var$_supports3D, $5a019fe42b4630c1$var$_addPaddingBR, //The ScrollProxy class wraps an element's contents into another div (we call it "content") that we either add padding when necessary or apply a translate3d() transform in order to overscroll (scroll past the boundaries). This allows us to simply set the scrollTop/scrollLeft (or top/left for easier reverse-axis orientation, which is what we do in Draggable) and it'll do all the work for us. For example, if we tried setting scrollTop to -100 on a normal DOM element, it wouldn't work - it'd look the same as setting it to 0, but if we set scrollTop of a ScrollProxy to -100, it'll give the correct appearance by either setting paddingTop of the wrapper to 100 or applying a 100-pixel translateY.
$5a019fe42b4630c1$var$ScrollProxy = function ScrollProxy(element, vars) {
    element = $5a019fe42b4630c1$var$gsap.utils.toArray(element)[0];
    vars = vars || {};
    var content = document.createElement("div"), style = content.style, node = element.firstChild, offsetTop = 0, offsetLeft = 0, prevTop = element.scrollTop, prevLeft = element.scrollLeft, scrollWidth = element.scrollWidth, scrollHeight = element.scrollHeight, extraPadRight = 0, maxLeft = 0, maxTop = 0, elementWidth, elementHeight, contentHeight, nextNode, transformStart, transformEnd;
    if ($5a019fe42b4630c1$var$_supports3D && vars.force3D !== false) {
        transformStart = "translate3d(";
        transformEnd = "px,0px)";
    } else if ($5a019fe42b4630c1$var$_transformProp) {
        transformStart = "translate(";
        transformEnd = "px)";
    }
    this.scrollTop = function(value, force) {
        if (!arguments.length) return -this.top();
        this.top(-value, force);
    };
    this.scrollLeft = function(value, force) {
        if (!arguments.length) return -this.left();
        this.left(-value, force);
    };
    this.left = function(value, force) {
        if (!arguments.length) return -(element.scrollLeft + offsetLeft);
        var dif = element.scrollLeft - prevLeft, oldOffset = offsetLeft;
        if ((dif > 2 || dif < -2) && !force) {
            //if the user interacts with the scrollbar (or something else scrolls it, like the mouse wheel), we should kill any tweens of the ScrollProxy.
            prevLeft = element.scrollLeft;
            $5a019fe42b4630c1$var$gsap.killTweensOf(this, {
                left: 1,
                scrollLeft: 1
            });
            this.left(-prevLeft);
            if (vars.onKill) vars.onKill();
            return;
        }
        value = -value; //invert because scrolling works in the opposite direction
        if (value < 0) {
            offsetLeft = value - 0.5 | 0;
            value = 0;
        } else if (value > maxLeft) {
            offsetLeft = value - maxLeft | 0;
            value = maxLeft;
        } else offsetLeft = 0;
        if (offsetLeft || oldOffset) {
            if (!this._skip) style[$5a019fe42b4630c1$var$_transformProp] = transformStart + -offsetLeft + "px," + -offsetTop + transformEnd;
            if (offsetLeft + extraPadRight >= 0) style.paddingRight = offsetLeft + extraPadRight + "px";
        }
        element.scrollLeft = value | 0;
        prevLeft = element.scrollLeft; //don't merge this with the line above because some browsers adjust the scrollLeft after it's set, so in order to be 100% accurate in tracking it, we need to ask the browser to report it.
    };
    this.top = function(value, force) {
        if (!arguments.length) return -(element.scrollTop + offsetTop);
        var dif = element.scrollTop - prevTop, oldOffset = offsetTop;
        if ((dif > 2 || dif < -2) && !force) {
            //if the user interacts with the scrollbar (or something else scrolls it, like the mouse wheel), we should kill any tweens of the ScrollProxy.
            prevTop = element.scrollTop;
            $5a019fe42b4630c1$var$gsap.killTweensOf(this, {
                top: 1,
                scrollTop: 1
            });
            this.top(-prevTop);
            if (vars.onKill) vars.onKill();
            return;
        }
        value = -value; //invert because scrolling works in the opposite direction
        if (value < 0) {
            offsetTop = value - 0.5 | 0;
            value = 0;
        } else if (value > maxTop) {
            offsetTop = value - maxTop | 0;
            value = maxTop;
        } else offsetTop = 0;
        if (offsetTop || oldOffset) {
            if (!this._skip) style[$5a019fe42b4630c1$var$_transformProp] = transformStart + -offsetLeft + "px," + -offsetTop + transformEnd;
        }
        element.scrollTop = value | 0;
        prevTop = element.scrollTop;
    };
    this.maxScrollTop = function() {
        return maxTop;
    };
    this.maxScrollLeft = function() {
        return maxLeft;
    };
    this.disable = function() {
        node = content.firstChild;
        while(node){
            nextNode = node.nextSibling;
            element.appendChild(node);
            node = nextNode;
        }
        if (element === content.parentNode) //in case disable() is called when it's already disabled.
        element.removeChild(content);
    };
    this.enable = function() {
        node = element.firstChild;
        if (node === content) return;
        while(node){
            nextNode = node.nextSibling;
            content.appendChild(node);
            node = nextNode;
        }
        element.appendChild(content);
        this.calibrate();
    };
    this.calibrate = function(force) {
        var widthMatches = element.clientWidth === elementWidth, cs, x, y;
        prevTop = element.scrollTop;
        prevLeft = element.scrollLeft;
        if (widthMatches && element.clientHeight === elementHeight && content.offsetHeight === contentHeight && scrollWidth === element.scrollWidth && scrollHeight === element.scrollHeight && !force) return; //no need to recalculate things if the width and height haven't changed.
        if (offsetTop || offsetLeft) {
            x = this.left();
            y = this.top();
            this.left(-element.scrollLeft);
            this.top(-element.scrollTop);
        }
        cs = $5a019fe42b4630c1$var$_getComputedStyle(element); //first, we need to remove any width constraints to see how the content naturally flows so that we can see if it's wider than the containing element. If so, we've got to record the amount of overage so that we can apply that as padding in order for browsers to correctly handle things. Then we switch back to a width of 100% (without that, some browsers don't flow the content correctly)
        if (!widthMatches || force) {
            style.display = "block";
            style.width = "auto";
            style.paddingRight = "0px";
            extraPadRight = Math.max(0, element.scrollWidth - element.clientWidth); //if the content is wider than the container, we need to add the paddingLeft and paddingRight in order for things to behave correctly.
            if (extraPadRight) extraPadRight += parseFloat(cs.paddingLeft) + ($5a019fe42b4630c1$var$_addPaddingBR ? parseFloat(cs.paddingRight) : 0);
        }
        style.display = "inline-block";
        style.position = "relative";
        style.overflow = "visible";
        style.verticalAlign = "top";
        style.boxSizing = "content-box";
        style.width = "100%";
        style.paddingRight = extraPadRight + "px"; //some browsers neglect to factor in the bottom padding when calculating the scrollHeight, so we need to add that padding to the content when that happens. Allow a 2px margin for error
        if ($5a019fe42b4630c1$var$_addPaddingBR) style.paddingBottom = cs.paddingBottom;
        elementWidth = element.clientWidth;
        elementHeight = element.clientHeight;
        scrollWidth = element.scrollWidth;
        scrollHeight = element.scrollHeight;
        maxLeft = element.scrollWidth - elementWidth;
        maxTop = element.scrollHeight - elementHeight;
        contentHeight = content.offsetHeight;
        style.display = "block";
        if (x || y) {
            this.left(x);
            this.top(y);
        }
    };
    this.content = content;
    this.element = element;
    this._skip = false;
    this.enable();
}, $5a019fe42b4630c1$var$_initCore = function _initCore(required) {
    if ($5a019fe42b4630c1$var$_windowExists() && document.body) {
        var nav = window && window.navigator;
        $5a019fe42b4630c1$var$_win = window;
        $5a019fe42b4630c1$var$_doc = document;
        $5a019fe42b4630c1$var$_docElement = $5a019fe42b4630c1$var$_doc.documentElement;
        $5a019fe42b4630c1$var$_body = $5a019fe42b4630c1$var$_doc.body;
        $5a019fe42b4630c1$var$_tempDiv = $5a019fe42b4630c1$var$_createElement("div");
        $5a019fe42b4630c1$var$_supportsPointer = !!window.PointerEvent;
        $5a019fe42b4630c1$var$_placeholderDiv = $5a019fe42b4630c1$var$_createElement("div");
        $5a019fe42b4630c1$var$_placeholderDiv.style.cssText = "visibility:hidden;height:1px;top:-1px;pointer-events:none;position:relative;clear:both;cursor:grab";
        $5a019fe42b4630c1$var$_defaultCursor = $5a019fe42b4630c1$var$_placeholderDiv.style.cursor === "grab" ? "grab" : "move";
        $5a019fe42b4630c1$var$_isAndroid = nav && nav.userAgent.toLowerCase().indexOf("android") !== -1; //Android handles touch events in an odd way and it's virtually impossible to "feature test" so we resort to UA sniffing
        $5a019fe42b4630c1$var$_isTouchDevice = "ontouchstart" in $5a019fe42b4630c1$var$_docElement && "orientation" in $5a019fe42b4630c1$var$_win || nav && (nav.MaxTouchPoints > 0 || nav.msMaxTouchPoints > 0);
        $5a019fe42b4630c1$var$_addPaddingBR = function() {
            //this function is in charge of analyzing browser behavior related to padding. It sets the _addPaddingBR to true if the browser doesn't normally factor in the bottom or right padding on the element inside the scrolling area, and it sets _addPaddingLeft to true if it's a browser that requires the extra offset (offsetLeft) to be added to the paddingRight (like Opera).
            var div = $5a019fe42b4630c1$var$_createElement("div"), child = $5a019fe42b4630c1$var$_createElement("div"), childStyle = child.style, parent = $5a019fe42b4630c1$var$_body, val;
            childStyle.display = "inline-block";
            childStyle.position = "relative";
            div.style.cssText = "width:90px;height:40px;padding:10px;overflow:auto;visibility:hidden";
            div.appendChild(child);
            parent.appendChild(div);
            val = child.offsetHeight + 18 > div.scrollHeight; //div.scrollHeight should be child.offsetHeight + 20 because of the 10px of padding on each side, but some browsers ignore one side. We allow a 2px margin of error.
            parent.removeChild(div);
            return val;
        }();
        $5a019fe42b4630c1$var$_touchEventLookup = function(types) {
            //we create an object that makes it easy to translate touch event types into their "pointer" counterparts if we're in a browser that uses those instead. Like IE10 uses "MSPointerDown" instead of "touchstart", for example.
            var standard = types.split(","), converted = ("onpointerdown" in $5a019fe42b4630c1$var$_tempDiv ? "pointerdown,pointermove,pointerup,pointercancel" : "onmspointerdown" in $5a019fe42b4630c1$var$_tempDiv ? "MSPointerDown,MSPointerMove,MSPointerUp,MSPointerCancel" : types).split(","), obj = {}, i = 4;
            while(--i > -1){
                obj[standard[i]] = converted[i];
                obj[converted[i]] = standard[i];
            } //to avoid problems in iOS 9, test to see if the browser supports the "passive" option on addEventListener().
            try {
                $5a019fe42b4630c1$var$_docElement.addEventListener("test", null, Object.defineProperty({}, "passive", {
                    get: function get() {
                        $5a019fe42b4630c1$var$_supportsPassive = 1;
                    }
                }));
            } catch (e) {}
            return obj;
        }("touchstart,touchmove,touchend,touchcancel");
        $5a019fe42b4630c1$var$_addListener($5a019fe42b4630c1$var$_doc, "touchcancel", $5a019fe42b4630c1$var$_emptyFunc); //some older Android devices intermittently stop dispatching "touchmove" events if we don't listen for "touchcancel" on the document. Very strange indeed.
        $5a019fe42b4630c1$var$_addListener($5a019fe42b4630c1$var$_win, "touchmove", $5a019fe42b4630c1$var$_emptyFunc); //works around Safari bugs that still allow the page to scroll even when we preventDefault() on the touchmove event.
        $5a019fe42b4630c1$var$_body && $5a019fe42b4630c1$var$_body.addEventListener("touchstart", $5a019fe42b4630c1$var$_emptyFunc); //works around Safari bug: https://gsap.com/forums/topic/21450-draggable-in-iframe-on-mobile-is-buggy/
        $5a019fe42b4630c1$var$_addListener($5a019fe42b4630c1$var$_doc, "contextmenu", function() {
            for(var p in $5a019fe42b4630c1$var$_lookup)if ($5a019fe42b4630c1$var$_lookup[p].isPressed) $5a019fe42b4630c1$var$_lookup[p].endDrag();
        });
        $5a019fe42b4630c1$var$gsap = $5a019fe42b4630c1$var$_coreInitted = $5a019fe42b4630c1$var$_getGSAP();
    }
    if ($5a019fe42b4630c1$var$gsap) {
        $5a019fe42b4630c1$var$InertiaPlugin = $5a019fe42b4630c1$var$gsap.plugins.inertia;
        $5a019fe42b4630c1$var$_context = $5a019fe42b4630c1$var$gsap.core.context || function() {};
        $5a019fe42b4630c1$var$_checkPrefix = $5a019fe42b4630c1$var$gsap.utils.checkPrefix;
        $5a019fe42b4630c1$var$_transformProp = $5a019fe42b4630c1$var$_checkPrefix($5a019fe42b4630c1$var$_transformProp);
        $5a019fe42b4630c1$var$_transformOriginProp = $5a019fe42b4630c1$var$_checkPrefix($5a019fe42b4630c1$var$_transformOriginProp);
        $5a019fe42b4630c1$var$_toArray = $5a019fe42b4630c1$var$gsap.utils.toArray;
        $5a019fe42b4630c1$var$_getStyleSaver = $5a019fe42b4630c1$var$gsap.core.getStyleSaver;
        $5a019fe42b4630c1$var$_supports3D = !!$5a019fe42b4630c1$var$_checkPrefix("perspective");
    } else if (required) console.warn("Please gsap.registerPlugin(Draggable)");
};
var $5a019fe42b4630c1$var$EventDispatcher = /*#__PURE__*/ function() {
    function EventDispatcher(target) {
        this._listeners = {};
        this.target = target || this;
    }
    var _proto = EventDispatcher.prototype;
    _proto.addEventListener = function addEventListener(type, callback) {
        var list = this._listeners[type] || (this._listeners[type] = []);
        if (!~list.indexOf(callback)) list.push(callback);
    };
    _proto.removeEventListener = function removeEventListener(type, callback) {
        var list = this._listeners[type], i = list && list.indexOf(callback);
        i >= 0 && list.splice(i, 1);
    };
    _proto.dispatchEvent = function dispatchEvent(type) {
        var _this = this;
        var result;
        (this._listeners[type] || []).forEach(function(callback) {
            return callback.call(_this, {
                type: type,
                target: _this.target
            }) === false && (result = false);
        });
        return result; //if any of the callbacks return false, pass that along.
    };
    return EventDispatcher;
}();
var $5a019fe42b4630c1$export$f2a139e5d18b9882 = /*#__PURE__*/ function(_EventDispatcher) {
    $5a019fe42b4630c1$var$_inheritsLoose(Draggable, _EventDispatcher);
    function Draggable(target, vars) {
        var _this2;
        _this2 = _EventDispatcher.call(this) || this;
        $5a019fe42b4630c1$var$_coreInitted || $5a019fe42b4630c1$var$_initCore(1);
        target = $5a019fe42b4630c1$var$_toArray(target)[0]; //in case the target is a selector object or selector text
        _this2.styles = $5a019fe42b4630c1$var$_getStyleSaver && $5a019fe42b4630c1$var$_getStyleSaver(target, "transform,left,top");
        if (!$5a019fe42b4630c1$var$InertiaPlugin) $5a019fe42b4630c1$var$InertiaPlugin = $5a019fe42b4630c1$var$gsap.plugins.inertia;
        _this2.vars = vars = $5a019fe42b4630c1$var$_copy(vars || {});
        _this2.target = target;
        _this2.x = _this2.y = _this2.rotation = 0;
        _this2.dragResistance = parseFloat(vars.dragResistance) || 0;
        _this2.edgeResistance = isNaN(vars.edgeResistance) ? 1 : parseFloat(vars.edgeResistance) || 0;
        _this2.lockAxis = vars.lockAxis;
        _this2.autoScroll = vars.autoScroll || 0;
        _this2.lockedAxis = null;
        _this2.allowEventDefault = !!vars.allowEventDefault;
        $5a019fe42b4630c1$var$gsap.getProperty(target, "x"); // to ensure that transforms are instantiated.
        var type = (vars.type || "x,y").toLowerCase(), xyMode = ~type.indexOf("x") || ~type.indexOf("y"), rotationMode = type.indexOf("rotation") !== -1, xProp = rotationMode ? "rotation" : xyMode ? "x" : "left", yProp = xyMode ? "y" : "top", allowX = !!(~type.indexOf("x") || ~type.indexOf("left") || type === "scroll"), allowY = !!(~type.indexOf("y") || ~type.indexOf("top") || type === "scroll"), minimumMovement = vars.minimumMovement || 2, self = $5a019fe42b4630c1$var$_assertThisInitialized(_this2), triggers = $5a019fe42b4630c1$var$_toArray(vars.trigger || vars.handle || target), killProps = {}, dragEndTime = 0, checkAutoScrollBounds = false, autoScrollMarginTop = vars.autoScrollMarginTop || 40, autoScrollMarginRight = vars.autoScrollMarginRight || 40, autoScrollMarginBottom = vars.autoScrollMarginBottom || 40, autoScrollMarginLeft = vars.autoScrollMarginLeft || 40, isClickable = vars.clickableTest || $5a019fe42b4630c1$var$_isClickable, clickTime = 0, gsCache = target._gsap || $5a019fe42b4630c1$var$gsap.core.getCache(target), isFixed = $5a019fe42b4630c1$var$_isFixed(target), getPropAsNum = function getPropAsNum(property, unit) {
            return parseFloat(gsCache.get(target, property, unit));
        }, ownerDoc = target.ownerDocument || $5a019fe42b4630c1$var$_doc, enabled, scrollProxy, startPointerX, startPointerY, startElementX, startElementY, hasBounds, hasDragCallback, hasMoveCallback, maxX, minX, maxY, minY, touch, touchID, rotationOrigin, dirty, old, snapX, snapY, snapXY, isClicking, touchEventTarget, matrix, interrupted, allowNativeTouchScrolling, touchDragAxis, isDispatching, clickDispatch, trustedClickDispatch, isPreventingDefault, innerMatrix, dragged, onContextMenu = function onContextMenu(e) {
            //used to prevent long-touch from triggering a context menu.
            // (self.isPressed && e.which < 2) && self.endDrag() // previously ended drag when context menu was triggered, but instead we should just stop propagation and prevent the default event behavior.
            $5a019fe42b4630c1$var$_preventDefault(e);
            e.stopImmediatePropagation && e.stopImmediatePropagation();
            return false;
        }, //this method gets called on every tick of TweenLite.ticker which allows us to synchronize the renders to the core engine (which is typically synchronized with the display refresh via requestAnimationFrame). This is an optimization - it's better than applying the values inside the "mousemove" or "touchmove" event handler which may get called many times inbetween refreshes.
        render = function render(suppressEvents) {
            if (self.autoScroll && self.isDragging && (checkAutoScrollBounds || dirty)) {
                var e = target, autoScrollFactor = self.autoScroll * 15, //multiplying by 15 just gives us a better "feel" speed-wise.
                parent, isRoot, rect, pointerX, pointerY, changeX, changeY, gap;
                checkAutoScrollBounds = false;
                $5a019fe42b4630c1$var$_windowProxy.scrollTop = $5a019fe42b4630c1$var$_win.pageYOffset != null ? $5a019fe42b4630c1$var$_win.pageYOffset : ownerDoc.documentElement.scrollTop != null ? ownerDoc.documentElement.scrollTop : ownerDoc.body.scrollTop;
                $5a019fe42b4630c1$var$_windowProxy.scrollLeft = $5a019fe42b4630c1$var$_win.pageXOffset != null ? $5a019fe42b4630c1$var$_win.pageXOffset : ownerDoc.documentElement.scrollLeft != null ? ownerDoc.documentElement.scrollLeft : ownerDoc.body.scrollLeft;
                pointerX = self.pointerX - $5a019fe42b4630c1$var$_windowProxy.scrollLeft;
                pointerY = self.pointerY - $5a019fe42b4630c1$var$_windowProxy.scrollTop;
                while(e && !isRoot){
                    //walk up the chain and sense wherever the pointer is within 40px of an edge that's scrollable.
                    isRoot = $5a019fe42b4630c1$var$_isRoot(e.parentNode);
                    parent = isRoot ? $5a019fe42b4630c1$var$_windowProxy : e.parentNode;
                    rect = isRoot ? {
                        bottom: Math.max($5a019fe42b4630c1$var$_docElement.clientHeight, $5a019fe42b4630c1$var$_win.innerHeight || 0),
                        right: Math.max($5a019fe42b4630c1$var$_docElement.clientWidth, $5a019fe42b4630c1$var$_win.innerWidth || 0),
                        left: 0,
                        top: 0
                    } : parent.getBoundingClientRect();
                    changeX = changeY = 0;
                    if (allowY) {
                        gap = parent._gsMaxScrollY - parent.scrollTop;
                        if (gap < 0) changeY = gap;
                        else if (pointerY > rect.bottom - autoScrollMarginBottom && gap) {
                            checkAutoScrollBounds = true;
                            changeY = Math.min(gap, autoScrollFactor * (1 - Math.max(0, rect.bottom - pointerY) / autoScrollMarginBottom) | 0);
                        } else if (pointerY < rect.top + autoScrollMarginTop && parent.scrollTop) {
                            checkAutoScrollBounds = true;
                            changeY = -Math.min(parent.scrollTop, autoScrollFactor * (1 - Math.max(0, pointerY - rect.top) / autoScrollMarginTop) | 0);
                        }
                        if (changeY) parent.scrollTop += changeY;
                    }
                    if (allowX) {
                        gap = parent._gsMaxScrollX - parent.scrollLeft;
                        if (gap < 0) changeX = gap;
                        else if (pointerX > rect.right - autoScrollMarginRight && gap) {
                            checkAutoScrollBounds = true;
                            changeX = Math.min(gap, autoScrollFactor * (1 - Math.max(0, rect.right - pointerX) / autoScrollMarginRight) | 0);
                        } else if (pointerX < rect.left + autoScrollMarginLeft && parent.scrollLeft) {
                            checkAutoScrollBounds = true;
                            changeX = -Math.min(parent.scrollLeft, autoScrollFactor * (1 - Math.max(0, pointerX - rect.left) / autoScrollMarginLeft) | 0);
                        }
                        if (changeX) parent.scrollLeft += changeX;
                    }
                    if (isRoot && (changeX || changeY)) {
                        $5a019fe42b4630c1$var$_win.scrollTo(parent.scrollLeft, parent.scrollTop);
                        setPointerPosition(self.pointerX + changeX, self.pointerY + changeY);
                    }
                    e = parent;
                }
            }
            if (dirty) {
                var x = self.x, y = self.y;
                if (rotationMode) {
                    self.deltaX = x - parseFloat(gsCache.rotation);
                    self.rotation = x;
                    gsCache.rotation = x + "deg";
                    gsCache.renderTransform(1, gsCache);
                } else {
                    if (scrollProxy) {
                        if (allowY) {
                            self.deltaY = y - scrollProxy.top();
                            scrollProxy.top(y);
                        }
                        if (allowX) {
                            self.deltaX = x - scrollProxy.left();
                            scrollProxy.left(x);
                        }
                    } else if (xyMode) {
                        if (allowY) {
                            self.deltaY = y - parseFloat(gsCache.y);
                            gsCache.y = y + "px";
                        }
                        if (allowX) {
                            self.deltaX = x - parseFloat(gsCache.x);
                            gsCache.x = x + "px";
                        }
                        gsCache.renderTransform(1, gsCache);
                    } else {
                        if (allowY) {
                            self.deltaY = y - parseFloat(target.style.top || 0);
                            target.style.top = y + "px";
                        }
                        if (allowX) {
                            self.deltaX = x - parseFloat(target.style.left || 0);
                            target.style.left = x + "px";
                        }
                    }
                }
                if (hasDragCallback && !suppressEvents && !isDispatching) {
                    isDispatching = true; //in case onDrag has an update() call (avoid endless loop)
                    if ($5a019fe42b4630c1$var$_dispatchEvent(self, "drag", "onDrag") === false) {
                        if (allowX) self.x -= self.deltaX;
                        if (allowY) self.y -= self.deltaY;
                        render(true);
                    }
                    isDispatching = false;
                }
            }
            dirty = false;
        }, //copies the x/y from the element (whether that be transforms, top/left, or ScrollProxy's top/left) to the Draggable's x and y (and rotation if necessary) properties so that they reflect reality and it also (optionally) applies any snapping necessary. This is used by the InertiaPlugin tween in an onUpdate to ensure things are synced and snapped.
        syncXY = function syncXY(skipOnUpdate, skipSnap) {
            var x = self.x, y = self.y, snappedValue, cs;
            if (!target._gsap) //just in case the _gsap cache got wiped, like if the user called clearProps on the transform or something (very rare).
            gsCache = $5a019fe42b4630c1$var$gsap.core.getCache(target);
            gsCache.uncache && $5a019fe42b4630c1$var$gsap.getProperty(target, "x"); // trigger a re-cache
            if (xyMode) {
                self.x = parseFloat(gsCache.x);
                self.y = parseFloat(gsCache.y);
            } else if (rotationMode) self.x = self.rotation = $5a019fe42b4630c1$var$_round(parseFloat(gsCache.rotation));
            else if (scrollProxy) {
                self.y = scrollProxy.top();
                self.x = scrollProxy.left();
            } else {
                self.y = parseFloat(target.style.top || (cs = $5a019fe42b4630c1$var$_getComputedStyle(target)) && cs.top) || 0;
                self.x = parseFloat(target.style.left || (cs || {}).left) || 0;
            }
            if ((snapX || snapY || snapXY) && !skipSnap && (self.isDragging || self.isThrowing)) {
                if (snapXY) {
                    $5a019fe42b4630c1$var$_temp1.x = self.x;
                    $5a019fe42b4630c1$var$_temp1.y = self.y;
                    snappedValue = snapXY($5a019fe42b4630c1$var$_temp1);
                    if (snappedValue.x !== self.x) {
                        self.x = snappedValue.x;
                        dirty = true;
                    }
                    if (snappedValue.y !== self.y) {
                        self.y = snappedValue.y;
                        dirty = true;
                    }
                }
                if (snapX) {
                    snappedValue = snapX(self.x);
                    if (snappedValue !== self.x) {
                        self.x = snappedValue;
                        if (rotationMode) self.rotation = snappedValue;
                        dirty = true;
                    }
                }
                if (snapY) {
                    snappedValue = snapY(self.y);
                    if (snappedValue !== self.y) self.y = snappedValue;
                    dirty = true;
                }
            }
            dirty && render(true);
            if (!skipOnUpdate) {
                self.deltaX = self.x - x;
                self.deltaY = self.y - y;
                $5a019fe42b4630c1$var$_dispatchEvent(self, "throwupdate", "onThrowUpdate");
            }
        }, buildSnapFunc = function buildSnapFunc(snap, min, max, factor) {
            if (min == null) min = -$5a019fe42b4630c1$var$_bigNum;
            if (max == null) max = $5a019fe42b4630c1$var$_bigNum;
            if ($5a019fe42b4630c1$var$_isFunction(snap)) return function(n) {
                var edgeTolerance = !self.isPressed ? 1 : 1 - self.edgeResistance; //if we're tweening, disable the edgeTolerance because it's already factored into the tweening values (we don't want to apply it multiple times)
                return snap.call(self, (n > max ? max + (n - max) * edgeTolerance : n < min ? min + (n - min) * edgeTolerance : n) * factor) * factor;
            };
            if ($5a019fe42b4630c1$var$_isArray(snap)) return function(n) {
                var i = snap.length, closest = 0, absDif = $5a019fe42b4630c1$var$_bigNum, val, dif;
                while(--i > -1){
                    val = snap[i];
                    dif = val - n;
                    if (dif < 0) dif = -dif;
                    if (dif < absDif && val >= min && val <= max) {
                        closest = i;
                        absDif = dif;
                    }
                }
                return snap[closest];
            };
            return isNaN(snap) ? function(n) {
                return n;
            } : function() {
                return snap * factor;
            };
        }, buildPointSnapFunc = function buildPointSnapFunc(snap, minX, maxX, minY, maxY, radius, factor) {
            radius = radius && radius < $5a019fe42b4630c1$var$_bigNum ? radius * radius : $5a019fe42b4630c1$var$_bigNum; //so we don't have to Math.sqrt() in the functions. Performance optimization.
            if ($5a019fe42b4630c1$var$_isFunction(snap)) return function(point) {
                var edgeTolerance = !self.isPressed ? 1 : 1 - self.edgeResistance, x = point.x, y = point.y, result, dx, dy; //if we're tweening, disable the edgeTolerance because it's already factored into the tweening values (we don't want to apply it multiple times)
                point.x = x = x > maxX ? maxX + (x - maxX) * edgeTolerance : x < minX ? minX + (x - minX) * edgeTolerance : x;
                point.y = y = y > maxY ? maxY + (y - maxY) * edgeTolerance : y < minY ? minY + (y - minY) * edgeTolerance : y;
                result = snap.call(self, point);
                if (result !== point) {
                    point.x = result.x;
                    point.y = result.y;
                }
                if (factor !== 1) {
                    point.x *= factor;
                    point.y *= factor;
                }
                if (radius < $5a019fe42b4630c1$var$_bigNum) {
                    dx = point.x - x;
                    dy = point.y - y;
                    if (dx * dx + dy * dy > radius) {
                        point.x = x;
                        point.y = y;
                    }
                }
                return point;
            };
            if ($5a019fe42b4630c1$var$_isArray(snap)) return function(p) {
                var i = snap.length, closest = 0, minDist = $5a019fe42b4630c1$var$_bigNum, x, y, point, dist;
                while(--i > -1){
                    point = snap[i];
                    x = point.x - p.x;
                    y = point.y - p.y;
                    dist = x * x + y * y;
                    if (dist < minDist) {
                        closest = i;
                        minDist = dist;
                    }
                }
                return minDist <= radius ? snap[closest] : p;
            };
            return function(n) {
                return n;
            };
        }, calculateBounds = function calculateBounds() {
            var bounds, targetBounds, snap, snapIsRaw;
            hasBounds = false;
            if (scrollProxy) {
                scrollProxy.calibrate();
                self.minX = minX = -scrollProxy.maxScrollLeft();
                self.minY = minY = -scrollProxy.maxScrollTop();
                self.maxX = maxX = self.maxY = maxY = 0;
                hasBounds = true;
            } else if (!!vars.bounds) {
                bounds = $5a019fe42b4630c1$var$_getBounds(vars.bounds, target.parentNode); //could be a selector/jQuery object or a DOM element or a generic object like {top:0, left:100, width:1000, height:800} or {minX:100, maxX:1100, minY:0, maxY:800}
                if (rotationMode) {
                    self.minX = minX = bounds.left;
                    self.maxX = maxX = bounds.left + bounds.width;
                    self.minY = minY = self.maxY = maxY = 0;
                } else if (!$5a019fe42b4630c1$var$_isUndefined(vars.bounds.maxX) || !$5a019fe42b4630c1$var$_isUndefined(vars.bounds.maxY)) {
                    bounds = vars.bounds;
                    self.minX = minX = bounds.minX;
                    self.minY = minY = bounds.minY;
                    self.maxX = maxX = bounds.maxX;
                    self.maxY = maxY = bounds.maxY;
                } else {
                    targetBounds = $5a019fe42b4630c1$var$_getBounds(target, target.parentNode);
                    self.minX = minX = Math.round(getPropAsNum(xProp, "px") + bounds.left - targetBounds.left);
                    self.minY = minY = Math.round(getPropAsNum(yProp, "px") + bounds.top - targetBounds.top);
                    self.maxX = maxX = Math.round(minX + (bounds.width - targetBounds.width));
                    self.maxY = maxY = Math.round(minY + (bounds.height - targetBounds.height));
                }
                if (minX > maxX) {
                    self.minX = maxX;
                    self.maxX = maxX = minX;
                    minX = self.minX;
                }
                if (minY > maxY) {
                    self.minY = maxY;
                    self.maxY = maxY = minY;
                    minY = self.minY;
                }
                if (rotationMode) {
                    self.minRotation = minX;
                    self.maxRotation = maxX;
                }
                hasBounds = true;
            }
            if (vars.liveSnap) {
                snap = vars.liveSnap === true ? vars.snap || {} : vars.liveSnap;
                snapIsRaw = $5a019fe42b4630c1$var$_isArray(snap) || $5a019fe42b4630c1$var$_isFunction(snap);
                if (rotationMode) {
                    snapX = buildSnapFunc(snapIsRaw ? snap : snap.rotation, minX, maxX, 1);
                    snapY = null;
                } else if (snap.points) snapXY = buildPointSnapFunc(snapIsRaw ? snap : snap.points, minX, maxX, minY, maxY, snap.radius, scrollProxy ? -1 : 1);
                else {
                    if (allowX) snapX = buildSnapFunc(snapIsRaw ? snap : snap.x || snap.left || snap.scrollLeft, minX, maxX, scrollProxy ? -1 : 1);
                    if (allowY) snapY = buildSnapFunc(snapIsRaw ? snap : snap.y || snap.top || snap.scrollTop, minY, maxY, scrollProxy ? -1 : 1);
                }
            }
        }, onThrowComplete = function onThrowComplete() {
            self.isThrowing = false;
            $5a019fe42b4630c1$var$_dispatchEvent(self, "throwcomplete", "onThrowComplete");
        }, onThrowInterrupt = function onThrowInterrupt() {
            self.isThrowing = false;
        }, animate = function animate(inertia, forceZeroVelocity) {
            var snap, snapIsRaw, tween, overshootTolerance;
            if (inertia && $5a019fe42b4630c1$var$InertiaPlugin) {
                if (inertia === true) {
                    snap = vars.snap || vars.liveSnap || {};
                    snapIsRaw = $5a019fe42b4630c1$var$_isArray(snap) || $5a019fe42b4630c1$var$_isFunction(snap);
                    inertia = {
                        resistance: (vars.throwResistance || vars.resistance || 1000) / (rotationMode ? 10 : 1)
                    };
                    if (rotationMode) inertia.rotation = $5a019fe42b4630c1$var$_parseInertia(self, snapIsRaw ? snap : snap.rotation, maxX, minX, 1, forceZeroVelocity);
                    else {
                        if (allowX) inertia[xProp] = $5a019fe42b4630c1$var$_parseInertia(self, snapIsRaw ? snap : snap.points || snap.x || snap.left, maxX, minX, scrollProxy ? -1 : 1, forceZeroVelocity || self.lockedAxis === "x");
                        if (allowY) inertia[yProp] = $5a019fe42b4630c1$var$_parseInertia(self, snapIsRaw ? snap : snap.points || snap.y || snap.top, maxY, minY, scrollProxy ? -1 : 1, forceZeroVelocity || self.lockedAxis === "y");
                        if (snap.points || $5a019fe42b4630c1$var$_isArray(snap) && $5a019fe42b4630c1$var$_isObject(snap[0])) {
                            inertia.linkedProps = xProp + "," + yProp;
                            inertia.radius = snap.radius; //note: we also disable liveSnapping while throwing if there's a "radius" defined, otherwise it looks weird to have the item thrown past a snapping point but live-snapping mid-tween. We do this by altering the onUpdateParams so that "skipSnap" parameter is true for syncXY.
                        }
                    }
                }
                self.isThrowing = true;
                overshootTolerance = !isNaN(vars.overshootTolerance) ? vars.overshootTolerance : vars.edgeResistance === 1 ? 0 : 1 - self.edgeResistance + 0.2;
                if (!inertia.duration) inertia.duration = {
                    max: Math.max(vars.minDuration || 0, "maxDuration" in vars ? vars.maxDuration : 2),
                    min: !isNaN(vars.minDuration) ? vars.minDuration : overshootTolerance === 0 || $5a019fe42b4630c1$var$_isObject(inertia) && inertia.resistance > 1000 ? 0 : 0.5,
                    overshoot: overshootTolerance
                };
                self.tween = tween = $5a019fe42b4630c1$var$gsap.to(scrollProxy || target, {
                    inertia: inertia,
                    data: "_draggable",
                    inherit: false,
                    onComplete: onThrowComplete,
                    onInterrupt: onThrowInterrupt,
                    onUpdate: vars.fastMode ? $5a019fe42b4630c1$var$_dispatchEvent : syncXY,
                    onUpdateParams: vars.fastMode ? [
                        self,
                        "onthrowupdate",
                        "onThrowUpdate"
                    ] : snap && snap.radius ? [
                        false,
                        true
                    ] : []
                });
                if (!vars.fastMode) {
                    if (scrollProxy) scrollProxy._skip = true; // Microsoft browsers have a bug that causes them to briefly render the position incorrectly (it flashes to the end state when we seek() the tween even though we jump right back to the current position, and this only seems to happen when we're affecting both top and left), so we set a _suspendTransforms flag to prevent it from actually applying the values in the ScrollProxy.
                    tween.render(1e9, true, true); // force to the end. Remember, the duration will likely change upon initting because that's when InertiaPlugin calculates it.
                    syncXY(true, true);
                    self.endX = self.x;
                    self.endY = self.y;
                    if (rotationMode) self.endRotation = self.x;
                    tween.play(0);
                    syncXY(true, true);
                    if (scrollProxy) scrollProxy._skip = false; //Microsoft browsers have a bug that causes them to briefly render the position incorrectly (it flashes to the end state when we seek() the tween even though we jump right back to the current position, and this only seems to happen when we're affecting both top and left), so we set a _suspendTransforms flag to prevent it from actually applying the values in the ScrollProxy.
                }
            } else if (hasBounds) self.applyBounds();
        }, updateMatrix = function updateMatrix(shiftStart) {
            var start = matrix, p;
            matrix = (0, $e1498ade04c27c48$export$91a495f99cf781b7)(target.parentNode, true);
            if (shiftStart && self.isPressed && !matrix.equals(start || new (0, $e1498ade04c27c48$export$26e6ecd136a15474)())) {
                //if the matrix changes WHILE the element is pressed, we must adjust the startPointerX and startPointerY accordingly, so we invert the original matrix and figure out where the pointerX and pointerY were in the global space, then apply the new matrix to get the updated coordinates.
                p = start.inverse().apply({
                    x: startPointerX,
                    y: startPointerY
                });
                matrix.apply(p, p);
                startPointerX = p.x;
                startPointerY = p.y;
            }
            if (matrix.equals($5a019fe42b4630c1$var$_identityMatrix)) //if there are no transforms, we can optimize performance by not factoring in the matrix
            matrix = null;
        }, recordStartPositions = function recordStartPositions() {
            var edgeTolerance = 1 - self.edgeResistance, offsetX = isFixed ? $5a019fe42b4630c1$var$_getDocScrollLeft(ownerDoc) : 0, offsetY = isFixed ? $5a019fe42b4630c1$var$_getDocScrollTop(ownerDoc) : 0, parsedOrigin, x, y;
            if (xyMode) {
                // in case the user set it as a different unit, like animating the x to "100%". We must convert it back to px!
                gsCache.x = getPropAsNum(xProp, "px") + "px";
                gsCache.y = getPropAsNum(yProp, "px") + "px";
                gsCache.renderTransform();
            }
            updateMatrix(false);
            $5a019fe42b4630c1$var$_point1.x = self.pointerX - offsetX;
            $5a019fe42b4630c1$var$_point1.y = self.pointerY - offsetY;
            matrix && matrix.apply($5a019fe42b4630c1$var$_point1, $5a019fe42b4630c1$var$_point1);
            startPointerX = $5a019fe42b4630c1$var$_point1.x; //translate to local coordinate system
            startPointerY = $5a019fe42b4630c1$var$_point1.y;
            if (dirty) {
                setPointerPosition(self.pointerX, self.pointerY);
                render(true);
            }
            innerMatrix = (0, $e1498ade04c27c48$export$91a495f99cf781b7)(target);
            if (scrollProxy) {
                calculateBounds();
                startElementY = scrollProxy.top();
                startElementX = scrollProxy.left();
            } else {
                //if the element is in the process of tweening, don't force snapping to occur because it could make it jump. Imagine the user throwing, then before it's done, clicking on the element in its inbetween state.
                if (isTweening()) {
                    syncXY(true, true);
                    calculateBounds();
                } else self.applyBounds();
                if (rotationMode) {
                    parsedOrigin = target.ownerSVGElement ? [
                        gsCache.xOrigin - target.getBBox().x,
                        gsCache.yOrigin - target.getBBox().y
                    ] : ($5a019fe42b4630c1$var$_getComputedStyle(target)[$5a019fe42b4630c1$var$_transformOriginProp] || "0 0").split(" ");
                    rotationOrigin = self.rotationOrigin = (0, $e1498ade04c27c48$export$91a495f99cf781b7)(target).apply({
                        x: parseFloat(parsedOrigin[0]) || 0,
                        y: parseFloat(parsedOrigin[1]) || 0
                    });
                    syncXY(true, true);
                    x = self.pointerX - rotationOrigin.x - offsetX;
                    y = rotationOrigin.y - self.pointerY + offsetY;
                    startElementX = self.x; //starting rotation (x always refers to rotation in type:"rotation", measured in degrees)
                    startElementY = self.y = Math.atan2(y, x) * $5a019fe42b4630c1$var$_RAD2DEG;
                } else {
                    //parent = !isFixed && target.parentNode;
                    //startScrollTop = parent ? parent.scrollTop || 0 : 0;
                    //startScrollLeft = parent ? parent.scrollLeft || 0 : 0;
                    startElementY = getPropAsNum(yProp, "px"); //record the starting top and left values so that we can just add the mouse's movement to them later.
                    startElementX = getPropAsNum(xProp, "px");
                }
            }
            if (hasBounds && edgeTolerance) {
                if (startElementX > maxX) startElementX = maxX + (startElementX - maxX) / edgeTolerance;
                else if (startElementX < minX) startElementX = minX - (minX - startElementX) / edgeTolerance;
                if (!rotationMode) {
                    if (startElementY > maxY) startElementY = maxY + (startElementY - maxY) / edgeTolerance;
                    else if (startElementY < minY) startElementY = minY - (minY - startElementY) / edgeTolerance;
                }
            }
            self.startX = startElementX = $5a019fe42b4630c1$var$_round(startElementX);
            self.startY = startElementY = $5a019fe42b4630c1$var$_round(startElementY);
        }, isTweening = function isTweening() {
            return self.tween && self.tween.isActive();
        }, removePlaceholder = function removePlaceholder() {
            if ($5a019fe42b4630c1$var$_placeholderDiv.parentNode && !isTweening() && !self.isDragging) //_placeholderDiv just props open auto-scrolling containers so they don't collapse as the user drags left/up. We remove it after dragging (and throwing, if necessary) finishes.
            $5a019fe42b4630c1$var$_placeholderDiv.parentNode.removeChild($5a019fe42b4630c1$var$_placeholderDiv);
        }, //called when the mouse is pressed (or touch starts)
        onPress = function onPress(e, force) {
            var i;
            if (!enabled || self.isPressed || !e || (e.type === "mousedown" || e.type === "pointerdown") && !force && $5a019fe42b4630c1$var$_getTime() - clickTime < 30 && $5a019fe42b4630c1$var$_touchEventLookup[self.pointerEvent.type]) {
                //when we DON'T preventDefault() in order to accommodate touch-scrolling and the user just taps, many browsers also fire a mousedown/mouseup sequence AFTER the touchstart/touchend sequence, thus it'd result in two quick "click" events being dispatched. This line senses that condition and halts it on the subsequent mousedown.
                isPreventingDefault && e && enabled && $5a019fe42b4630c1$var$_preventDefault(e); // in some browsers, we must listen for multiple event types like touchstart, pointerdown, mousedown. The first time this function is called, we record whether or not we _preventDefault() so that on duplicate calls, we can do the same if necessary.
                return;
            }
            interrupted = isTweening();
            dragged = false; // we need to track whether or not it was dragged in this interaction so that if, for example, the user calls .endDrag() to FORCE it to stop and then they keep the mouse pressed down and eventually release, that would normally cause an onClick but we have to skip it in that case if there was dragging that occurred.
            self.pointerEvent = e;
            if ($5a019fe42b4630c1$var$_touchEventLookup[e.type]) {
                //note: on iOS, BOTH touchmove and mousemove are dispatched, but the mousemove has pageY and pageX of 0 which would mess up the calculations and needlessly hurt performance.
                touchEventTarget = ~e.type.indexOf("touch") ? e.currentTarget || e.target : ownerDoc; //pointer-based touches (for Microsoft browsers) don't remain locked to the original target like other browsers, so we must use the document instead. The event type would be "MSPointerDown" or "pointerdown".
                $5a019fe42b4630c1$var$_addListener(touchEventTarget, "touchend", onRelease);
                $5a019fe42b4630c1$var$_addListener(touchEventTarget, "touchmove", onMove); // possible future change if PointerEvents are more standardized: https://developer.mozilla.org/en-US/docs/Web/API/Element/setPointerCapture
                $5a019fe42b4630c1$var$_addListener(touchEventTarget, "touchcancel", onRelease);
                $5a019fe42b4630c1$var$_addListener(ownerDoc, "touchstart", $5a019fe42b4630c1$var$_onMultiTouchDocument);
            } else {
                touchEventTarget = null;
                $5a019fe42b4630c1$var$_addListener(ownerDoc, "mousemove", onMove); //attach these to the document instead of the box itself so that if the user's mouse moves too quickly (and off of the box), things still work.
            }
            touchDragAxis = null;
            if (!$5a019fe42b4630c1$var$_supportsPointer || !touchEventTarget) {
                $5a019fe42b4630c1$var$_addListener(ownerDoc, "mouseup", onRelease);
                e && e.target && $5a019fe42b4630c1$var$_addListener(e.target, "mouseup", onRelease); //we also have to listen directly on the element because some browsers don't bubble up the event to the _doc on elements with contentEditable="true"
            }
            isClicking = isClickable.call(self, e.target) && vars.dragClickables === false && !force;
            if (isClicking) {
                $5a019fe42b4630c1$var$_addListener(e.target, "change", onRelease); //in some browsers, when you mousedown on a <select> element, no mouseup gets dispatched! So we listen for a "change" event instead.
                $5a019fe42b4630c1$var$_dispatchEvent(self, "pressInit", "onPressInit");
                $5a019fe42b4630c1$var$_dispatchEvent(self, "press", "onPress");
                $5a019fe42b4630c1$var$_setSelectable(triggers, true); //accommodates things like inputs and elements with contentEditable="true" (otherwise user couldn't drag to select text)
                isPreventingDefault = false;
                return;
            }
            allowNativeTouchScrolling = !touchEventTarget || allowX === allowY || self.vars.allowNativeTouchScrolling === false || self.vars.allowContextMenu && e && (e.ctrlKey || e.which > 2) ? false : allowX ? "y" : "x"; //note: in Chrome, right-clicking (for a context menu) fires onPress and it doesn't have the event.which set properly, so we must look for event.ctrlKey. If the user wants to allow context menus we should of course sense it here and not allow native touch scrolling.
            isPreventingDefault = !allowNativeTouchScrolling && !self.allowEventDefault;
            if (isPreventingDefault) {
                $5a019fe42b4630c1$var$_preventDefault(e);
                $5a019fe42b4630c1$var$_addListener($5a019fe42b4630c1$var$_win, "touchforcechange", $5a019fe42b4630c1$var$_preventDefault); //works around safari bug: https://gsap.com/forums/topic/21450-draggable-in-iframe-on-mobile-is-buggy/
            }
            if (e.changedTouches) {
                //touch events store the data slightly differently
                e = touch = e.changedTouches[0];
                touchID = e.identifier;
            } else if (e.pointerId) touchID = e.pointerId; //for some Microsoft browsers
            else touch = touchID = null;
            $5a019fe42b4630c1$var$_dragCount++;
            $5a019fe42b4630c1$var$_addToRenderQueue(render); //causes the Draggable to render on each "tick" of gsap.ticker (performance optimization - updating values in a mousemove can cause them to happen too frequently, like multiple times between frame redraws which is wasteful, and it also prevents values from updating properly in IE8)
            startPointerY = self.pointerY = e.pageY; //record the starting x and y so that we can calculate the movement from the original in _onMouseMove
            startPointerX = self.pointerX = e.pageX;
            $5a019fe42b4630c1$var$_dispatchEvent(self, "pressInit", "onPressInit");
            if (allowNativeTouchScrolling || self.autoScroll) $5a019fe42b4630c1$var$_recordMaxScrolls(target.parentNode);
            if (target.parentNode && self.autoScroll && !scrollProxy && !rotationMode && target.parentNode._gsMaxScrollX && !$5a019fe42b4630c1$var$_placeholderDiv.parentNode && !target.getBBox) {
                //add a placeholder div to prevent the parent container from collapsing when the user drags the element left.
                $5a019fe42b4630c1$var$_placeholderDiv.style.width = target.parentNode.scrollWidth + "px";
                target.parentNode.appendChild($5a019fe42b4630c1$var$_placeholderDiv);
            }
            recordStartPositions();
            self.tween && self.tween.kill();
            self.isThrowing = false;
            $5a019fe42b4630c1$var$gsap.killTweensOf(scrollProxy || target, killProps, true); //in case the user tries to drag it before the last tween is done.
            scrollProxy && $5a019fe42b4630c1$var$gsap.killTweensOf(target, {
                scrollTo: 1
            }, true); //just in case the original target's scroll position is being tweened somewhere else.
            self.tween = self.lockedAxis = null;
            if (vars.zIndexBoost || !rotationMode && !scrollProxy && vars.zIndexBoost !== false) target.style.zIndex = Draggable.zIndex++;
            self.isPressed = true;
            hasDragCallback = !!(vars.onDrag || self._listeners.drag);
            hasMoveCallback = !!(vars.onMove || self._listeners.move);
            if (vars.cursor !== false || vars.activeCursor) {
                i = triggers.length;
                while(--i > -1)$5a019fe42b4630c1$var$gsap.set(triggers[i], {
                    cursor: vars.activeCursor || vars.cursor || ($5a019fe42b4630c1$var$_defaultCursor === "grab" ? "grabbing" : $5a019fe42b4630c1$var$_defaultCursor)
                });
            }
            $5a019fe42b4630c1$var$_dispatchEvent(self, "press", "onPress"); // reset the velocity tracking because it's relatively common to suddenly change position in an onPress() or onPressInit()
            $5a019fe42b4630c1$var$InertiaPlugin && $5a019fe42b4630c1$var$InertiaPlugin.track(scrollProxy || target, xyMode ? "x,y" : rotationMode ? "rotation" : "top,left");
        }, //called every time the mouse/touch moves
        onMove = function onMove(e) {
            var originalEvent = e, touches, pointerX, pointerY, i, dx, dy;
            if (!enabled || $5a019fe42b4630c1$var$_isMultiTouching || !self.isPressed || !e) {
                isPreventingDefault && e && enabled && $5a019fe42b4630c1$var$_preventDefault(e); // in some browsers, we must listen for multiple event types like touchmove, pointermove, mousemove. The first time this function is called, we record whether or not we _preventDefault() so that on duplicate calls, we can do the same if necessary.
                return;
            }
            self.pointerEvent = e;
            touches = e.changedTouches;
            if (touches) {
                //touch events store the data slightly differently
                e = touches[0];
                if (e !== touch && e.identifier !== touchID) {
                    //Usually changedTouches[0] will be what we're looking for, but in case it's not, look through the rest of the array...(and Android browsers don't reuse the event like iOS)
                    i = touches.length;
                    while(--i > -1 && (e = touches[i]).identifier !== touchID && e.target !== target); // Some Android devices dispatch a touchstart AND pointerdown initially, and then only pointermove thus the touchID may not match because it was grabbed from the touchstart event whereas the pointer event is the one that the browser dispatches for move, so if the event target matches this Draggable's target, let it through.
                    if (i < 0) return;
                }
            } else if (e.pointerId && touchID && e.pointerId !== touchID) //for some Microsoft browsers, we must attach the listener to the doc rather than the trigger so that when the finger moves outside the bounds of the trigger, things still work. So if the event we're receiving has a pointerId that doesn't match the touchID, ignore it (for multi-touch)
            return;
            if (touchEventTarget && allowNativeTouchScrolling && !touchDragAxis) {
                //Android browsers force us to decide on the first "touchmove" event if we should allow the default (scrolling) behavior or preventDefault(). Otherwise, a "touchcancel" will be fired and then no "touchmove" or "touchend" will fire during the scrolling (no good).
                $5a019fe42b4630c1$var$_point1.x = e.pageX - (isFixed ? $5a019fe42b4630c1$var$_getDocScrollLeft(ownerDoc) : 0);
                $5a019fe42b4630c1$var$_point1.y = e.pageY - (isFixed ? $5a019fe42b4630c1$var$_getDocScrollTop(ownerDoc) : 0);
                matrix && matrix.apply($5a019fe42b4630c1$var$_point1, $5a019fe42b4630c1$var$_point1);
                pointerX = $5a019fe42b4630c1$var$_point1.x;
                pointerY = $5a019fe42b4630c1$var$_point1.y;
                dx = Math.abs(pointerX - startPointerX);
                dy = Math.abs(pointerY - startPointerY);
                if (dx !== dy && (dx > minimumMovement || dy > minimumMovement) || $5a019fe42b4630c1$var$_isAndroid && allowNativeTouchScrolling === touchDragAxis) {
                    touchDragAxis = dx > dy && allowX ? "x" : "y";
                    if (allowNativeTouchScrolling && touchDragAxis !== allowNativeTouchScrolling) $5a019fe42b4630c1$var$_addListener($5a019fe42b4630c1$var$_win, "touchforcechange", $5a019fe42b4630c1$var$_preventDefault); // prevents native touch scrolling from taking over if the user started dragging in the other direction in iOS Safari
                    if (self.vars.lockAxisOnTouchScroll !== false && allowX && allowY) {
                        self.lockedAxis = touchDragAxis === "x" ? "y" : "x";
                        $5a019fe42b4630c1$var$_isFunction(self.vars.onLockAxis) && self.vars.onLockAxis.call(self, originalEvent);
                    }
                    if ($5a019fe42b4630c1$var$_isAndroid && allowNativeTouchScrolling === touchDragAxis) {
                        onRelease(originalEvent);
                        return;
                    }
                }
            }
            if (!self.allowEventDefault && (!allowNativeTouchScrolling || touchDragAxis && allowNativeTouchScrolling !== touchDragAxis) && originalEvent.cancelable !== false) {
                $5a019fe42b4630c1$var$_preventDefault(originalEvent);
                isPreventingDefault = true;
            } else if (isPreventingDefault) isPreventingDefault = false;
            if (self.autoScroll) checkAutoScrollBounds = true;
            setPointerPosition(e.pageX, e.pageY, hasMoveCallback);
        }, setPointerPosition = function setPointerPosition(pointerX, pointerY, invokeOnMove) {
            var dragTolerance = 1 - self.dragResistance, edgeTolerance = 1 - self.edgeResistance, prevPointerX = self.pointerX, prevPointerY = self.pointerY, prevStartElementY = startElementY, prevX = self.x, prevY = self.y, prevEndX = self.endX, prevEndY = self.endY, prevEndRotation = self.endRotation, prevDirty = dirty, xChange, yChange, x, y, dif, temp;
            self.pointerX = pointerX;
            self.pointerY = pointerY;
            if (isFixed) {
                pointerX -= $5a019fe42b4630c1$var$_getDocScrollLeft(ownerDoc);
                pointerY -= $5a019fe42b4630c1$var$_getDocScrollTop(ownerDoc);
            }
            if (rotationMode) {
                y = $5a019fe42b4630c1$var$_round(Math.atan2(rotationOrigin.y - pointerY, pointerX - rotationOrigin.x) * $5a019fe42b4630c1$var$_RAD2DEG);
                dif = self.y - y;
                if (dif > 180) {
                    startElementY -= 360;
                    self.y = y;
                } else if (dif < -180) {
                    startElementY += 360;
                    self.y = y;
                }
                if (matrix) {
                    temp = pointerX * matrix.a + pointerY * matrix.c + matrix.e;
                    pointerY = pointerX * matrix.b + pointerY * matrix.d + matrix.f;
                    pointerX = temp;
                }
                if (self.x !== startElementX || Math.max(Math.abs(startPointerX - pointerX), Math.abs(startPointerY - pointerY)) > minimumMovement) {
                    self.y = y;
                    x = $5a019fe42b4630c1$var$_round(startElementX + (startElementY - y) * dragTolerance);
                } else x = startElementX;
            } else {
                if (matrix) {
                    temp = pointerX * matrix.a + pointerY * matrix.c + matrix.e;
                    pointerY = pointerX * matrix.b + pointerY * matrix.d + matrix.f;
                    pointerX = temp;
                }
                yChange = pointerY - startPointerY;
                xChange = pointerX - startPointerX;
                if (yChange < minimumMovement && yChange > -minimumMovement) yChange = 0;
                if (xChange < minimumMovement && xChange > -minimumMovement) xChange = 0;
                if ((self.lockAxis || self.lockedAxis) && (xChange || yChange)) {
                    temp = self.lockedAxis;
                    if (!temp) {
                        self.lockedAxis = temp = allowX && Math.abs(xChange) > Math.abs(yChange) ? "y" : allowY ? "x" : null;
                        if (temp && $5a019fe42b4630c1$var$_isFunction(self.vars.onLockAxis)) self.vars.onLockAxis.call(self, self.pointerEvent);
                    }
                    if (temp === "y") yChange = 0;
                    else if (temp === "x") xChange = 0;
                }
                x = $5a019fe42b4630c1$var$_round(startElementX + xChange * dragTolerance);
                y = $5a019fe42b4630c1$var$_round(startElementY + yChange * dragTolerance);
            }
            if ((snapX || snapY || snapXY) && (self.x !== x || self.y !== y && !rotationMode)) {
                if (snapXY) {
                    $5a019fe42b4630c1$var$_temp1.x = x;
                    $5a019fe42b4630c1$var$_temp1.y = y;
                    temp = snapXY($5a019fe42b4630c1$var$_temp1);
                    x = $5a019fe42b4630c1$var$_round(temp.x);
                    y = $5a019fe42b4630c1$var$_round(temp.y);
                }
                if (snapX) x = $5a019fe42b4630c1$var$_round(snapX(x));
                if (snapY) y = $5a019fe42b4630c1$var$_round(snapY(y));
            }
            if (hasBounds) {
                if (x > maxX) x = maxX + Math.round((x - maxX) * edgeTolerance);
                else if (x < minX) x = minX + Math.round((x - minX) * edgeTolerance);
                if (!rotationMode) {
                    if (y > maxY) y = Math.round(maxY + (y - maxY) * edgeTolerance);
                    else if (y < minY) y = Math.round(minY + (y - minY) * edgeTolerance);
                }
            }
            if (self.x !== x || self.y !== y && !rotationMode) {
                if (rotationMode) {
                    self.endRotation = self.x = self.endX = $5a019fe42b4630c1$var$_round(x);
                    dirty = true;
                } else {
                    if (allowY) {
                        self.y = self.endY = y;
                        dirty = true; //a flag that indicates we need to render the target next time the TweenLite.ticker dispatches a "tick" event (typically on a requestAnimationFrame) - this is a performance optimization (we shouldn't render on every move because sometimes many move events can get dispatched between screen refreshes, and that'd be wasteful to render every time)
                    }
                    if (allowX) {
                        self.x = self.endX = x;
                        dirty = true;
                    }
                }
                if (!invokeOnMove || $5a019fe42b4630c1$var$_dispatchEvent(self, "move", "onMove") !== false) {
                    if (!self.isDragging && self.isPressed) {
                        self.isDragging = dragged = true;
                        $5a019fe42b4630c1$var$_dispatchEvent(self, "dragstart", "onDragStart");
                    }
                } else {
                    //revert because the onMove returned false!
                    self.pointerX = prevPointerX;
                    self.pointerY = prevPointerY;
                    startElementY = prevStartElementY;
                    self.x = prevX;
                    self.y = prevY;
                    self.endX = prevEndX;
                    self.endY = prevEndY;
                    self.endRotation = prevEndRotation;
                    dirty = prevDirty;
                }
            }
        }, //called when the mouse/touch is released
        onRelease = function onRelease(e, force) {
            if (!enabled || !self.isPressed || e && touchID != null && !force && (e.pointerId && e.pointerId !== touchID && e.target !== target || e.changedTouches && !$5a019fe42b4630c1$var$_hasTouchID(e.changedTouches, touchID))) {
                //for some Microsoft browsers, we must attach the listener to the doc rather than the trigger so that when the finger moves outside the bounds of the trigger, things still work. So if the event we're receiving has a pointerId that doesn't match the touchID, ignore it (for multi-touch)
                isPreventingDefault && e && enabled && $5a019fe42b4630c1$var$_preventDefault(e); // in some browsers, we must listen for multiple event types like touchend, pointerup, mouseup. The first time this function is called, we record whether or not we _preventDefault() so that on duplicate calls, we can do the same if necessary.
                return;
            }
            self.isPressed = false;
            var originalEvent = e, wasDragging = self.isDragging, isContextMenuRelease = self.vars.allowContextMenu && e && (e.ctrlKey || e.which > 2), placeholderDelayedCall = $5a019fe42b4630c1$var$gsap.delayedCall(0.001, removePlaceholder), touches, i, syntheticEvent, eventTarget, syntheticClick;
            if (touchEventTarget) {
                $5a019fe42b4630c1$var$_removeListener(touchEventTarget, "touchend", onRelease);
                $5a019fe42b4630c1$var$_removeListener(touchEventTarget, "touchmove", onMove);
                $5a019fe42b4630c1$var$_removeListener(touchEventTarget, "touchcancel", onRelease);
                $5a019fe42b4630c1$var$_removeListener(ownerDoc, "touchstart", $5a019fe42b4630c1$var$_onMultiTouchDocument);
            } else $5a019fe42b4630c1$var$_removeListener(ownerDoc, "mousemove", onMove);
            $5a019fe42b4630c1$var$_removeListener($5a019fe42b4630c1$var$_win, "touchforcechange", $5a019fe42b4630c1$var$_preventDefault);
            if (!$5a019fe42b4630c1$var$_supportsPointer || !touchEventTarget) {
                $5a019fe42b4630c1$var$_removeListener(ownerDoc, "mouseup", onRelease);
                e && e.target && $5a019fe42b4630c1$var$_removeListener(e.target, "mouseup", onRelease);
            }
            dirty = false;
            if (wasDragging) {
                dragEndTime = $5a019fe42b4630c1$var$_lastDragTime = $5a019fe42b4630c1$var$_getTime();
                self.isDragging = false;
            }
            $5a019fe42b4630c1$var$_removeFromRenderQueue(render);
            if (isClicking && !isContextMenuRelease) {
                if (e) {
                    $5a019fe42b4630c1$var$_removeListener(e.target, "change", onRelease);
                    self.pointerEvent = originalEvent;
                }
                $5a019fe42b4630c1$var$_setSelectable(triggers, false);
                $5a019fe42b4630c1$var$_dispatchEvent(self, "release", "onRelease");
                $5a019fe42b4630c1$var$_dispatchEvent(self, "click", "onClick");
                isClicking = false;
                return;
            }
            i = triggers.length;
            while(--i > -1)$5a019fe42b4630c1$var$_setStyle(triggers[i], "cursor", vars.cursor || (vars.cursor !== false ? $5a019fe42b4630c1$var$_defaultCursor : null));
            $5a019fe42b4630c1$var$_dragCount--;
            if (e) {
                touches = e.changedTouches;
                if (touches) {
                    //touch events store the data slightly differently
                    e = touches[0];
                    if (e !== touch && e.identifier !== touchID) {
                        //Usually changedTouches[0] will be what we're looking for, but in case it's not, look through the rest of the array...(and Android browsers don't reuse the event like iOS)
                        i = touches.length;
                        while(--i > -1 && (e = touches[i]).identifier !== touchID && e.target !== target);
                        if (i < 0 && !force) return;
                    }
                }
                self.pointerEvent = originalEvent;
                self.pointerX = e.pageX;
                self.pointerY = e.pageY;
            }
            if (isContextMenuRelease && originalEvent) {
                $5a019fe42b4630c1$var$_preventDefault(originalEvent);
                isPreventingDefault = true;
                $5a019fe42b4630c1$var$_dispatchEvent(self, "release", "onRelease");
            } else if (originalEvent && !wasDragging) {
                isPreventingDefault = false;
                if (interrupted && (vars.snap || vars.bounds)) //otherwise, if the user clicks on the object while it's animating to a snapped position, and then releases without moving 3 pixels, it will just stay there (it should animate/snap)
                animate(vars.inertia || vars.throwProps);
                $5a019fe42b4630c1$var$_dispatchEvent(self, "release", "onRelease");
                if ((!$5a019fe42b4630c1$var$_isAndroid || originalEvent.type !== "touchmove") && originalEvent.type.indexOf("cancel") === -1) {
                    //to accommodate native scrolling on Android devices, we have to immediately call onRelease() on the first touchmove event, but that shouldn't trigger a "click".
                    $5a019fe42b4630c1$var$_dispatchEvent(self, "click", "onClick");
                    if ($5a019fe42b4630c1$var$_getTime() - clickTime < 300) $5a019fe42b4630c1$var$_dispatchEvent(self, "doubleclick", "onDoubleClick");
                    eventTarget = originalEvent.target || target; //old IE uses srcElement
                    clickTime = $5a019fe42b4630c1$var$_getTime();
                    syntheticClick = function syntheticClick() {
                        // some browsers (like Firefox) won't trust script-generated clicks, so if the user tries to click on a video to play it, for example, it simply won't work. Since a regular "click" event will most likely be generated anyway (one that has its isTrusted flag set to true), we must slightly delay our script-generated click so that the "real"/trusted one is prioritized. Remember, when there are duplicate events in quick succession, we suppress all but the first one. Some browsers don't even trigger the "real" one at all, so our synthetic one is a safety valve that ensures that no matter what, a click event does get dispatched.
                        if (clickTime !== clickDispatch && self.enabled() && !self.isPressed && !originalEvent.defaultPrevented) {
                            if (eventTarget.click) //some browsers (like mobile Safari) don't properly trigger the click event
                            eventTarget.click();
                            else if (ownerDoc.createEvent) {
                                syntheticEvent = ownerDoc.createEvent("MouseEvents");
                                syntheticEvent.initMouseEvent("click", true, true, $5a019fe42b4630c1$var$_win, 1, self.pointerEvent.screenX, self.pointerEvent.screenY, self.pointerX, self.pointerY, false, false, false, false, 0, null);
                                eventTarget.dispatchEvent(syntheticEvent);
                            }
                        }
                    };
                    if (!$5a019fe42b4630c1$var$_isAndroid && !originalEvent.defaultPrevented) //iOS Safari requires the synthetic click to happen immediately or else it simply won't work, but Android doesn't play nice.
                    $5a019fe42b4630c1$var$gsap.delayedCall(0.05, syntheticClick); //in addition to the iOS bug workaround, there's a Firefox issue with clicking on things like a video to play, so we must fake a click event in a slightly delayed fashion. Previously, we listened for the "click" event with "capture" false which solved the video-click-to-play issue, but it would allow the "click" event to be dispatched twice like if you were using a jQuery.click() because that was handled in the capture phase, thus we had to switch to the capture phase to avoid the double-dispatching, but do the delayed synthetic click. Don't fire it too fast (like 0.00001) because we want to give the native event a chance to fire first as it's "trusted".
                }
            } else {
                animate(vars.inertia || vars.throwProps); //will skip if inertia/throwProps isn't defined or InertiaPlugin isn't loaded.
                if (!self.allowEventDefault && originalEvent && (vars.dragClickables !== false || !isClickable.call(self, originalEvent.target)) && wasDragging && (!allowNativeTouchScrolling || touchDragAxis && allowNativeTouchScrolling === touchDragAxis) && originalEvent.cancelable !== false) {
                    isPreventingDefault = true;
                    $5a019fe42b4630c1$var$_preventDefault(originalEvent);
                } else isPreventingDefault = false;
                $5a019fe42b4630c1$var$_dispatchEvent(self, "release", "onRelease");
            }
            isTweening() && placeholderDelayedCall.duration(self.tween.duration()); //sync the timing so that the placeholder DIV gets
            wasDragging && $5a019fe42b4630c1$var$_dispatchEvent(self, "dragend", "onDragEnd");
            return true;
        }, updateScroll = function updateScroll(e) {
            if (e && self.isDragging && !scrollProxy) {
                var parent = e.target || target.parentNode, deltaX = parent.scrollLeft - parent._gsScrollX, deltaY = parent.scrollTop - parent._gsScrollY;
                if (deltaX || deltaY) {
                    if (matrix) {
                        startPointerX -= deltaX * matrix.a + deltaY * matrix.c;
                        startPointerY -= deltaY * matrix.d + deltaX * matrix.b;
                    } else {
                        startPointerX -= deltaX;
                        startPointerY -= deltaY;
                    }
                    parent._gsScrollX += deltaX;
                    parent._gsScrollY += deltaY;
                    setPointerPosition(self.pointerX, self.pointerY);
                }
            }
        }, onClick = function onClick(e) {
            //this was a huge pain in the neck to align all the various browsers and their behaviors. Chrome, Firefox, Safari, Opera, Android, and Microsoft Edge all handle events differently! Some will only trigger native behavior (like checkbox toggling) from trusted events. Others don't even support isTrusted, but require 2 events to flow through before triggering native behavior. Edge treats everything as trusted but also mandates that 2 flow through to trigger the correct native behavior.
            var time = $5a019fe42b4630c1$var$_getTime(), recentlyClicked = time - clickTime < 100, recentlyDragged = time - dragEndTime < 50, alreadyDispatched = recentlyClicked && clickDispatch === clickTime, defaultPrevented = self.pointerEvent && self.pointerEvent.defaultPrevented, alreadyDispatchedTrusted = recentlyClicked && trustedClickDispatch === clickTime, trusted = e.isTrusted || e.isTrusted == null && recentlyClicked && alreadyDispatched; //note: Safari doesn't support isTrusted, and it won't properly execute native behavior (like toggling checkboxes) on the first synthetic "click" event - we must wait for the 2nd and treat it as trusted (but stop propagation at that point). Confusing, I know. Don't you love cross-browser compatibility challenges?
            if ((alreadyDispatched || recentlyDragged && self.vars.suppressClickOnDrag !== false) && e.stopImmediatePropagation) e.stopImmediatePropagation();
            if (recentlyClicked && !(self.pointerEvent && self.pointerEvent.defaultPrevented) && (!alreadyDispatched || trusted && !alreadyDispatchedTrusted)) {
                //let the first click pass through unhindered. Let the next one only if it's trusted, then no more (stop quick-succession ones)
                if (trusted && alreadyDispatched) trustedClickDispatch = clickTime;
                clickDispatch = clickTime;
                return;
            }
            if (self.isPressed || recentlyDragged || recentlyClicked) {
                if (!trusted || !e.detail || !recentlyClicked || defaultPrevented) $5a019fe42b4630c1$var$_preventDefault(e);
            }
            if (!recentlyClicked && !recentlyDragged && !dragged) {
                // for script-triggered event dispatches, like element.click()
                e && e.target && (self.pointerEvent = e);
                $5a019fe42b4630c1$var$_dispatchEvent(self, "click", "onClick");
            }
        }, localizePoint = function localizePoint(p) {
            return matrix ? {
                x: p.x * matrix.a + p.y * matrix.c + matrix.e,
                y: p.x * matrix.b + p.y * matrix.d + matrix.f
            } : {
                x: p.x,
                y: p.y
            };
        };
        old = Draggable.get(target);
        old && old.kill(); // avoids duplicates (an element can only be controlled by one Draggable)
        //give the user access to start/stop dragging...
        _this2.startDrag = function(event, align) {
            var r1, r2, p1, p2;
            onPress(event || self.pointerEvent, true); //if the pointer isn't on top of the element, adjust things accordingly
            if (align && !self.hitTest(event || self.pointerEvent)) {
                r1 = $5a019fe42b4630c1$var$_parseRect(event || self.pointerEvent);
                r2 = $5a019fe42b4630c1$var$_parseRect(target);
                p1 = localizePoint({
                    x: r1.left + r1.width / 2,
                    y: r1.top + r1.height / 2
                });
                p2 = localizePoint({
                    x: r2.left + r2.width / 2,
                    y: r2.top + r2.height / 2
                });
                startPointerX -= p1.x - p2.x;
                startPointerY -= p1.y - p2.y;
            }
            if (!self.isDragging) {
                self.isDragging = dragged = true;
                $5a019fe42b4630c1$var$_dispatchEvent(self, "dragstart", "onDragStart");
            }
        };
        _this2.drag = onMove;
        _this2.endDrag = function(e) {
            return onRelease(e || self.pointerEvent, true);
        };
        _this2.timeSinceDrag = function() {
            return self.isDragging ? 0 : ($5a019fe42b4630c1$var$_getTime() - dragEndTime) / 1000;
        };
        _this2.timeSinceClick = function() {
            return ($5a019fe42b4630c1$var$_getTime() - clickTime) / 1000;
        };
        _this2.hitTest = function(target, threshold) {
            return Draggable.hitTest(self.target, target, threshold);
        };
        _this2.getDirection = function(from, diagonalThreshold) {
            //from can be "start" (default), "velocity", or an element
            var mode = from === "velocity" && $5a019fe42b4630c1$var$InertiaPlugin ? from : $5a019fe42b4630c1$var$_isObject(from) && !rotationMode ? "element" : "start", xChange, yChange, ratio, direction, r1, r2;
            if (mode === "element") {
                r1 = $5a019fe42b4630c1$var$_parseRect(self.target);
                r2 = $5a019fe42b4630c1$var$_parseRect(from);
            }
            xChange = mode === "start" ? self.x - startElementX : mode === "velocity" ? $5a019fe42b4630c1$var$InertiaPlugin.getVelocity(target, xProp) : r1.left + r1.width / 2 - (r2.left + r2.width / 2);
            if (rotationMode) return xChange < 0 ? "counter-clockwise" : "clockwise";
            else {
                diagonalThreshold = diagonalThreshold || 2;
                yChange = mode === "start" ? self.y - startElementY : mode === "velocity" ? $5a019fe42b4630c1$var$InertiaPlugin.getVelocity(target, yProp) : r1.top + r1.height / 2 - (r2.top + r2.height / 2);
                ratio = Math.abs(xChange / yChange);
                direction = ratio < 1 / diagonalThreshold ? "" : xChange < 0 ? "left" : "right";
                if (ratio < diagonalThreshold) {
                    if (direction !== "") direction += "-";
                    direction += yChange < 0 ? "up" : "down";
                }
            }
            return direction;
        };
        _this2.applyBounds = function(newBounds, sticky) {
            var x, y, forceZeroVelocity, e, parent, isRoot;
            if (newBounds && vars.bounds !== newBounds) {
                vars.bounds = newBounds;
                return self.update(true, sticky);
            }
            syncXY(true);
            calculateBounds();
            if (hasBounds && !isTweening()) {
                x = self.x;
                y = self.y;
                if (x > maxX) x = maxX;
                else if (x < minX) x = minX;
                if (y > maxY) y = maxY;
                else if (y < minY) y = minY;
                if (self.x !== x || self.y !== y) {
                    forceZeroVelocity = true;
                    self.x = self.endX = x;
                    if (rotationMode) self.endRotation = x;
                    else self.y = self.endY = y;
                    dirty = true;
                    render(true);
                    if (self.autoScroll && !self.isDragging) {
                        $5a019fe42b4630c1$var$_recordMaxScrolls(target.parentNode);
                        e = target;
                        $5a019fe42b4630c1$var$_windowProxy.scrollTop = $5a019fe42b4630c1$var$_win.pageYOffset != null ? $5a019fe42b4630c1$var$_win.pageYOffset : ownerDoc.documentElement.scrollTop != null ? ownerDoc.documentElement.scrollTop : ownerDoc.body.scrollTop;
                        $5a019fe42b4630c1$var$_windowProxy.scrollLeft = $5a019fe42b4630c1$var$_win.pageXOffset != null ? $5a019fe42b4630c1$var$_win.pageXOffset : ownerDoc.documentElement.scrollLeft != null ? ownerDoc.documentElement.scrollLeft : ownerDoc.body.scrollLeft;
                        while(e && !isRoot){
                            //walk up the chain and sense wherever the scrollTop/scrollLeft exceeds the maximum.
                            isRoot = $5a019fe42b4630c1$var$_isRoot(e.parentNode);
                            parent = isRoot ? $5a019fe42b4630c1$var$_windowProxy : e.parentNode;
                            if (allowY && parent.scrollTop > parent._gsMaxScrollY) parent.scrollTop = parent._gsMaxScrollY;
                            if (allowX && parent.scrollLeft > parent._gsMaxScrollX) parent.scrollLeft = parent._gsMaxScrollX;
                            e = parent;
                        }
                    }
                }
                if (self.isThrowing && (forceZeroVelocity || self.endX > maxX || self.endX < minX || self.endY > maxY || self.endY < minY)) animate(vars.inertia || vars.throwProps, forceZeroVelocity);
            }
            return self;
        };
        _this2.update = function(applyBounds, sticky, ignoreExternalChanges) {
            if (sticky && self.isPressed) {
                // in case the element was repositioned in the document flow, thus its x/y may be identical but its position is actually quite different.
                if (rotationMode) self.x = self.y = $5a019fe42b4630c1$var$_round(parseFloat(gsCache.rotation));
                else {
                    var m = (0, $e1498ade04c27c48$export$91a495f99cf781b7)(target), p = innerMatrix.apply({
                        x: self.x - startElementX,
                        y: self.y - startElementY
                    }), m2 = (0, $e1498ade04c27c48$export$91a495f99cf781b7)(target.parentNode, true);
                    m2.apply({
                        x: m.e - p.x,
                        y: m.f - p.y
                    }, p);
                    self.x = $5a019fe42b4630c1$var$_round(self.x - (p.x - m2.e));
                    self.y = $5a019fe42b4630c1$var$_round(self.y - (p.y - m2.f));
                }
                render(true);
                recordStartPositions();
            }
            var x = self.x, y = self.y;
            updateMatrix(!sticky);
            if (applyBounds) self.applyBounds();
            else {
                dirty && ignoreExternalChanges && render(true);
                syncXY(true);
            }
            if (sticky) {
                setPointerPosition(self.pointerX, self.pointerY);
                dirty && render(true);
            }
            if (self.isPressed && !sticky && (allowX && Math.abs(x - self.x) > 0.01 || allowY && Math.abs(y - self.y) > 0.01 && !rotationMode)) recordStartPositions();
            if (self.autoScroll) {
                $5a019fe42b4630c1$var$_recordMaxScrolls(target.parentNode, self.isDragging);
                checkAutoScrollBounds = self.isDragging;
                render(true); //in case reparenting occurred.
                $5a019fe42b4630c1$var$_removeScrollListener(target, updateScroll);
                $5a019fe42b4630c1$var$_addScrollListener(target, updateScroll);
            }
            return self;
        };
        _this2.enable = function(type) {
            var setVars = {
                lazy: true
            }, id, i, trigger;
            if (vars.cursor !== false) setVars.cursor = vars.cursor || $5a019fe42b4630c1$var$_defaultCursor;
            if ($5a019fe42b4630c1$var$gsap.utils.checkPrefix("touchCallout")) setVars.touchCallout = "none";
            if (type !== "soft") {
                $5a019fe42b4630c1$var$_setTouchActionForAllDescendants(triggers, allowX === allowY ? "none" : vars.allowNativeTouchScrolling && target.scrollHeight === target.clientHeight === (target.scrollWidth === target.clientHeight) || vars.allowEventDefault ? "manipulation" : allowX ? "pan-y" : "pan-x"); // Some browsers like Internet Explorer will fire a pointercancel event when the user attempts to drag when touchAction is "manipulate" because it's perceived as a pan. If the element has scrollable content in only one direction, we should use pan-x or pan-y accordingly so that the pointercancel doesn't prevent dragging.
                i = triggers.length;
                while(--i > -1){
                    trigger = triggers[i];
                    $5a019fe42b4630c1$var$_supportsPointer || $5a019fe42b4630c1$var$_addListener(trigger, "mousedown", onPress);
                    $5a019fe42b4630c1$var$_addListener(trigger, "touchstart", onPress);
                    $5a019fe42b4630c1$var$_addListener(trigger, "click", onClick, true); // note: used to pass true for capture but it prevented click-to-play-video functionality in Firefox.
                    $5a019fe42b4630c1$var$gsap.set(trigger, setVars);
                    if (trigger.getBBox && trigger.ownerSVGElement && allowX !== allowY) // a bug in chrome doesn't respect touch-action on SVG elements - it only works if we set it on the parent SVG.
                    $5a019fe42b4630c1$var$gsap.set(trigger.ownerSVGElement, {
                        touchAction: vars.allowNativeTouchScrolling || vars.allowEventDefault ? "manipulation" : allowX ? "pan-y" : "pan-x"
                    });
                    vars.allowContextMenu || $5a019fe42b4630c1$var$_addListener(trigger, "contextmenu", onContextMenu);
                }
                $5a019fe42b4630c1$var$_setSelectable(triggers, false);
            }
            $5a019fe42b4630c1$var$_addScrollListener(target, updateScroll);
            enabled = true;
            if ($5a019fe42b4630c1$var$InertiaPlugin && type !== "soft") $5a019fe42b4630c1$var$InertiaPlugin.track(scrollProxy || target, xyMode ? "x,y" : rotationMode ? "rotation" : "top,left");
            target._gsDragID = id = target._gsDragID || "d" + $5a019fe42b4630c1$var$_lookupCount++;
            $5a019fe42b4630c1$var$_lookup[id] = self;
            if (scrollProxy) {
                scrollProxy.enable();
                scrollProxy.element._gsDragID = id;
            }
            (vars.bounds || rotationMode) && recordStartPositions();
            vars.bounds && self.applyBounds();
            return self;
        };
        _this2.disable = function(type) {
            var dragging = self.isDragging, i = triggers.length, trigger;
            while(--i > -1)$5a019fe42b4630c1$var$_setStyle(triggers[i], "cursor", null);
            if (type !== "soft") {
                $5a019fe42b4630c1$var$_setTouchActionForAllDescendants(triggers, null);
                i = triggers.length;
                while(--i > -1){
                    trigger = triggers[i];
                    $5a019fe42b4630c1$var$_setStyle(trigger, "touchCallout", null);
                    $5a019fe42b4630c1$var$_removeListener(trigger, "mousedown", onPress);
                    $5a019fe42b4630c1$var$_removeListener(trigger, "touchstart", onPress);
                    $5a019fe42b4630c1$var$_removeListener(trigger, "click", onClick, true);
                    $5a019fe42b4630c1$var$_removeListener(trigger, "contextmenu", onContextMenu);
                }
                $5a019fe42b4630c1$var$_setSelectable(triggers, true);
                if (touchEventTarget) {
                    $5a019fe42b4630c1$var$_removeListener(touchEventTarget, "touchcancel", onRelease);
                    $5a019fe42b4630c1$var$_removeListener(touchEventTarget, "touchend", onRelease);
                    $5a019fe42b4630c1$var$_removeListener(touchEventTarget, "touchmove", onMove);
                }
                $5a019fe42b4630c1$var$_removeListener(ownerDoc, "mouseup", onRelease);
                $5a019fe42b4630c1$var$_removeListener(ownerDoc, "mousemove", onMove);
            }
            $5a019fe42b4630c1$var$_removeScrollListener(target, updateScroll);
            enabled = false;
            if ($5a019fe42b4630c1$var$InertiaPlugin && type !== "soft") {
                $5a019fe42b4630c1$var$InertiaPlugin.untrack(scrollProxy || target, xyMode ? "x,y" : rotationMode ? "rotation" : "top,left");
                self.tween && self.tween.kill();
            }
            scrollProxy && scrollProxy.disable();
            $5a019fe42b4630c1$var$_removeFromRenderQueue(render);
            self.isDragging = self.isPressed = isClicking = false;
            dragging && $5a019fe42b4630c1$var$_dispatchEvent(self, "dragend", "onDragEnd");
            return self;
        };
        _this2.enabled = function(value, type) {
            return arguments.length ? value ? self.enable(type) : self.disable(type) : enabled;
        };
        _this2.kill = function() {
            self.isThrowing = false;
            self.tween && self.tween.kill();
            self.disable();
            $5a019fe42b4630c1$var$gsap.set(triggers, {
                clearProps: "userSelect"
            });
            delete $5a019fe42b4630c1$var$_lookup[target._gsDragID];
            return self;
        };
        _this2.revert = function() {
            this.kill();
            this.styles && this.styles.revert();
        };
        if (~type.indexOf("scroll")) {
            scrollProxy = _this2.scrollProxy = new $5a019fe42b4630c1$var$ScrollProxy(target, $5a019fe42b4630c1$var$_extend({
                onKill: function onKill() {
                    //ScrollProxy's onKill() gets called if/when the ScrollProxy senses that the user interacted with the scroll position manually (like using the scrollbar). IE9 doesn't fire the "mouseup" properly when users drag the scrollbar of an element, so this works around that issue.
                    self.isPressed && onRelease(null);
                }
            }, vars)); //a bug in many Android devices' stock browser causes scrollTop to get forced back to 0 after it is altered via JS, so we set overflow to "hidden" on mobile/touch devices (they hide the scroll bar anyway). That works around the bug. (This bug is discussed at https://code.google.com/p/android/issues/detail?id=19625)
            target.style.overflowY = allowY && !$5a019fe42b4630c1$var$_isTouchDevice ? "auto" : "hidden";
            target.style.overflowX = allowX && !$5a019fe42b4630c1$var$_isTouchDevice ? "auto" : "hidden";
            target = scrollProxy.content;
        }
        if (rotationMode) killProps.rotation = 1;
        else {
            if (allowX) killProps[xProp] = 1;
            if (allowY) killProps[yProp] = 1;
        }
        gsCache.force3D = "force3D" in vars ? vars.force3D : true; //otherwise, normal dragging would be in 2D and then as soon as it's released and there's an inertia tween, it'd jump to 3D which can create an initial jump due to the work the browser must to do layerize it.
        $5a019fe42b4630c1$var$_context($5a019fe42b4630c1$var$_assertThisInitialized(_this2));
        _this2.enable();
        return _this2;
    }
    Draggable.register = function register(core) {
        $5a019fe42b4630c1$var$gsap = core;
        $5a019fe42b4630c1$var$_initCore();
    };
    Draggable.create = function create(targets, vars) {
        $5a019fe42b4630c1$var$_coreInitted || $5a019fe42b4630c1$var$_initCore(true);
        return $5a019fe42b4630c1$var$_toArray(targets).map(function(target) {
            return new Draggable(target, vars);
        });
    };
    Draggable.get = function get(target) {
        return $5a019fe42b4630c1$var$_lookup[($5a019fe42b4630c1$var$_toArray(target)[0] || {})._gsDragID];
    };
    Draggable.timeSinceDrag = function timeSinceDrag() {
        return ($5a019fe42b4630c1$var$_getTime() - $5a019fe42b4630c1$var$_lastDragTime) / 1000;
    };
    Draggable.hitTest = function hitTest(obj1, obj2, threshold) {
        if (obj1 === obj2) return false;
        var r1 = $5a019fe42b4630c1$var$_parseRect(obj1), r2 = $5a019fe42b4630c1$var$_parseRect(obj2), top = r1.top, left = r1.left, right = r1.right, bottom = r1.bottom, width = r1.width, height = r1.height, isOutside = r2.left > right || r2.right < left || r2.top > bottom || r2.bottom < top, overlap, area, isRatio;
        if (isOutside || !threshold) return !isOutside;
        isRatio = (threshold + "").indexOf("%") !== -1;
        threshold = parseFloat(threshold) || 0;
        overlap = {
            left: Math.max(left, r2.left),
            top: Math.max(top, r2.top)
        };
        overlap.width = Math.min(right, r2.right) - overlap.left;
        overlap.height = Math.min(bottom, r2.bottom) - overlap.top;
        if (overlap.width < 0 || overlap.height < 0) return false;
        if (isRatio) {
            threshold *= 0.01;
            area = overlap.width * overlap.height;
            return area >= width * height * threshold || area >= r2.width * r2.height * threshold;
        }
        return overlap.width > threshold && overlap.height > threshold;
    };
    return Draggable;
}($5a019fe42b4630c1$var$EventDispatcher);
$5a019fe42b4630c1$var$_setDefaults($5a019fe42b4630c1$export$f2a139e5d18b9882.prototype, {
    pointerX: 0,
    pointerY: 0,
    startX: 0,
    startY: 0,
    deltaX: 0,
    deltaY: 0,
    isDragging: false,
    isPressed: false
});
$5a019fe42b4630c1$export$f2a139e5d18b9882.zIndex = 1000;
$5a019fe42b4630c1$export$f2a139e5d18b9882.version = "3.14.2";
$5a019fe42b4630c1$var$_getGSAP() && $5a019fe42b4630c1$var$gsap.registerPlugin($5a019fe42b4630c1$export$f2a139e5d18b9882);


// package.json
var $8ecb29f509dc0bd0$var$version = "1.3.17";
// packages/core/src/maths.ts
function $8ecb29f509dc0bd0$var$clamp(min, input, max) {
    return Math.max(min, Math.min(input, max));
}
function $8ecb29f509dc0bd0$var$lerp(x, y, t) {
    return (1 - t) * x + t * y;
}
function $8ecb29f509dc0bd0$var$damp(x, y, lambda, deltaTime) {
    return $8ecb29f509dc0bd0$var$lerp(x, y, 1 - Math.exp(-lambda * deltaTime));
}
function $8ecb29f509dc0bd0$var$modulo(n, d) {
    return (n % d + d) % d;
}
// packages/core/src/animate.ts
var $8ecb29f509dc0bd0$var$Animate = class {
    isRunning = false;
    value = 0;
    from = 0;
    to = 0;
    currentTime = 0;
    // These are instanciated in the fromTo method
    lerp;
    duration;
    easing;
    onUpdate;
    /**
   * Advance the animation by the given delta time
   *
   * @param deltaTime - The time in seconds to advance the animation
   */ advance(deltaTime) {
        if (!this.isRunning) return;
        let completed = false;
        if (this.duration && this.easing) {
            this.currentTime += deltaTime;
            const linearProgress = $8ecb29f509dc0bd0$var$clamp(0, this.currentTime / this.duration, 1);
            completed = linearProgress >= 1;
            const easedProgress = completed ? 1 : this.easing(linearProgress);
            this.value = this.from + (this.to - this.from) * easedProgress;
        } else if (this.lerp) {
            this.value = $8ecb29f509dc0bd0$var$damp(this.value, this.to, this.lerp * 60, deltaTime);
            if (Math.round(this.value) === this.to) {
                this.value = this.to;
                completed = true;
            }
        } else {
            this.value = this.to;
            completed = true;
        }
        if (completed) this.stop();
        this.onUpdate?.(this.value, completed);
    }
    /** Stop the animation */ stop() {
        this.isRunning = false;
    }
    /**
   * Set up the animation from a starting value to an ending value
   * with optional parameters for lerping, duration, easing, and onUpdate callback
   *
   * @param from - The starting value
   * @param to - The ending value
   * @param options - Options for the animation
   */ fromTo(from, to, { lerp: lerp2, duration: duration, easing: easing, onStart: onStart, onUpdate: onUpdate }) {
        this.from = this.value = from;
        this.to = to;
        this.lerp = lerp2;
        this.duration = duration;
        this.easing = easing;
        this.currentTime = 0;
        this.isRunning = true;
        onStart?.();
        this.onUpdate = onUpdate;
    }
};
// packages/core/src/debounce.ts
function $8ecb29f509dc0bd0$var$debounce(callback, delay) {
    let timer;
    return function(...args) {
        let context = this;
        clearTimeout(timer);
        timer = setTimeout(()=>{
            timer = void 0;
            callback.apply(context, args);
        }, delay);
    };
}
// packages/core/src/dimensions.ts
var $8ecb29f509dc0bd0$var$Dimensions = class {
    constructor(wrapper, content, { autoResize: autoResize = true, debounce: debounceValue = 250 } = {}){
        this.wrapper = wrapper;
        this.content = content;
        if (autoResize) {
            this.debouncedResize = $8ecb29f509dc0bd0$var$debounce(this.resize, debounceValue);
            if (this.wrapper instanceof Window) window.addEventListener("resize", this.debouncedResize, false);
            else {
                this.wrapperResizeObserver = new ResizeObserver(this.debouncedResize);
                this.wrapperResizeObserver.observe(this.wrapper);
            }
            this.contentResizeObserver = new ResizeObserver(this.debouncedResize);
            this.contentResizeObserver.observe(this.content);
        }
        this.resize();
    }
    width = 0;
    height = 0;
    scrollHeight = 0;
    scrollWidth = 0;
    // These are instanciated in the constructor as they need information from the options
    debouncedResize;
    wrapperResizeObserver;
    contentResizeObserver;
    destroy() {
        this.wrapperResizeObserver?.disconnect();
        this.contentResizeObserver?.disconnect();
        if (this.wrapper === window && this.debouncedResize) window.removeEventListener("resize", this.debouncedResize, false);
    }
    resize = ()=>{
        this.onWrapperResize();
        this.onContentResize();
    };
    onWrapperResize = ()=>{
        if (this.wrapper instanceof Window) {
            this.width = window.innerWidth;
            this.height = window.innerHeight;
        } else {
            this.width = this.wrapper.clientWidth;
            this.height = this.wrapper.clientHeight;
        }
    };
    onContentResize = ()=>{
        if (this.wrapper instanceof Window) {
            this.scrollHeight = this.content.scrollHeight;
            this.scrollWidth = this.content.scrollWidth;
        } else {
            this.scrollHeight = this.wrapper.scrollHeight;
            this.scrollWidth = this.wrapper.scrollWidth;
        }
    };
    get limit() {
        return {
            x: this.scrollWidth - this.width,
            y: this.scrollHeight - this.height
        };
    }
};
// packages/core/src/emitter.ts
var $8ecb29f509dc0bd0$var$Emitter = class {
    events = {};
    /**
   * Emit an event with the given data
   * @param event Event name
   * @param args Data to pass to the event handlers
   */ emit(event, ...args) {
        let callbacks = this.events[event] || [];
        for(let i = 0, length = callbacks.length; i < length; i++)callbacks[i]?.(...args);
    }
    /**
   * Add a callback to the event
   * @param event Event name
   * @param cb Callback function
   * @returns Unsubscribe function
   */ on(event, cb) {
        this.events[event]?.push(cb) || (this.events[event] = [
            cb
        ]);
        return ()=>{
            this.events[event] = this.events[event]?.filter((i)=>cb !== i);
        };
    }
    /**
   * Remove a callback from the event
   * @param event Event name
   * @param callback Callback function
   */ off(event, callback) {
        this.events[event] = this.events[event]?.filter((i)=>callback !== i);
    }
    /**
   * Remove all event listeners and clean up
   */ destroy() {
        this.events = {};
    }
};
// packages/core/src/virtual-scroll.ts
var $8ecb29f509dc0bd0$var$LINE_HEIGHT = 100 / 6;
var $8ecb29f509dc0bd0$var$listenerOptions = {
    passive: false
};
var $8ecb29f509dc0bd0$var$VirtualScroll = class {
    constructor(element, options = {
        wheelMultiplier: 1,
        touchMultiplier: 1
    }){
        this.element = element;
        this.options = options;
        window.addEventListener("resize", this.onWindowResize, false);
        this.onWindowResize();
        this.element.addEventListener("wheel", this.onWheel, $8ecb29f509dc0bd0$var$listenerOptions);
        this.element.addEventListener("touchstart", this.onTouchStart, $8ecb29f509dc0bd0$var$listenerOptions);
        this.element.addEventListener("touchmove", this.onTouchMove, $8ecb29f509dc0bd0$var$listenerOptions);
        this.element.addEventListener("touchend", this.onTouchEnd, $8ecb29f509dc0bd0$var$listenerOptions);
    }
    touchStart = {
        x: 0,
        y: 0
    };
    lastDelta = {
        x: 0,
        y: 0
    };
    window = {
        width: 0,
        height: 0
    };
    emitter = new $8ecb29f509dc0bd0$var$Emitter();
    /**
   * Add an event listener for the given event and callback
   *
   * @param event Event name
   * @param callback Callback function
   */ on(event, callback) {
        return this.emitter.on(event, callback);
    }
    /** Remove all event listeners and clean up */ destroy() {
        this.emitter.destroy();
        window.removeEventListener("resize", this.onWindowResize, false);
        this.element.removeEventListener("wheel", this.onWheel, $8ecb29f509dc0bd0$var$listenerOptions);
        this.element.removeEventListener("touchstart", this.onTouchStart, $8ecb29f509dc0bd0$var$listenerOptions);
        this.element.removeEventListener("touchmove", this.onTouchMove, $8ecb29f509dc0bd0$var$listenerOptions);
        this.element.removeEventListener("touchend", this.onTouchEnd, $8ecb29f509dc0bd0$var$listenerOptions);
    }
    /**
   * Event handler for 'touchstart' event
   *
   * @param event Touch event
   */ onTouchStart = (event)=>{
        const { clientX: clientX, clientY: clientY } = event.targetTouches ? event.targetTouches[0] : event;
        this.touchStart.x = clientX;
        this.touchStart.y = clientY;
        this.lastDelta = {
            x: 0,
            y: 0
        };
        this.emitter.emit("scroll", {
            deltaX: 0,
            deltaY: 0,
            event: event
        });
    };
    /** Event handler for 'touchmove' event */ onTouchMove = (event)=>{
        const { clientX: clientX, clientY: clientY } = event.targetTouches ? event.targetTouches[0] : event;
        const deltaX = -(clientX - this.touchStart.x) * this.options.touchMultiplier;
        const deltaY = -(clientY - this.touchStart.y) * this.options.touchMultiplier;
        this.touchStart.x = clientX;
        this.touchStart.y = clientY;
        this.lastDelta = {
            x: deltaX,
            y: deltaY
        };
        this.emitter.emit("scroll", {
            deltaX: deltaX,
            deltaY: deltaY,
            event: event
        });
    };
    onTouchEnd = (event)=>{
        this.emitter.emit("scroll", {
            deltaX: this.lastDelta.x,
            deltaY: this.lastDelta.y,
            event: event
        });
    };
    /** Event handler for 'wheel' event */ onWheel = (event)=>{
        let { deltaX: deltaX, deltaY: deltaY, deltaMode: deltaMode } = event;
        const multiplierX = deltaMode === 1 ? $8ecb29f509dc0bd0$var$LINE_HEIGHT : deltaMode === 2 ? this.window.width : 1;
        const multiplierY = deltaMode === 1 ? $8ecb29f509dc0bd0$var$LINE_HEIGHT : deltaMode === 2 ? this.window.height : 1;
        deltaX *= multiplierX;
        deltaY *= multiplierY;
        deltaX *= this.options.wheelMultiplier;
        deltaY *= this.options.wheelMultiplier;
        this.emitter.emit("scroll", {
            deltaX: deltaX,
            deltaY: deltaY,
            event: event
        });
    };
    onWindowResize = ()=>{
        this.window = {
            width: window.innerWidth,
            height: window.innerHeight
        };
    };
};
// packages/core/src/lenis.ts
var $8ecb29f509dc0bd0$var$defaultEasing = (t)=>Math.min(1, 1.001 - Math.pow(2, -10 * t));
var $8ecb29f509dc0bd0$export$2e2bcd8739ae039 = class {
    _isScrolling = false;
    // true when scroll is animating
    _isStopped = false;
    // true if user should not be able to scroll - enable/disable programmatically
    _isLocked = false;
    // same as isStopped but enabled/disabled when scroll reaches target
    _preventNextNativeScrollEvent = false;
    _resetVelocityTimeout = null;
    _rafId = null;
    /**
   * Whether or not the user is touching the screen
   */ isTouching;
    /**
   * The time in ms since the lenis instance was created
   */ time = 0;
    /**
   * User data that will be forwarded through the scroll event
   *
   * @example
   * lenis.scrollTo(100, {
   *   userData: {
   *     foo: 'bar'
   *   }
   * })
   */ userData = {};
    /**
   * The last velocity of the scroll
   */ lastVelocity = 0;
    /**
   * The current velocity of the scroll
   */ velocity = 0;
    /**
   * The direction of the scroll
   */ direction = 0;
    /**
   * The options passed to the lenis instance
   */ options;
    /**
   * The target scroll value
   */ targetScroll;
    /**
   * The animated scroll value
   */ animatedScroll;
    // These are instanciated here as they don't need information from the options
    animate = new $8ecb29f509dc0bd0$var$Animate();
    emitter = new $8ecb29f509dc0bd0$var$Emitter();
    // These are instanciated in the constructor as they need information from the options
    dimensions;
    // This is not private because it's used in the Snap class
    virtualScroll;
    constructor({ wrapper: wrapper = window, content: content = document.documentElement, eventsTarget: eventsTarget = wrapper, smoothWheel: smoothWheel = true, syncTouch: syncTouch = false, syncTouchLerp: syncTouchLerp = 0.075, touchInertiaExponent: touchInertiaExponent = 1.7, duration: duration, easing: // in seconds
    easing, lerp: lerp2 = 0.1, infinite: infinite = false, orientation: orientation = "vertical", gestureOrientation: // vertical, horizontal
    gestureOrientation = orientation === "horizontal" ? "both" : "vertical", touchMultiplier: // vertical, horizontal, both
    touchMultiplier = 1, wheelMultiplier: wheelMultiplier = 1, autoResize: autoResize = true, prevent: prevent, virtualScroll: virtualScroll, overscroll: overscroll = true, autoRaf: autoRaf = false, anchors: anchors = false, autoToggle: autoToggle = false, allowNestedScroll: // https://caniuse.com/?search=transition-behavior
    allowNestedScroll = false, __experimental__naiveDimensions: // @ts-ignore: this will be deprecated in the future
    __experimental__naiveDimensions = false, naiveDimensions: naiveDimensions = __experimental__naiveDimensions, stopInertiaOnNavigate: stopInertiaOnNavigate = false } = {}){
        window.lenisVersion = $8ecb29f509dc0bd0$var$version;
        if (!wrapper || wrapper === document.documentElement) wrapper = window;
        if (typeof duration === "number" && typeof easing !== "function") easing = $8ecb29f509dc0bd0$var$defaultEasing;
        else if (typeof easing === "function" && typeof duration !== "number") duration = 1;
        this.options = {
            wrapper: wrapper,
            content: content,
            eventsTarget: eventsTarget,
            smoothWheel: smoothWheel,
            syncTouch: syncTouch,
            syncTouchLerp: syncTouchLerp,
            touchInertiaExponent: touchInertiaExponent,
            duration: duration,
            easing: easing,
            lerp: lerp2,
            infinite: infinite,
            gestureOrientation: gestureOrientation,
            orientation: orientation,
            touchMultiplier: touchMultiplier,
            wheelMultiplier: wheelMultiplier,
            autoResize: autoResize,
            prevent: prevent,
            virtualScroll: virtualScroll,
            overscroll: overscroll,
            autoRaf: autoRaf,
            anchors: anchors,
            autoToggle: autoToggle,
            allowNestedScroll: allowNestedScroll,
            naiveDimensions: naiveDimensions,
            stopInertiaOnNavigate: stopInertiaOnNavigate
        };
        this.dimensions = new $8ecb29f509dc0bd0$var$Dimensions(wrapper, content, {
            autoResize: autoResize
        });
        this.updateClassName();
        this.targetScroll = this.animatedScroll = this.actualScroll;
        this.options.wrapper.addEventListener("scroll", this.onNativeScroll, false);
        this.options.wrapper.addEventListener("scrollend", this.onScrollEnd, {
            capture: true
        });
        if (this.options.anchors || this.options.stopInertiaOnNavigate) this.options.wrapper.addEventListener("click", this.onClick, false);
        this.options.wrapper.addEventListener("pointerdown", this.onPointerDown, false);
        this.virtualScroll = new $8ecb29f509dc0bd0$var$VirtualScroll(eventsTarget, {
            touchMultiplier: touchMultiplier,
            wheelMultiplier: wheelMultiplier
        });
        this.virtualScroll.on("scroll", this.onVirtualScroll);
        if (this.options.autoToggle) {
            this.checkOverflow();
            this.rootElement.addEventListener("transitionend", this.onTransitionEnd, {
                passive: true
            });
        }
        if (this.options.autoRaf) this._rafId = requestAnimationFrame(this.raf);
    }
    /**
   * Destroy the lenis instance, remove all event listeners and clean up the class name
   */ destroy() {
        this.emitter.destroy();
        this.options.wrapper.removeEventListener("scroll", this.onNativeScroll, false);
        this.options.wrapper.removeEventListener("scrollend", this.onScrollEnd, {
            capture: true
        });
        this.options.wrapper.removeEventListener("pointerdown", this.onPointerDown, false);
        if (this.options.anchors || this.options.stopInertiaOnNavigate) this.options.wrapper.removeEventListener("click", this.onClick, false);
        this.virtualScroll.destroy();
        this.dimensions.destroy();
        this.cleanUpClassName();
        if (this._rafId) cancelAnimationFrame(this._rafId);
    }
    on(event, callback) {
        return this.emitter.on(event, callback);
    }
    off(event, callback) {
        return this.emitter.off(event, callback);
    }
    onScrollEnd = (e)=>{
        if (!(e instanceof CustomEvent)) {
            if (this.isScrolling === "smooth" || this.isScrolling === false) e.stopPropagation();
        }
    };
    dispatchScrollendEvent = ()=>{
        this.options.wrapper.dispatchEvent(new CustomEvent("scrollend", {
            bubbles: this.options.wrapper === window,
            // cancelable: false,
            detail: {
                lenisScrollEnd: true
            }
        }));
    };
    get overflow() {
        const property = this.isHorizontal ? "overflow-x" : "overflow-y";
        return getComputedStyle(this.rootElement)[property];
    }
    checkOverflow() {
        if ([
            "hidden",
            "clip"
        ].includes(this.overflow)) this.internalStop();
        else this.internalStart();
    }
    onTransitionEnd = (event)=>{
        if (event.propertyName.includes("overflow")) this.checkOverflow();
    };
    setScroll(scroll) {
        if (this.isHorizontal) this.options.wrapper.scrollTo({
            left: scroll,
            behavior: "instant"
        });
        else this.options.wrapper.scrollTo({
            top: scroll,
            behavior: "instant"
        });
    }
    onClick = (event)=>{
        const path = event.composedPath();
        const anchorElements = path.filter((node)=>node instanceof HTMLAnchorElement && node.getAttribute("href"));
        if (this.options.anchors) {
            const anchor = anchorElements.find((node)=>node.getAttribute("href")?.includes("#"));
            if (anchor) {
                const href = anchor.getAttribute("href");
                if (href) {
                    const options = typeof this.options.anchors === "object" && this.options.anchors ? this.options.anchors : void 0;
                    const target = `#${href.split("#")[1]}`;
                    this.scrollTo(target, options);
                }
            }
        }
        if (this.options.stopInertiaOnNavigate) {
            const internalLink = anchorElements.find((node)=>node.host === window.location.host);
            if (internalLink) this.reset();
        }
    };
    onPointerDown = (event)=>{
        if (event.button === 1) this.reset();
    };
    onVirtualScroll = (data)=>{
        if (typeof this.options.virtualScroll === "function" && this.options.virtualScroll(data) === false) return;
        const { deltaX: deltaX, deltaY: deltaY, event: event } = data;
        this.emitter.emit("virtual-scroll", {
            deltaX: deltaX,
            deltaY: deltaY,
            event: event
        });
        if (event.ctrlKey) return;
        if (event.lenisStopPropagation) return;
        const isTouch = event.type.includes("touch");
        const isWheel = event.type.includes("wheel");
        this.isTouching = event.type === "touchstart" || event.type === "touchmove";
        const isClickOrTap = deltaX === 0 && deltaY === 0;
        const isTapToStop = this.options.syncTouch && isTouch && event.type === "touchstart" && isClickOrTap && !this.isStopped && !this.isLocked;
        if (isTapToStop) {
            this.reset();
            return;
        }
        const isUnknownGesture = this.options.gestureOrientation === "vertical" && deltaY === 0 || this.options.gestureOrientation === "horizontal" && deltaX === 0;
        if (isClickOrTap || isUnknownGesture) return;
        let composedPath = event.composedPath();
        composedPath = composedPath.slice(0, composedPath.indexOf(this.rootElement));
        const prevent = this.options.prevent;
        if (!!composedPath.find((node)=>node instanceof HTMLElement && (typeof prevent === "function" && prevent?.(node) || node.hasAttribute?.("data-lenis-prevent") || isTouch && node.hasAttribute?.("data-lenis-prevent-touch") || isWheel && node.hasAttribute?.("data-lenis-prevent-wheel") || this.options.allowNestedScroll && this.checkNestedScroll(node, {
                deltaX: deltaX,
                deltaY: deltaY
            })))) return;
        if (this.isStopped || this.isLocked) {
            if (event.cancelable) event.preventDefault();
            return;
        }
        const isSmooth = this.options.syncTouch && isTouch || this.options.smoothWheel && isWheel;
        if (!isSmooth) {
            this.isScrolling = "native";
            this.animate.stop();
            event.lenisStopPropagation = true;
            return;
        }
        let delta = deltaY;
        if (this.options.gestureOrientation === "both") delta = Math.abs(deltaY) > Math.abs(deltaX) ? deltaY : deltaX;
        else if (this.options.gestureOrientation === "horizontal") delta = deltaX;
        if (!this.options.overscroll || this.options.infinite || this.options.wrapper !== window && this.limit > 0 && (this.animatedScroll > 0 && this.animatedScroll < this.limit || this.animatedScroll === 0 && deltaY > 0 || this.animatedScroll === this.limit && deltaY < 0)) event.lenisStopPropagation = true;
        if (event.cancelable) event.preventDefault();
        const isSyncTouch = isTouch && this.options.syncTouch;
        const isTouchEnd = isTouch && event.type === "touchend";
        const hasTouchInertia = isTouchEnd;
        if (hasTouchInertia) delta = Math.sign(this.velocity) * Math.pow(Math.abs(this.velocity), this.options.touchInertiaExponent);
        this.scrollTo(this.targetScroll + delta, {
            programmatic: false,
            ...isSyncTouch ? {
                lerp: hasTouchInertia ? this.options.syncTouchLerp : 1
            } : {
                lerp: this.options.lerp,
                duration: this.options.duration,
                easing: this.options.easing
            }
        });
    };
    /**
   * Force lenis to recalculate the dimensions
   */ resize() {
        this.dimensions.resize();
        this.animatedScroll = this.targetScroll = this.actualScroll;
        this.emit();
    }
    emit() {
        this.emitter.emit("scroll", this);
    }
    onNativeScroll = ()=>{
        if (this._resetVelocityTimeout !== null) {
            clearTimeout(this._resetVelocityTimeout);
            this._resetVelocityTimeout = null;
        }
        if (this._preventNextNativeScrollEvent) {
            this._preventNextNativeScrollEvent = false;
            return;
        }
        if (this.isScrolling === false || this.isScrolling === "native") {
            const lastScroll = this.animatedScroll;
            this.animatedScroll = this.targetScroll = this.actualScroll;
            this.lastVelocity = this.velocity;
            this.velocity = this.animatedScroll - lastScroll;
            this.direction = Math.sign(this.animatedScroll - lastScroll);
            if (!this.isStopped) this.isScrolling = "native";
            this.emit();
            if (this.velocity !== 0) this._resetVelocityTimeout = setTimeout(()=>{
                this.lastVelocity = this.velocity;
                this.velocity = 0;
                this.isScrolling = false;
                this.emit();
            }, 400);
        }
    };
    reset() {
        this.isLocked = false;
        this.isScrolling = false;
        this.animatedScroll = this.targetScroll = this.actualScroll;
        this.lastVelocity = this.velocity = 0;
        this.animate.stop();
    }
    /**
   * Start lenis scroll after it has been stopped
   */ start() {
        if (!this.isStopped) return;
        if (this.options.autoToggle) {
            this.rootElement.style.removeProperty("overflow");
            return;
        }
        this.internalStart();
    }
    internalStart() {
        if (!this.isStopped) return;
        this.reset();
        this.isStopped = false;
        this.emit();
    }
    /**
   * Stop lenis scroll
   */ stop() {
        if (this.isStopped) return;
        if (this.options.autoToggle) {
            this.rootElement.style.setProperty("overflow", "clip");
            return;
        }
        this.internalStop();
    }
    internalStop() {
        if (this.isStopped) return;
        this.reset();
        this.isStopped = true;
        this.emit();
    }
    /**
   * RequestAnimationFrame for lenis
   *
   * @param time The time in ms from an external clock like `requestAnimationFrame` or Tempus
   */ raf = (time)=>{
        const deltaTime = time - (this.time || time);
        this.time = time;
        this.animate.advance(deltaTime * 1e-3);
        if (this.options.autoRaf) this._rafId = requestAnimationFrame(this.raf);
    };
    /**
   * Scroll to a target value
   *
   * @param target The target value to scroll to
   * @param options The options for the scroll
   *
   * @example
   * lenis.scrollTo(100, {
   *   offset: 100,
   *   duration: 1,
   *   easing: (t) => 1 - Math.cos((t * Math.PI) / 2),
   *   lerp: 0.1,
   *   onStart: () => {
   *     console.log('onStart')
   *   },
   *   onComplete: () => {
   *     console.log('onComplete')
   *   },
   * })
   */ scrollTo(target, { offset: offset = 0, immediate: immediate = false, lock: lock = false, programmatic: programmatic = true, // called from outside of the class
    lerp: lerp2 = programmatic ? this.options.lerp : void 0, duration: duration = programmatic ? this.options.duration : void 0, easing: easing = programmatic ? this.options.easing : void 0, onStart: onStart, onComplete: onComplete, force: force = false, userData: // scroll even if stopped
    userData } = {}) {
        if ((this.isStopped || this.isLocked) && !force) return;
        if (typeof target === "string" && [
            "top",
            "left",
            "start",
            "#"
        ].includes(target)) target = 0;
        else if (typeof target === "string" && [
            "bottom",
            "right",
            "end"
        ].includes(target)) target = this.limit;
        else {
            let node;
            if (typeof target === "string") {
                node = document.querySelector(target);
                if (!node) {
                    if (target === "#top") target = 0;
                    else console.warn("Lenis: Target not found", target);
                }
            } else if (target instanceof HTMLElement && target?.nodeType) node = target;
            if (node) {
                if (this.options.wrapper !== window) {
                    const wrapperRect = this.rootElement.getBoundingClientRect();
                    offset -= this.isHorizontal ? wrapperRect.left : wrapperRect.top;
                }
                const rect = node.getBoundingClientRect();
                target = (this.isHorizontal ? rect.left : rect.top) + this.animatedScroll;
            }
        }
        if (typeof target !== "number") return;
        target += offset;
        target = Math.round(target);
        if (this.options.infinite) {
            if (programmatic) {
                this.targetScroll = this.animatedScroll = this.scroll;
                const distance = target - this.animatedScroll;
                if (distance > this.limit / 2) target = target - this.limit;
                else if (distance < -this.limit / 2) target = target + this.limit;
            }
        } else target = $8ecb29f509dc0bd0$var$clamp(0, target, this.limit);
        if (target === this.targetScroll) {
            onStart?.(this);
            onComplete?.(this);
            return;
        }
        this.userData = userData ?? {};
        if (immediate) {
            this.animatedScroll = this.targetScroll = target;
            this.setScroll(this.scroll);
            this.reset();
            this.preventNextNativeScrollEvent();
            this.emit();
            onComplete?.(this);
            this.userData = {};
            requestAnimationFrame(()=>{
                this.dispatchScrollendEvent();
            });
            return;
        }
        if (!programmatic) this.targetScroll = target;
        if (typeof duration === "number" && typeof easing !== "function") easing = $8ecb29f509dc0bd0$var$defaultEasing;
        else if (typeof easing === "function" && typeof duration !== "number") duration = 1;
        this.animate.fromTo(this.animatedScroll, target, {
            duration: duration,
            easing: easing,
            lerp: lerp2,
            onStart: ()=>{
                if (lock) this.isLocked = true;
                this.isScrolling = "smooth";
                onStart?.(this);
            },
            onUpdate: (value, completed)=>{
                this.isScrolling = "smooth";
                this.lastVelocity = this.velocity;
                this.velocity = value - this.animatedScroll;
                this.direction = Math.sign(this.velocity);
                this.animatedScroll = value;
                this.setScroll(this.scroll);
                if (programmatic) this.targetScroll = value;
                if (!completed) this.emit();
                if (completed) {
                    this.reset();
                    this.emit();
                    onComplete?.(this);
                    this.userData = {};
                    requestAnimationFrame(()=>{
                        this.dispatchScrollendEvent();
                    });
                    this.preventNextNativeScrollEvent();
                }
            }
        });
    }
    preventNextNativeScrollEvent() {
        this._preventNextNativeScrollEvent = true;
        requestAnimationFrame(()=>{
            this._preventNextNativeScrollEvent = false;
        });
    }
    checkNestedScroll(node, { deltaX: deltaX, deltaY: deltaY }) {
        const time = Date.now();
        const cache = node._lenis ??= {};
        let hasOverflowX, hasOverflowY, isScrollableX, isScrollableY, scrollWidth, scrollHeight, clientWidth, clientHeight;
        const gestureOrientation = this.options.gestureOrientation;
        if (time - (cache.time ?? 0) > 2e3) {
            cache.time = Date.now();
            const computedStyle = window.getComputedStyle(node);
            cache.computedStyle = computedStyle;
            const overflowXString = computedStyle.overflowX;
            const overflowYString = computedStyle.overflowY;
            hasOverflowX = [
                "auto",
                "overlay",
                "scroll"
            ].includes(overflowXString);
            hasOverflowY = [
                "auto",
                "overlay",
                "scroll"
            ].includes(overflowYString);
            cache.hasOverflowX = hasOverflowX;
            cache.hasOverflowY = hasOverflowY;
            if (!hasOverflowX && !hasOverflowY) return false;
            if (gestureOrientation === "vertical" && !hasOverflowY) return false;
            if (gestureOrientation === "horizontal" && !hasOverflowX) return false;
            scrollWidth = node.scrollWidth;
            scrollHeight = node.scrollHeight;
            clientWidth = node.clientWidth;
            clientHeight = node.clientHeight;
            isScrollableX = scrollWidth > clientWidth;
            isScrollableY = scrollHeight > clientHeight;
            cache.isScrollableX = isScrollableX;
            cache.isScrollableY = isScrollableY;
            cache.scrollWidth = scrollWidth;
            cache.scrollHeight = scrollHeight;
            cache.clientWidth = clientWidth;
            cache.clientHeight = clientHeight;
        } else {
            isScrollableX = cache.isScrollableX;
            isScrollableY = cache.isScrollableY;
            hasOverflowX = cache.hasOverflowX;
            hasOverflowY = cache.hasOverflowY;
            scrollWidth = cache.scrollWidth;
            scrollHeight = cache.scrollHeight;
            clientWidth = cache.clientWidth;
            clientHeight = cache.clientHeight;
        }
        if (!hasOverflowX && !hasOverflowY || !isScrollableX && !isScrollableY) return false;
        if (gestureOrientation === "vertical" && (!hasOverflowY || !isScrollableY)) return false;
        if (gestureOrientation === "horizontal" && (!hasOverflowX || !isScrollableX)) return false;
        let orientation;
        if (gestureOrientation === "horizontal") orientation = "x";
        else if (gestureOrientation === "vertical") orientation = "y";
        else {
            const isScrollingX = deltaX !== 0;
            const isScrollingY = deltaY !== 0;
            if (isScrollingX && hasOverflowX && isScrollableX) orientation = "x";
            if (isScrollingY && hasOverflowY && isScrollableY) orientation = "y";
        }
        if (!orientation) return false;
        let scroll, maxScroll, delta, hasOverflow, isScrollable;
        if (orientation === "x") {
            scroll = node.scrollLeft;
            maxScroll = scrollWidth - clientWidth;
            delta = deltaX;
            hasOverflow = hasOverflowX;
            isScrollable = isScrollableX;
        } else if (orientation === "y") {
            scroll = node.scrollTop;
            maxScroll = scrollHeight - clientHeight;
            delta = deltaY;
            hasOverflow = hasOverflowY;
            isScrollable = isScrollableY;
        } else return false;
        const willScroll = delta > 0 ? scroll < maxScroll : scroll > 0;
        return willScroll && hasOverflow && isScrollable;
    }
    /**
   * The root element on which lenis is instanced
   */ get rootElement() {
        return this.options.wrapper === window ? document.documentElement : this.options.wrapper;
    }
    /**
   * The limit which is the maximum scroll value
   */ get limit() {
        if (this.options.naiveDimensions) {
            if (this.isHorizontal) return this.rootElement.scrollWidth - this.rootElement.clientWidth;
            else return this.rootElement.scrollHeight - this.rootElement.clientHeight;
        } else return this.dimensions.limit[this.isHorizontal ? "x" : "y"];
    }
    /**
   * Whether or not the scroll is horizontal
   */ get isHorizontal() {
        return this.options.orientation === "horizontal";
    }
    /**
   * The actual scroll value
   */ get actualScroll() {
        const wrapper = this.options.wrapper;
        return this.isHorizontal ? wrapper.scrollX ?? wrapper.scrollLeft : wrapper.scrollY ?? wrapper.scrollTop;
    }
    /**
   * The current scroll value
   */ get scroll() {
        return this.options.infinite ? $8ecb29f509dc0bd0$var$modulo(this.animatedScroll, this.limit) : this.animatedScroll;
    }
    /**
   * The progress of the scroll relative to the limit
   */ get progress() {
        return this.limit === 0 ? 1 : this.scroll / this.limit;
    }
    /**
   * Current scroll state
   */ get isScrolling() {
        return this._isScrolling;
    }
    set isScrolling(value) {
        if (this._isScrolling !== value) {
            this._isScrolling = value;
            this.updateClassName();
        }
    }
    /**
   * Check if lenis is stopped
   */ get isStopped() {
        return this._isStopped;
    }
    set isStopped(value) {
        if (this._isStopped !== value) {
            this._isStopped = value;
            this.updateClassName();
        }
    }
    /**
   * Check if lenis is locked
   */ get isLocked() {
        return this._isLocked;
    }
    set isLocked(value) {
        if (this._isLocked !== value) {
            this._isLocked = value;
            this.updateClassName();
        }
    }
    /**
   * Check if lenis is smooth scrolling
   */ get isSmooth() {
        return this.isScrolling === "smooth";
    }
    /**
   * The class name applied to the wrapper element
   */ get className() {
        let className = "lenis";
        if (this.options.autoToggle) className += " lenis-autoToggle";
        if (this.isStopped) className += " lenis-stopped";
        if (this.isLocked) className += " lenis-locked";
        if (this.isScrolling) className += " lenis-scrolling";
        if (this.isScrolling === "smooth") className += " lenis-smooth";
        return className;
    }
    updateClassName() {
        this.cleanUpClassName();
        this.rootElement.className = `${this.rootElement.className} ${this.className}`.trim();
    }
    cleanUpClassName() {
        this.rootElement.className = this.rootElement.className.replace(/lenis(-\w+)?/g, "").trim();
    }
};



var $7su0d = parcelRequire("7su0d");

var $4AGbv = parcelRequire("4AGbv");

var $iNA1s = parcelRequire("iNA1s");
(0, $4AGbv.default).registerPlugin((0, $iNA1s.ScrollTrigger));
function $bbda2dbb38b850b8$export$88099837baf9f921() {
    const track = document.querySelector(".maladie-slider-track");
    if (!track) return;
    const items = track.querySelectorAll(".maladie-slide-item");
    if (!items.length) return;
    // ============================================================
    // MALADIE - CALCUL MOITIE TRACK (images dupliquées)
    // ============================================================
    const itemWidth = items[0].offsetWidth + 15;
    const totalWidth = itemWidth * (items.length / 2);
    (0, $4AGbv.default).to(track, {
        x: -totalWidth,
        duration: 20,
        ease: "none",
        repeat: -1
    });
    // ============================================================
    // MALADIE - IMG - ANIMATION FUMEE HOVER DISPPAITION 3S
    // ============================================================
    const imgs = track.querySelectorAll("img[data-artwork]");
    imgs.forEach((img)=>{
        let reappearTimer = null;
        img.addEventListener("mouseenter", ()=>{
            clearTimeout(reappearTimer);
            (0, $4AGbv.default).to(img, {
                opacity: 0,
                filter: "blur(22px) brightness(1.4)",
                duration: 0.7,
                ease: "power2.out",
                overwrite: "auto",
                onComplete: ()=>{
                    reappearTimer = setTimeout(()=>{
                        (0, $4AGbv.default).to(img, {
                            opacity: 1,
                            filter: "blur(0px) brightness(1)",
                            duration: 1.2,
                            ease: "power3.out"
                        });
                    }, 2000);
                }
            });
        });
    });
}
function $bbda2dbb38b850b8$export$727d064b164ec9cd(el, texte) {
    if (!el) return;
    el.innerHTML = "";
    const letters = [];
    const easeVal = 0.05;
    texte.split("").forEach((char)=>{
        const span = document.createElement("span");
        if (char === " ") {
            span.classList.add("space");
            span.innerHTML = "&nbsp;";
        } else {
            span.textContent = char;
            letters.push(span);
            const state = {
                opacity: 1,
                blur: 0,
                brightness: 1,
                targetOpacity: 1,
                targetBlur: 0,
                targetBrightness: 1
            };
            span._state = state;
            span.addEventListener("mousemove", ()=>{
                state.targetOpacity = 0;
                state.targetBlur = 10;
                state.targetBrightness = 2;
            });
            span.addEventListener("mouseleave", ()=>{
                state.targetOpacity = 1;
                state.targetBlur = 0;
                state.targetBrightness = 1;
            });
        }
        el.appendChild(span);
    });
    function lerp(a, b, t) {
        return a + (b - a) * t;
    }
    function animate() {
        letters.forEach((span)=>{
            const s = span._state;
            s.opacity = lerp(s.opacity, s.targetOpacity, easeVal);
            s.blur = lerp(s.blur, s.targetBlur, easeVal);
            s.brightness = lerp(s.brightness, s.targetBrightness, easeVal);
            span.style.opacity = s.opacity;
            span.style.filter = `blur(${s.blur}px) brightness(${s.brightness})`;
        });
        requestAnimationFrame(animate);
    }
    animate();
}
function $bbda2dbb38b850b8$export$9ed29f8b75578d20() {
    $bbda2dbb38b850b8$export$727d064b164ec9cd(document.getElementById("titre"), "Alzheimer");
    const patriciaH1 = document.querySelector(".text-pat-maladie h1");
    if (patriciaH1) $bbda2dbb38b850b8$export$727d064b164ec9cd(patriciaH1, "Patricia");
    const textSelectors = [
        "#maladie-hero-text",
        ".hero_maladie p",
        ".maladie-text-container p",
        ".maladie-text-container h2",
        ".Before-image-Sky h1",
        ".text-pat-maladie p",
        ".After-Patricia-Maladie h1"
    ];
    textSelectors.forEach((sel)=>{
        const el = document.querySelector(sel);
        if (el) $bbda2dbb38b850b8$export$727d064b164ec9cd(el, el.textContent.trim().replace(/\s+/g, " "));
    });
}


// ============================================================
// AUTO - IMPORT ET CONST
// ============================================================

function $6a63b9da8492a4cf$export$641db4a1a1211ca3() {
    document.querySelectorAll(".hero_conversation h1 .hero-text-part").forEach((el)=>{
        (0, $bbda2dbb38b850b8$export$727d064b164ec9cd)(el, el.textContent.trim().replace(/\s+/g, " "));
    });
    const selectors = [
        ".hero_conversation h2",
        ".info-avant-footer h1",
        ".info-avant-footer > p",
        ".info-avant-footer h2"
    ];
    selectors.forEach((sel)=>{
        document.querySelectorAll(sel).forEach((el)=>{
            (0, $bbda2dbb38b850b8$export$727d064b164ec9cd)(el, el.textContent.trim().replace(/\s+/g, " "));
        });
    });
}
function $6a63b9da8492a4cf$export$315e6a39609a32c4() {
    const trackEl = document.getElementById("gallery-track");
    if (!trackEl) return;
    const DATA = [
        ...trackEl.querySelectorAll("#gallery-images img")
    ].map((img)=>({
            year: parseInt(img.dataset.year),
            src: img.getAttribute("src"),
            x: parseFloat(img.dataset.x),
            y: parseFloat(img.dataset.y),
            w: parseFloat(img.dataset.w),
            h: parseFloat(img.dataset.h)
        }));
    if (!DATA.length) return;
    const sceneEl = document.getElementById("scene");
    const cvsEl = document.getElementById("canvas");
    const countEl = document.getElementById("gCount");
    const progEl = document.getElementById("gProg");
    const tlEl = document.getElementById("gTimeline");
    const zoomEl = document.getElementById("gZoom");
    const VW = window.innerWidth, VH = window.innerHeight, CY = VH / 2;
    const LERP = 0.08, FRIC = 0.88, MAX_Y = 260, DEF_ZOOM = 0.9;
    const first = DATA[0], last = DATA[DATA.length - 1];
    let zoom = DEF_ZOOM, camX = 0, camY = 0, tgtX = 0, tgtY = 0;
    let velY = 0, idx = 0, pDist = 0;
    let drag = false, dSY = 0, dCY = 0, dLY = 0, dVY = 0;
    const xForP = (p, z)=>{
        const s = VW / 2 - (first.x + first.w / 2) * z, e = VW / 2 - (last.x + last.w / 2) * z;
        return s + p * (e - s);
    };
    const trackH = (z)=>Math.round((last.x + last.w / 2 - first.x - first.w / 2) * z / 1.6) + VH;
    const scrollP = ()=>{
        const s = trackEl.offsetHeight - VH;
        return s > 0 ? Math.max(0, Math.min(1, (window.scrollY - trackEl.offsetTop) / s)) : 0;
    };
    trackEl.style.height = trackH(zoom) + "px";
    // ============================================================
    // AUTO - GALLERIE - CARTES
    // ============================================================
    DATA.forEach((d, i)=>{
        const t = i / (DATA.length - 1);
        const brightness = 1 - t * 0.75;
        const el = document.createElement("div");
        el.className = "g-card";
        el.style.cssText = `left:${d.x}px;top:${CY + d.y - d.h / 2}px;width:${d.w}px;height:${d.h}px;filter:brightness(${brightness})`;
        el.innerHTML = `<img src="${d.src}" loading="lazy" data-artwork="${i}">`;
        cvsEl.appendChild(el);
    });
    // ============================================================
    // AUTO - GALLERIE - TIMELINE
    // ============================================================
    const years = [
        ...new Set(DATA.map((d)=>d.year))
    ].sort((a, b)=>a - b);
    const tlMap = {};
    years.forEach((yr, i)=>{
        if (i > 0) {
            const r = document.createElement("div");
            r.className = "g-tl-rule";
            tlEl.appendChild(r);
        }
        const w = document.createElement("div");
        w.className = "g-tl-item";
        w.innerHTML = `<div class="g-tl-dot"></div><div class="g-tl-yr">${yr}</div>`;
        w.onclick = ()=>scrollToCard(DATA.findIndex((d)=>d.year === yr));
        tlEl.appendChild(w);
        tlMap[yr] = w;
    });
    function updateUI() {
        countEl.textContent = String(idx + 1).padStart(2, "0") + " / " + String(DATA.length).padStart(2, "0");
        document.getElementById("gPrev").disabled = idx === 0;
        document.getElementById("gNext").disabled = idx === DATA.length - 1;
        years.forEach((yr)=>tlMap[yr].classList.toggle("active", yr === DATA[idx].year));
        progEl.style.width = idx / (DATA.length - 1) * 100 + "%";
    }
    function updateIdx() {
        const cx = (-camX + VW / 2) / zoom;
        let best = 0, bestD = Infinity;
        DATA.forEach((d, i)=>{
            const dist = Math.abs(d.x + d.w / 2 - cx);
            if (dist < bestD) {
                bestD = dist;
                best = i;
            }
        });
        idx = best;
    }
    // ============================================================
    // AUTO - GALLERIE - ZOOM & Dragg
    // ============================================================
    function scrollToCard(i) {
        idx = Math.max(0, Math.min(DATA.length - 1, i));
        const d = DATA[idx], s = VW / 2 - (first.x + first.w / 2) * zoom, e = VW / 2 - (last.x + last.w / 2) * zoom;
        const p = (VW / 2 - (d.x + d.w / 2) * zoom - s) / (e - s);
        window.scrollTo({
            top: trackEl.offsetTop + p * (trackEl.offsetHeight - VH),
            behavior: "smooth"
        });
        updateUI();
    }
    window.addEventListener("scroll", ()=>{
        const p = scrollP();
        tgtX = xForP(p, zoom);
        if (window.__lenis) window.__lenis.options.wheelMultiplier = 0.3 - p * 0.23;
        updateIdx();
        updateUI();
    }, {
        passive: true
    });
    let zoomTimer;
    function applyZoom(z) {
        zoom = Math.max(0.25, Math.min(2.5, z));
        tgtX = xForP(scrollP(), zoom);
        tgtY = Math.max(-MAX_Y * zoom, Math.min(MAX_Y * zoom, tgtY));
        trackEl.style.height = trackH(zoom) + "px";
        zoomEl.textContent = Math.round(zoom * 100) + "%";
        zoomEl.classList.add("show");
        clearTimeout(zoomTimer);
        zoomTimer = setTimeout(()=>zoomEl.classList.remove("show"), 1200);
    }
    sceneEl.addEventListener("wheel", (e)=>{
        if (e.ctrlKey || e.metaKey) {
            e.preventDefault();
            applyZoom(zoom * (1 - e.deltaY * 0.003));
        }
    }, {
        passive: false
    });
    window.addEventListener("mousemove", (e)=>{
        if (!drag) return;
        dVY = e.clientY - dLY;
        dLY = e.clientY;
        tgtY = Math.max(-MAX_Y * zoom, Math.min(MAX_Y * zoom, dCY + (e.clientY - dSY)));
    });
    window.addEventListener("mouseup", ()=>{
        if (!drag) return;
        drag = false;
        velY = dVY * 1.2;
        sceneEl.classList.remove("dragging");
    });
    sceneEl.addEventListener("touchstart", (e)=>{
        if (e.touches.length === 2) {
            pDist = Math.hypot(e.touches[0].clientX - e.touches[1].clientX, e.touches[0].clientY - e.touches[1].clientY);
            return;
        }
        const t = e.touches[0];
        drag = true;
        dSY = dLY = t.clientY;
        dCY = tgtY;
        dVY = velY = 0;
    }, {
        passive: true
    });
    window.addEventListener("touchmove", (e)=>{
        if (e.touches.length === 2) {
            const d = Math.hypot(e.touches[0].clientX - e.touches[1].clientX, e.touches[0].clientY - e.touches[1].clientY);
            if (pDist > 0) applyZoom(zoom * (d / pDist));
            pDist = d;
            return;
        }
        if (!drag) return;
        const t = e.touches[0];
        dVY = t.clientY - dLY;
        dLY = t.clientY;
        tgtY = Math.max(-MAX_Y * zoom, Math.min(MAX_Y * zoom, dCY + (t.clientY - dSY)));
    }, {
        passive: true
    });
    window.addEventListener("touchend", ()=>{
        if (drag) {
            drag = false;
            velY = dVY * 1.2;
        }
    });
    (function loop() {
        if (!drag) {
            tgtY += velY;
            velY *= FRIC;
            if (Math.abs(velY) < 0.05) velY = 0;
        }
        camX += (tgtX - camX) * LERP;
        camY += (tgtY - camY) * LERP;
        cvsEl.style.transform = `translate3d(${camX}px,${camY}px,0) scale(${zoom})`;
        requestAnimationFrame(loop);
    })();
    tgtX = camX = xForP(scrollP(), zoom);
    updateUI();
}


function $d5da25764ebe9a7c$export$49096fa2ca92ad92() {
    const nav = document.getElementById("tl-nav");
    if (nav) nav.classList.remove("hidden");
}



var $4AGbv = parcelRequire("4AGbv");

var $iNA1s = parcelRequire("iNA1s");

function $656174d208695581$export$498d0fb7ade0687() {
    const sticker = document.querySelector(".scroll-lock__sticker");
    const pinned = document.querySelector(".pinned-section");
    if (!sticker || !pinned) return;
    const LAND_Y = 230;
    const START_Y = window.innerHeight + 100;
    (0, $4AGbv.default).set(sticker, {
        position: "fixed",
        top: 0,
        x: 0,
        y: START_Y,
        zIndex: 999999,
        transformOrigin: "50% 50%"
    });
    const stickerTl = (0, $4AGbv.default).timeline({
        scrollTrigger: {
            trigger: pinned,
            start: "30% top",
            end: "bottom top",
            scrub: 1,
            onEnter: ()=>(0, $4AGbv.default).set(sticker, {
                    visibility: "visible"
                }),
            onEnterBack: ()=>(0, $4AGbv.default).set(sticker, {
                    visibility: "visible"
                }),
            onLeaveBack: ()=>(0, $4AGbv.default).set(sticker, {
                    visibility: "hidden"
                })
        }
    });
    const stickerImg = sticker.querySelector("img");
    (0, $4AGbv.default).set(stickerImg, {
        transformOrigin: "50% 50%",
        rotation: 0
    });
    stickerTl.fromTo(sticker, {
        y: START_Y,
        scale: 1.8,
        x: 0
    }, {
        y: 60,
        scale: 1.1,
        x: -160,
        ease: "power2.out"
    }).to(sticker, {
        y: LAND_Y,
        scale: 0.6,
        x: -320,
        ease: "power2.in"
    });
    stickerTl.fromTo(stickerImg, {
        rotation: 0
    }, {
        rotation: 360,
        ease: "none"
    }, 0.5);
    const afterSection = document.querySelector(".after-dante");
    if (afterSection) (0, $4AGbv.default).fromTo(sticker, {
        y: LAND_Y
    }, {
        y: -window.innerHeight,
        ease: "none",
        scrollTrigger: {
            trigger: afterSection,
            start: "top bottom",
            end: "bottom top",
            scrub: true
        }
    });
}
function $656174d208695581$export$4836633f5520d527(namespace) {
    const sticker = document.querySelector(".scroll-lock__sticker");
    if (!sticker) return;
    sticker.style.display = namespace === "dante" ? "" : "none";
}
function $656174d208695581$export$474c7158c4247004() {
    const pics = document.querySelectorAll(".Section-mummers .pic");
    if (!pics.length) return;
    let zCounter = 10;
    pics.forEach((pic)=>{
        let prevX = 0, prevY = 0, velX = 0, velY = 0;
        (0, $5a019fe42b4630c1$export$f2a139e5d18b9882).create(pic, {
            type: "x,y",
            bounds: ".Section-mummers",
            onPress: function() {
                zCounter++;
                (0, $4AGbv.default).set(this.target, {
                    zIndex: zCounter
                });
                (0, $4AGbv.default).killTweensOf(this.target);
                prevX = this.x;
                prevY = this.y;
                velX = 0;
                velY = 0;
            },
            onDrag: function() {
                velX = this.x - prevX;
                velY = this.y - prevY;
                prevX = this.x;
                prevY = this.y;
            },
            onDragEnd: function() {
                const targetX = Math.max(this.minX, Math.min(this.maxX, this.x + velX * 6));
                const targetY = Math.max(this.minY, Math.min(this.maxY, this.y + velY * 6));
                (0, $4AGbv.default).to(this.target, {
                    x: targetX,
                    y: targetY,
                    ease: "power3.out",
                    duration: 0.7
                });
            }
        });
    });
}
function $656174d208695581$export$b37588a3eee0f6fd() {
    const imgs = document.querySelectorAll(".container-img-mummers img");
    const section = document.querySelector(".images-Mummers");
    if (!imgs.length || !section) return;
    (0, $4AGbv.default).set(imgs, {
        opacity: 0,
        y: 80
    });
    (0, $iNA1s.ScrollTrigger).create({
        trigger: section,
        start: "top bottom",
        once: true,
        onEnter: ()=>{
            imgs.forEach((img, i)=>{
                (0, $4AGbv.default).to(img, {
                    opacity: 1,
                    y: 0,
                    duration: 0.8,
                    ease: "power2.out",
                    delay: i * 0.2
                });
            });
        }
    });
}


// ============================================================
// CONV - IMPORT ET CONST
// ============================================================

var $4AGbv = parcelRequire("4AGbv");

var $iNA1s = parcelRequire("iNA1s");
function $592a78804c8b1cca$export$180426490a8b0f51() {
    const container = document.querySelector(".container-conversation-slider");
    if (!container) return;
    const groups = [
        ...document.querySelectorAll(".copy-group")
    ];
    const NUM_GROUPS = groups.length;
    const GROUP_SEG = 1 / NUM_GROUPS;
    const STAGGER_RATIO = 0.2;
    const CROSSFADE_THRESHOLDS = [
        0.6,
        0.73,
        0.86
    ];
    // ============================================================
    // CONV - STOCK DES DELAYEDCALLS POUR ANNULATION
    // ============================================================
    const pendingDelays = new Map();
    function prepareWords(block) {
        const p = block.querySelector("p");
        if (!p || p.dataset.wordsReady) return;
        p.dataset.wordsReady = "true";
        const text = p.textContent;
        const words = text.split(/(\s+)/);
        p.innerHTML = "";
        words.forEach((word)=>{
            if (word.trim() === "") {
                p.appendChild(document.createTextNode(word));
                return;
            }
            const wrapper = document.createElement("span");
            wrapper.style.cssText = "display:inline-block;overflow:hidden;vertical-align:bottom";
            const span = document.createElement("span");
            span.textContent = word;
            span.style.display = "inline-block";
            wrapper.appendChild(span);
            p.appendChild(wrapper);
        });
        (0, $4AGbv.default).set(p.querySelectorAll("span > span"), {
            y: "100%"
        });
    }
    function animateWords(block) {
        const spans = block.querySelectorAll("p span > span");
        if (!spans.length) return;
        (0, $4AGbv.default).killTweensOf(spans);
        (0, $4AGbv.default).fromTo(spans, {
            y: "100%"
        }, {
            y: "0%",
            duration: 1.2,
            stagger: 0.04,
            ease: "power4.out"
        });
    }
    function animateWordsOut(block) {
        const spans = block.querySelectorAll("p span > span");
        if (!spans.length) return;
        (0, $4AGbv.default).killTweensOf(spans);
        (0, $4AGbv.default).to(spans, {
            y: "100%",
            duration: 0.8,
            stagger: 0.03,
            ease: "power4.in"
        });
    }
    // ============================================================
    // CONV - KILL DES TEXT ET IMAGE APRES DISSPARITION
    // ============================================================
    function killPendingDelay(block) {
        if (pendingDelays.has(block)) {
            pendingDelays.get(block).kill();
            pendingDelays.delete(block);
        }
    }
    function resetBlock(block) {
        killPendingDelay(block);
        const spans = block.querySelectorAll("p span > span");
        (0, $4AGbv.default).killTweensOf(spans);
        (0, $4AGbv.default).set(block, {
            autoAlpha: 0
        });
        (0, $4AGbv.default).set(spans, {
            y: "100%"
        });
    }
    const blockVisible = new WeakMap();
    const blockCrossed = new WeakMap();
    const igFaded = new WeakMap();
    const groupXFired = new Map();
    const imageGroupes = [
        ...document.querySelectorAll(".image-groupe")
    ];
    imageGroupes.forEach((ig, i)=>{
        (0, $4AGbv.default).set(ig.querySelectorAll("img"), {
            x: 0
        });
        if (i === 0) {
            (0, $4AGbv.default).set(ig, {
                autoAlpha: 1,
                display: "flex"
            });
            igFaded.set(ig, true);
        } else {
            (0, $4AGbv.default).set(ig, {
                autoAlpha: 0
            });
            igFaded.set(ig, false);
        }
    });
    groups.forEach((group)=>{
        group.querySelectorAll(".copy-block").forEach((block)=>{
            prepareWords(block);
            blockVisible.set(block, false);
            blockCrossed.set(block, false);
        });
        (0, $4AGbv.default).set(group.querySelectorAll(".copy-block"), {
            autoAlpha: 0
        });
        (0, $4AGbv.default).set(group.querySelectorAll(".copy-img"), {
            autoAlpha: 0
        });
        groupXFired.set(group, [
            false,
            false,
            false
        ]);
    });
    const lenis = window.__lenis;
    if (lenis) (0, $iNA1s.ScrollTrigger).create({
        trigger: container,
        start: "top bottom",
        end: "bottom top",
        onEnter: ()=>{
            lenis.options.wheelMultiplier = 0.03;
        },
        onLeave: ()=>{
            lenis.options.wheelMultiplier = 1;
        },
        onEnterBack: ()=>{
            lenis.options.wheelMultiplier = 0.03;
        },
        onLeaveBack: ()=>{
            lenis.options.wheelMultiplier = 1;
        }
    });
    // ============================================================
    // CONV - SLIDER IMG
    // ============================================================
    (0, $iNA1s.ScrollTrigger).create({
        trigger: container,
        start: "top top",
        end: "bottom bottom",
        onUpdate (self) {
            const p = self.progress;
            groups.forEach((group, g)=>{
                const groupStart = g * GROUP_SEG;
                const groupP = (p - groupStart) / GROUP_SEG;
                const blocks = [
                    ...group.querySelectorAll(".copy-block")
                ];
                const isFirst = g === 0;
                const isLast = g === NUM_GROUPS - 1;
                const isActive = (isFirst ? groupP >= 0 : groupP > 0) && (isLast ? true : groupP < 1);
                const exitP = !isLast && groupP > 0.6 ? (groupP - 0.6) / 0.4 : 0;
                const exitX = `${-exitP * 110}vw`;
                const imgs = group.querySelectorAll(".copy-img");
                const ig = imageGroupes[g];
                if (ig) {
                    if (!isActive) {
                        (0, $4AGbv.default).killTweensOf(ig);
                        (0, $4AGbv.default).killTweensOf(ig.querySelectorAll("img"));
                        (0, $4AGbv.default).set(ig, {
                            autoAlpha: 0,
                            display: "none"
                        });
                        igFaded.set(ig, false);
                    } else {
                        if (!igFaded.get(ig)) {
                            igFaded.set(ig, true);
                            (0, $4AGbv.default).set(ig, {
                                display: "flex",
                                autoAlpha: 1
                            });
                            const igImgs = ig.querySelectorAll("img");
                            (0, $4AGbv.default).set(igImgs, {
                                autoAlpha: 0
                            });
                            (0, $4AGbv.default).to(igImgs, {
                                autoAlpha: 1,
                                duration: 1.5,
                                ease: "power2.out",
                                stagger: 0.4
                            });
                        }
                        (0, $4AGbv.default).set(ig, {
                            x: exitX
                        });
                    }
                }
                // ============================================================
                // CONV - RESET DES BLOQUES SI INNACTIF
                // ============================================================
                if (!isActive) {
                    blocks.forEach((block)=>{
                        resetBlock(block);
                        blockVisible.set(block, false);
                        blockCrossed.set(block, false);
                    });
                    (0, $4AGbv.default).set(imgs, {
                        autoAlpha: 0
                    });
                    groupXFired.set(group, [
                        false,
                        false,
                        false
                    ]);
                    return;
                }
                (0, $4AGbv.default).set(imgs, {
                    autoAlpha: 1,
                    x: exitX
                });
                // ============================================================
                // CONV - STAGGER D'APPARITION DES BLOCS
                // ============================================================
                blocks.forEach((block, b)=>{
                    if (blockCrossed.get(block)) return;
                    const blockStart = b * STAGGER_RATIO;
                    const localP = (groupP - blockStart) / STAGGER_RATIO;
                    let blockOpacity = 0;
                    if (localP >= 1) blockOpacity = 1;
                    else if (localP > 0) blockOpacity = localP;
                    const wasVisible = blockVisible.get(block);
                    const isNowVisible = blockOpacity > 0;
                    // ============================================================
                    // CONV - SLIDER - SCROLL TROP RAPIDE, AFFICHEAGE SANS ANIMATION
                    // ============================================================
                    if (!wasVisible && isNowVisible) {
                        killPendingDelay(block);
                        if (localP >= 1) {
                            const spans = block.querySelectorAll("p span > span");
                            (0, $4AGbv.default).killTweensOf(spans);
                            (0, $4AGbv.default).set(spans, {
                                y: "0%"
                            });
                        } else animateWords(block);
                    // ============================================================
                    // CONV - SLIDER - SCROLL RETOUR, RESET DES MOTS
                    // ============================================================
                    } else if (wasVisible && !isNowVisible) {
                        const spans = block.querySelectorAll("p span > span");
                        (0, $4AGbv.default).killTweensOf(spans);
                        (0, $4AGbv.default).set(spans, {
                            y: "100%"
                        });
                    }
                    blockVisible.set(block, isNowVisible);
                    (0, $4AGbv.default).set(block, {
                        autoAlpha: blockOpacity
                    });
                });
                // ============================================================
                // CONV - SLIDER - CROSSFADE DES TEXT
                // ============================================================
                if (!isLast) {
                    const nextGroup = groups[g + 1];
                    const nextBlocks = [
                        ...nextGroup.querySelectorAll(".copy-block")
                    ];
                    const fired = groupXFired.get(group);
                    CROSSFADE_THRESHOLDS.forEach((threshold, b)=>{
                        if (groupP >= threshold && !fired[b]) {
                            fired[b] = true;
                            if (blocks[b]) animateWordsOut(blocks[b]);
                            if (nextBlocks[b]) {
                                killPendingDelay(nextBlocks[b]);
                                (0, $4AGbv.default).set(nextBlocks[b], {
                                    autoAlpha: 1
                                });
                                animateWords(nextBlocks[b]);
                                blockVisible.set(nextBlocks[b], true);
                                blockCrossed.set(nextBlocks[b], true);
                            }
                        } else if (groupP < threshold && fired[b]) {
                            fired[b] = false;
                            if (nextBlocks[b]) {
                                resetBlock(nextBlocks[b]);
                                blockVisible.set(nextBlocks[b], false);
                                blockCrossed.set(nextBlocks[b], false);
                            }
                            if (blocks[b]) {
                                (0, $4AGbv.default).killTweensOf(blocks[b].querySelectorAll("p span > span"));
                                (0, $4AGbv.default).set(blocks[b].querySelectorAll("p span > span"), {
                                    y: "0%"
                                });
                            }
                        }
                    });
                }
            });
        }
    });
    // ============================================================
    // CONV - SLIDER - REFRESH QUAND PANEL SE FERME
    // ============================================================
    new MutationObserver(()=>{
        if (!document.body.classList.contains("panel-open")) (0, $iNA1s.ScrollTrigger).refresh();
    }).observe(document.body, {
        attributes: true,
        attributeFilter: [
            "class"
        ]
    });
}


// ============================================================
//  SCROLL SECTION — DANTE - GALLERIE
// ============================================================
function $4e74ac1112ac791b$export$6a1f221ffca70c82() {
    const section = document.getElementById("scrollLock");
    if (!section) return;
    const stages = document.querySelectorAll(".text-stage");
    const scrollHint = document.getElementById("scrollHint");
    const total = stages.length;
    const galleryTrack = document.getElementById("galleryTrack");
    let currentActive = -1;
    let targetY = 0;
    let currentY = 0;
    const ease = 0.08;
    function activate(index) {
        if (index === currentActive) return;
        stages.forEach((s, i)=>{
            if (i === currentActive) {
                s.classList.remove("is-active");
                s.classList.add("is-exiting");
                setTimeout(()=>s.classList.remove("is-exiting"), 400);
            } else s.classList.remove("is-active", "is-exiting");
        });
        if (index >= 0 && index < total) stages[index].classList.add("is-active");
        currentActive = index;
    }
    function onScroll() {
        const rect = section.getBoundingClientRect();
        const scrolled = -rect.top;
        const scrollable = section.offsetHeight - window.innerHeight;
        const progress = Math.max(0, Math.min(1, scrolled / scrollable));
        const activeIndex = Math.min(total - 1, Math.floor(progress / (1 / total)));
        activate(activeIndex);
        if (scrollHint) scrollHint.style.opacity = progress > 0.03 ? "0" : "1";
        if (galleryTrack) {
            const maxScroll = galleryTrack.scrollHeight - window.innerHeight;
            targetY = -progress * maxScroll;
        }
    }
    function animateGallery() {
        currentY += (targetY - currentY) * ease;
        if (galleryTrack) galleryTrack.style.transform = `translateY(${currentY}px)`;
        requestAnimationFrame(animateGallery);
    }
    window.addEventListener("scroll", onScroll, {
        passive: true
    });
    onScroll();
    animateGallery();
}


(0, $4AGbv.default).registerPlugin((0, $iNA1s.ScrollTrigger), (0, $5a019fe42b4630c1$export$f2a139e5d18b9882));
// ============================================================
// MAIN - CONFIG PAGES ET NAVIGATION
// ============================================================
const $54b47fc030b7b21e$var$pageOrder = [
    "index",
    "dante",
    "conversation",
    "maladie",
    "autoportrait",
    "index"
];
const $54b47fc030b7b21e$var$pageUrls = {
    index: "/index.html",
    dante: "/dante.html",
    conversation: "/conversation.html",
    maladie: "/maladie.html",
    autoportrait: "/autoportrait.html"
};
// ============================================================
// MAIN - ÉTAT GLOBAL
// ============================================================
let $54b47fc030b7b21e$var$isTransitioning = false;
let $54b47fc030b7b21e$var$isGoingBack = false;
let $54b47fc030b7b21e$var$currentPageNamespace = null;
let $54b47fc030b7b21e$var$footerReady = false;
let $54b47fc030b7b21e$var$footerScrollAccum = 0;
const $54b47fc030b7b21e$var$FOOTER_SCROLL_THRESHOLD = 400;
let $54b47fc030b7b21e$var$headerReady = false;
let $54b47fc030b7b21e$var$headerScrollAccum = 0;
const $54b47fc030b7b21e$var$HEADER_SCROLL_THRESHOLD = 400;
let $54b47fc030b7b21e$var$headerProgressEl = null;
let $54b47fc030b7b21e$var$headerProgressBarEl = null;
const $54b47fc030b7b21e$var$layerBg = document.getElementById("layerBg");
const $54b47fc030b7b21e$var$layerFg = document.getElementById("layerFg");
// ============================================================
// MAIN - PARALLAXE SOURIS (image header)
// ============================================================
const $54b47fc030b7b21e$var$SPEED_BG = 10, $54b47fc030b7b21e$var$SPEED_FG = 22, $54b47fc030b7b21e$var$LERP = 0.07;
let $54b47fc030b7b21e$var$tBgX = 0, $54b47fc030b7b21e$var$tBgY = 0, $54b47fc030b7b21e$var$tFgX = 0, $54b47fc030b7b21e$var$tFgY = 0;
let $54b47fc030b7b21e$var$cBgX = 0, $54b47fc030b7b21e$var$cBgY = 0, $54b47fc030b7b21e$var$cFgX = 0, $54b47fc030b7b21e$var$cFgY = 0;
function $54b47fc030b7b21e$var$lerp(a, b, t) {
    return a + (b - a) * t;
}
if ($54b47fc030b7b21e$var$layerBg && $54b47fc030b7b21e$var$layerFg) (function animate() {
    $54b47fc030b7b21e$var$cBgX = $54b47fc030b7b21e$var$lerp($54b47fc030b7b21e$var$cBgX, $54b47fc030b7b21e$var$tBgX, $54b47fc030b7b21e$var$LERP);
    $54b47fc030b7b21e$var$cBgY = $54b47fc030b7b21e$var$lerp($54b47fc030b7b21e$var$cBgY, $54b47fc030b7b21e$var$tBgY, $54b47fc030b7b21e$var$LERP);
    $54b47fc030b7b21e$var$cFgX = $54b47fc030b7b21e$var$lerp($54b47fc030b7b21e$var$cFgX, $54b47fc030b7b21e$var$tFgX, $54b47fc030b7b21e$var$LERP);
    $54b47fc030b7b21e$var$cFgY = $54b47fc030b7b21e$var$lerp($54b47fc030b7b21e$var$cFgY, $54b47fc030b7b21e$var$tFgY, $54b47fc030b7b21e$var$LERP);
    $54b47fc030b7b21e$var$layerBg.style.transform = `translate(${$54b47fc030b7b21e$var$cBgX}px,${$54b47fc030b7b21e$var$cBgY}px)`;
    $54b47fc030b7b21e$var$layerFg.style.transform = `translate(${$54b47fc030b7b21e$var$cFgX}px,${$54b47fc030b7b21e$var$cFgY}px)`;
    requestAnimationFrame(animate);
})();
document.addEventListener("mousemove", (e)=>{
    const nx = (e.clientX / window.innerWidth - 0.5) * 2;
    const ny = (e.clientY / window.innerHeight - 0.5) * 2;
    $54b47fc030b7b21e$var$tBgX = -nx * $54b47fc030b7b21e$var$SPEED_BG;
    $54b47fc030b7b21e$var$tBgY = -ny * $54b47fc030b7b21e$var$SPEED_BG;
    $54b47fc030b7b21e$var$tFgX = -nx * $54b47fc030b7b21e$var$SPEED_FG;
    $54b47fc030b7b21e$var$tFgY = -ny * $54b47fc030b7b21e$var$SPEED_FG;
});
document.addEventListener("mouseleave", ()=>{
    $54b47fc030b7b21e$var$tBgX = 0;
    $54b47fc030b7b21e$var$tBgY = 0;
    $54b47fc030b7b21e$var$tFgX = 0;
    $54b47fc030b7b21e$var$tFgY = 0;
});
// ============================================================
// MAIN - LENIS + SCROLL
// ============================================================
const $54b47fc030b7b21e$var$lenis = new (0, $8ecb29f509dc0bd0$export$2e2bcd8739ae039)();
window.__lenis = $54b47fc030b7b21e$var$lenis;
function $54b47fc030b7b21e$var$raf(time) {
    $54b47fc030b7b21e$var$lenis.raf(time);
    (0, $iNA1s.ScrollTrigger).update();
    requestAnimationFrame($54b47fc030b7b21e$var$raf);
}
requestAnimationFrame($54b47fc030b7b21e$var$raf);
$54b47fc030b7b21e$var$lenis.on("scroll", (0, $iNA1s.ScrollTrigger).update);
const $54b47fc030b7b21e$var$progressBar = document.getElementById("scroll-progress-bar");
$54b47fc030b7b21e$var$lenis.on("scroll", ({ scroll: scroll, limit: limit })=>{
    if ($54b47fc030b7b21e$var$progressBar) $54b47fc030b7b21e$var$progressBar.style.height = `${scroll / limit * 100}%`;
});
// ============================================================
// MAIN - UTILITAIRE GSAP
// ============================================================
function $54b47fc030b7b21e$var$gsapPromise(target, vars) {
    return new Promise((resolve)=>{
        (0, $4AGbv.default).to(target, {
            ...vars,
            onComplete: resolve
        });
    });
}
function $54b47fc030b7b21e$export$6243399072c0c4e3() {
    (0, $iNA1s.ScrollTrigger).getAll().filter((st)=>st.vars?.id !== "text-anim").forEach((st)=>st.kill());
    const pinnedSection = document.querySelector(".pinned-section");
    if (!pinnedSection) return;
    (0, $iNA1s.ScrollTrigger).create({
        trigger: ".pinned-section",
        start: "top top",
        end: "bottom bottom",
        pin: ".pinned-wrapper",
        pinSpacing: false
    });
    const isDante = !!pinnedSection.querySelector(".image-track--dante");
    const cards = pinnedSection.querySelectorAll(".img-card");
    cards.forEach((card, i)=>{
        const speed = parseFloat(card.dataset.speed) || 2;
        const endRotation = parseFloat(card.dataset.rotation) || 0;
        const startY = isDante ? window.innerHeight * (1.2 + i * 0.2) : window.innerHeight * (0.8 + i * 0.15);
        const endY = isDante ? -window.innerHeight * (0.15 + i * 0.08) : -window.innerHeight * (0.3 + i * 0.1);
        (0, $4AGbv.default).fromTo(card, {
            y: startY,
            opacity: 1,
            scale: isDante ? 1 : 0.92,
            rotation: i % 2 === 0 ? -5 : 3
        }, {
            y: endY,
            opacity: 1,
            scale: 1,
            rotation: endRotation,
            ease: isDante ? "power2.out" : "none",
            scrollTrigger: {
                trigger: ".pinned-section",
                start: "top top",
                end: "bottom bottom",
                scrub: isDante ? 1.8 * speed : 0.8 * speed
            }
        });
    });
    (0, $4AGbv.default).fromTo(".text-layer", {
        opacity: 0,
        y: 40
    }, {
        opacity: 1,
        y: 0,
        duration: 1,
        scrollTrigger: {
            trigger: ".pinned-section",
            start: "top 80%",
            end: "top 20%",
            scrub: true
        }
    });
    const progressBar = document.getElementById("progressBar");
    if (progressBar) (0, $iNA1s.ScrollTrigger).create({
        trigger: ".pinned-section",
        start: "top top",
        end: "bottom bottom",
        onUpdate: (self)=>{
            progressBar.style.width = Math.round(self.progress * 100) + "%";
        }
    });
    (0, $iNA1s.ScrollTrigger).refresh();
}
// ============================================================
// MAIN - ZOOM SCROLL (section after)
// ============================================================
function $54b47fc030b7b21e$var$initAfterSectionZoom() {
    const imgs = document.querySelectorAll(".mother img, .father img");
    if (!imgs.length) return;
    imgs.forEach((img)=>{
        (0, $4AGbv.default).fromTo(img, {
            scale: 1
        }, {
            scale: 1.08,
            ease: "none",
            scrollTrigger: {
                trigger: img,
                start: "top bottom",
                end: "bottom top",
                scrub: 1
            }
        });
    });
}
// ============================================================
// MAIN - IMAGE PATRICIA (pendaison + chute)
// ============================================================
function $54b47fc030b7b21e$var$initPatriciaHangingImage() {
    const section = document.querySelector(".patricia");
    const wrapper = document.getElementById("hanging-pat-wrapper");
    if (!section || !wrapper) return;
    wrapper.classList.remove("falling", "fallen", "no-string");
    wrapper.classList.add("swinging");
    wrapper.style.transform = "";
    let fell = false;
    function triggerFall() {
        if (fell) return;
        fell = true;
        const sectionRect = section.getBoundingClientRect();
        const wrapperRect = wrapper.getBoundingClientRect();
        const wrapperTopInSection = wrapperRect.top - sectionRect.top;
        const fallY = section.offsetHeight - wrapperTopInSection - wrapper.offsetHeight - 10;
        wrapper.style.setProperty("--fall-y", fallY + "px");
        wrapper.classList.remove("swinging");
        wrapper.classList.add("no-string");
        wrapper.style.transform = "rotate(0deg)";
        requestAnimationFrame(()=>requestAnimationFrame(()=>{
                wrapper.style.transform = "";
                wrapper.classList.add("falling");
                wrapper.addEventListener("animationend", ()=>{
                    wrapper.classList.remove("falling");
                    wrapper.classList.add("fallen");
                    wrapper.style.transform = `translateY(${fallY}px) rotate(-2deg)`;
                }, {
                    once: true
                });
            }));
    }
    (0, $iNA1s.ScrollTrigger).create({
        trigger: section,
        start: "center 80%",
        once: true,
        onEnter: triggerFall
    });
}
// ============================================================
// MAIN - LIGNES SVG INTERACTIVES
// ============================================================
function $54b47fc030b7b21e$var$initSVGLine(scope, axis = "y", strength = 0.5) {
    const svg = scope.querySelector("svg");
    const path = scope.querySelector(".line-path");
    const hit = scope.querySelector(".line-hit");
    if (!svg || !path || !hit) return;
    let connected = false;
    const start = axis === "y" ? 200 : 50;
    const mid = axis === "y" ? 400 : 400;
    const end = axis === "y" ? 800 : 800;
    const viewMid = axis === "y" ? 400 : 100;
    let p0 = axis === "y" ? {
        x: 0,
        y: start
    } : {
        x: start,
        y: 0
    };
    let p1 = axis === "y" ? {
        x: mid,
        y: start
    } : {
        x: start,
        y: mid
    };
    let p2 = axis === "y" ? {
        x: end,
        y: start
    } : {
        x: start,
        y: end
    };
    let target = start;
    function curveString() {
        return `M${p0.x},${p0.y} Q${p1.x},${p1.y} ${p2.x},${p2.y}`;
    }
    function render() {
        if (axis === "y") p1.y += (target - p1.y) * strength;
        const d = curveString();
        path.setAttribute("d", d);
        hit.setAttribute("d", d);
    }
    (0, $4AGbv.default).ticker.add(render);
    svg.addEventListener("pointermove", (e)=>{
        const rect = svg.getBoundingClientRect();
        const overPath = e.target === hit;
        if (!connected && overPath) {
            connected = true;
            (0, $4AGbv.default).killTweensOf(p1);
        }
        if (connected) {
            if (axis === "y") {
                const y = (e.clientY - rect.top) * (400 / rect.height);
                target = (y * 2 - (p0.y + p2.y) / 2) * 0.15 + start * 0.85;
            } else {
                const x = (e.clientX - rect.left) * (viewMid / rect.width);
                p1.x = (x * 2 - (p0.x + p2.x) / 2) * 0.15 + start * 0.85;
            }
        }
    });
    svg.addEventListener("pointerleave", ()=>{
        connected = false;
        if (axis === "y") (0, $4AGbv.default).to({
            v: target
        }, {
            v: start,
            duration: 0.9,
            ease: "elastic.out(1,0.3)",
            onUpdate: function() {
                target = this.targets()[0].v;
            }
        });
        else (0, $4AGbv.default).to(p1, {
            duration: 0.9,
            x: start,
            ease: "elastic.out(1,0.3)"
        });
    });
    render();
}
// ============================================================
// MAIN - SLIDER ANIMATION (index)
// ============================================================
function $54b47fc030b7b21e$var$initSliderAnimation() {
    const sliderMask = document.querySelector(".slider-mask");
    if (!sliderMask) return;
    (0, $4AGbv.default).to(".slider-container", {
        x: "-33%",
        scrollTrigger: {
            trigger: ".slider-mask",
            start: "top top",
            end: "500%",
            scrub: true,
            pin: true
        }
    });
    (0, $4AGbv.default).to(".slider-item", {
        opacity: 1,
        scrollTrigger: {
            trigger: ".slider-item",
            scrub: true,
            start: "left 100%"
        }
    });
    const itemOffsets = [
        "-8%",
        "-6%",
        "-5%",
        "-7%",
        "-6%",
        "-4%",
        "-5%"
    ];
    itemOffsets.forEach((x, i)=>{
        (0, $4AGbv.default).to(`#item-${i + 1}`, {
            opacity: 1,
            x: x,
            scrollTrigger: {
                trigger: ".slider-mask",
                start: "top top",
                end: "+=500%",
                scrub: 1
            }
        });
    });
}
// ============================================================
// MAIN - CURSEUR PERSONNALISÉ
// ============================================================
const $54b47fc030b7b21e$var$cursorConfigs = {
    index: {
        pointsNumber: 5,
        widthFactor: 0.5,
        spring: 0.4,
        friction: 0.5,
        strokeStyle: "rgba(0, 0, 0, 0.85)"
    },
    dante: {
        pointsNumber: 5,
        widthFactor: 0.5,
        spring: 0.4,
        friction: 0.5,
        strokeStyle: "rgb(255, 0, 0)"
    },
    conversation: {
        pointsNumber: 5,
        widthFactor: 0.5,
        spring: 0.4,
        friction: 0.3,
        strokeStyle: "rgb(255, 250, 103)"
    },
    maladie: {
        pointsNumber: 5,
        widthFactor: 0.5,
        spring: 0.4,
        friction: 0.15,
        strokeStyle: "#555555"
    },
    autoportrait: {
        pointsNumber: 5,
        widthFactor: 0.5,
        spring: 0.3,
        friction: 0.14,
        strokeStyle: "#272727"
    }
};
let $54b47fc030b7b21e$var$cursorAnimationId = null;
let $54b47fc030b7b21e$var$cursorMouseMoved = false;
let $54b47fc030b7b21e$var$cursorIdleTimer = null;
const $54b47fc030b7b21e$var$CURSOR_IDLE_DELAY = 6000;
const $54b47fc030b7b21e$var$cursorPointer = {
    x: 0.5 * window.innerWidth,
    y: 0.5 * window.innerHeight
};
function $54b47fc030b7b21e$var$resetCursorIdleTimer() {
    clearTimeout($54b47fc030b7b21e$var$cursorIdleTimer);
    $54b47fc030b7b21e$var$cursorIdleTimer = setTimeout(()=>{
        $54b47fc030b7b21e$var$cursorMouseMoved = false;
    }, $54b47fc030b7b21e$var$CURSOR_IDLE_DELAY);
}
function $54b47fc030b7b21e$var$onCursorClick(e) {
    $54b47fc030b7b21e$var$cursorPointer.x = e.clientX;
    $54b47fc030b7b21e$var$cursorPointer.y = e.clientY;
}
function $54b47fc030b7b21e$var$onCursorMouseMove(e) {
    $54b47fc030b7b21e$var$cursorMouseMoved = true;
    $54b47fc030b7b21e$var$cursorPointer.x = e.clientX;
    $54b47fc030b7b21e$var$cursorPointer.y = e.clientY;
    $54b47fc030b7b21e$var$resetCursorIdleTimer();
}
function $54b47fc030b7b21e$var$onCursorTouchMove(e) {
    $54b47fc030b7b21e$var$cursorMouseMoved = true;
    $54b47fc030b7b21e$var$cursorPointer.x = e.targetTouches[0].clientX;
    $54b47fc030b7b21e$var$cursorPointer.y = e.targetTouches[0].clientY;
    $54b47fc030b7b21e$var$resetCursorIdleTimer();
}
window.addEventListener("click", $54b47fc030b7b21e$var$onCursorClick);
window.addEventListener("mousemove", $54b47fc030b7b21e$var$onCursorMouseMove);
window.addEventListener("touchmove", $54b47fc030b7b21e$var$onCursorTouchMove);
function $54b47fc030b7b21e$var$initCursor(namespace) {
    if ($54b47fc030b7b21e$var$cursorAnimationId) {
        cancelAnimationFrame($54b47fc030b7b21e$var$cursorAnimationId);
        $54b47fc030b7b21e$var$cursorAnimationId = null;
    }
    const canvas = document.querySelector("canvas");
    if (!canvas) return;
    const ctx = canvas.getContext("2d");
    const params = $54b47fc030b7b21e$var$cursorConfigs[namespace] || $54b47fc030b7b21e$var$cursorConfigs.index;
    const trail = new Array(params.pointsNumber);
    for(let i = 0; i < params.pointsNumber; i++)trail[i] = {
        x: $54b47fc030b7b21e$var$cursorPointer.x,
        y: $54b47fc030b7b21e$var$cursorPointer.y,
        dx: 0,
        dy: 0
    };
    function setupCanvas() {
        canvas.width = window.innerWidth;
        canvas.height = window.innerHeight;
    }
    setupCanvas();
    window.removeEventListener("resize", setupCanvas);
    window.addEventListener("resize", setupCanvas);
    function update(t) {
        if (!$54b47fc030b7b21e$var$cursorMouseMoved) {
            $54b47fc030b7b21e$var$cursorPointer.x = (0.5 + 0.3 * Math.cos(0.0008 * t) * Math.sin(0.002 * t)) * window.innerWidth;
            $54b47fc030b7b21e$var$cursorPointer.y = (0.5 + 0.2 * Math.cos(0.002 * t) + 0.1 * Math.cos(0.004 * t)) * window.innerHeight;
        }
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        ctx.strokeStyle = params.strokeStyle;
        trail.forEach((p, pIdx)=>{
            const prev = pIdx === 0 ? $54b47fc030b7b21e$var$cursorPointer : trail[pIdx - 1];
            const spring = pIdx === 0 ? 0.4 * params.spring : params.spring;
            p.dx += (prev.x - p.x) * spring;
            p.dy += (prev.y - p.y) * spring;
            p.dx *= params.friction;
            p.dy *= params.friction;
            p.x += p.dx;
            p.y += p.dy;
        });
        ctx.lineCap = "round";
        ctx.beginPath();
        ctx.moveTo(trail[0].x, trail[0].y);
        for(let i = 1; i < trail.length - 1; i++){
            const xc = 0.5 * (trail[i].x + trail[i + 1].x);
            const yc = 0.5 * (trail[i].y + trail[i + 1].y);
            ctx.quadraticCurveTo(trail[i].x, trail[i].y, xc, yc);
            ctx.lineWidth = params.widthFactor * (params.pointsNumber - i);
            ctx.stroke();
        }
        ctx.lineTo(trail[trail.length - 1].x, trail[trail.length - 1].y);
        ctx.stroke();
        $54b47fc030b7b21e$var$cursorAnimationId = window.requestAnimationFrame(update);
    }
    $54b47fc030b7b21e$var$cursorAnimationId = window.requestAnimationFrame(update);
}
// ============================================================
// MAIN - NAVIGATION ENTRE PAGES
// ============================================================
function $54b47fc030b7b21e$var$getNextPage(currentNamespace) {
    const currentIndex = $54b47fc030b7b21e$var$pageOrder.indexOf(currentNamespace);
    if (currentIndex !== -1 && currentIndex < $54b47fc030b7b21e$var$pageOrder.length - 1) return $54b47fc030b7b21e$var$pageOrder[currentIndex + 1];
    return null;
}
function $54b47fc030b7b21e$var$getPreviousPage(currentNamespace) {
    const currentIndex = $54b47fc030b7b21e$var$pageOrder.indexOf(currentNamespace);
    if (currentIndex > 0) return $54b47fc030b7b21e$var$pageOrder[currentIndex - 1];
    return null;
}
// ============================================================
// MAIN - BARRE DE PROGRESSION FOOTER / HEADER
// ============================================================
let $54b47fc030b7b21e$var$progressEl = null;
let $54b47fc030b7b21e$var$progressBarEl = null;
function $54b47fc030b7b21e$var$getOrCreateProgressBar() {
    if (!$54b47fc030b7b21e$var$progressEl) {
        $54b47fc030b7b21e$var$progressEl = document.createElement("div");
        $54b47fc030b7b21e$var$progressEl.className = "footer-progress";
        $54b47fc030b7b21e$var$progressBarEl = document.createElement("div");
        $54b47fc030b7b21e$var$progressBarEl.className = "footer-progress__bar";
        $54b47fc030b7b21e$var$progressEl.appendChild($54b47fc030b7b21e$var$progressBarEl);
        document.body.appendChild($54b47fc030b7b21e$var$progressEl);
    }
    return {
        progressEl: $54b47fc030b7b21e$var$progressEl,
        progressBarEl: $54b47fc030b7b21e$var$progressBarEl
    };
}
function $54b47fc030b7b21e$var$resetFooterProgress() {
    $54b47fc030b7b21e$var$footerScrollAccum = 0;
    $54b47fc030b7b21e$var$footerReady = false;
    window.removeEventListener("wheel", $54b47fc030b7b21e$var$onFooterWheel);
    const { progressEl: progressEl, progressBarEl: progressBarEl } = $54b47fc030b7b21e$var$getOrCreateProgressBar();
    progressEl.classList.remove("visible");
    progressBarEl.style.width = "0%";
}
function $54b47fc030b7b21e$var$getOrCreateHeaderProgressBar() {
    if (!$54b47fc030b7b21e$var$headerProgressEl) {
        $54b47fc030b7b21e$var$headerProgressEl = document.createElement("div");
        $54b47fc030b7b21e$var$headerProgressEl.className = "header-progress";
        $54b47fc030b7b21e$var$headerProgressBarEl = document.createElement("div");
        $54b47fc030b7b21e$var$headerProgressBarEl.className = "header-progress__bar";
        $54b47fc030b7b21e$var$headerProgressEl.appendChild($54b47fc030b7b21e$var$headerProgressBarEl);
        document.body.appendChild($54b47fc030b7b21e$var$headerProgressEl);
    }
    return {
        progressEl: $54b47fc030b7b21e$var$headerProgressEl,
        progressBarEl: $54b47fc030b7b21e$var$headerProgressBarEl
    };
}
function $54b47fc030b7b21e$var$resetHeaderProgress() {
    $54b47fc030b7b21e$var$headerScrollAccum = 0;
    $54b47fc030b7b21e$var$headerReady = false;
    window.removeEventListener("wheel", $54b47fc030b7b21e$var$onHeaderWheel);
    const { progressEl: progressEl, progressBarEl: progressBarEl } = $54b47fc030b7b21e$var$getOrCreateHeaderProgressBar();
    progressEl.classList.remove("visible");
    progressBarEl.style.width = "0%";
}
function $54b47fc030b7b21e$var$triggerPrevPage() {
    const prevPage = $54b47fc030b7b21e$var$getPreviousPage($54b47fc030b7b21e$var$currentPageNamespace);
    if (!prevPage) return;
    $54b47fc030b7b21e$var$isTransitioning = true;
    $54b47fc030b7b21e$var$isGoingBack = true;
    $54b47fc030b7b21e$var$resetHeaderProgress();
    window.removeEventListener("scroll", $54b47fc030b7b21e$var$handleScroll);
    (0, (/*@__PURE__*/$parcel$interopDefault($f233fb7ce3af900a$exports))).go($54b47fc030b7b21e$var$pageUrls[prevPage]).catch(()=>{
        $54b47fc030b7b21e$var$isTransitioning = false;
        $54b47fc030b7b21e$var$isGoingBack = false;
        window.addEventListener("scroll", $54b47fc030b7b21e$var$handleScroll);
    });
}
function $54b47fc030b7b21e$var$onHeaderWheel(e) {
    if (!$54b47fc030b7b21e$var$headerReady || $54b47fc030b7b21e$var$isTransitioning) return;
    const { progressBarEl: progressBarEl } = $54b47fc030b7b21e$var$getOrCreateHeaderProgressBar();
    if (e.deltaY < 0) $54b47fc030b7b21e$var$headerScrollAccum = Math.min($54b47fc030b7b21e$var$headerScrollAccum + Math.abs(e.deltaY), $54b47fc030b7b21e$var$HEADER_SCROLL_THRESHOLD);
    else $54b47fc030b7b21e$var$headerScrollAccum = Math.max($54b47fc030b7b21e$var$headerScrollAccum - e.deltaY, 0);
    const pct = $54b47fc030b7b21e$var$headerScrollAccum / $54b47fc030b7b21e$var$HEADER_SCROLL_THRESHOLD * 100;
    progressBarEl.style.width = pct + "%";
    if ($54b47fc030b7b21e$var$headerScrollAccum >= $54b47fc030b7b21e$var$HEADER_SCROLL_THRESHOLD) $54b47fc030b7b21e$var$triggerPrevPage();
}
function $54b47fc030b7b21e$var$triggerNextPage() {
    const nextPage = $54b47fc030b7b21e$var$getNextPage($54b47fc030b7b21e$var$currentPageNamespace);
    if (!nextPage) return;
    $54b47fc030b7b21e$var$isTransitioning = true;
    $54b47fc030b7b21e$var$resetFooterProgress();
    window.removeEventListener("scroll", $54b47fc030b7b21e$var$handleScroll);
    (0, (/*@__PURE__*/$parcel$interopDefault($f233fb7ce3af900a$exports))).go($54b47fc030b7b21e$var$pageUrls[nextPage]).catch(()=>{
        $54b47fc030b7b21e$var$isTransitioning = false;
        window.addEventListener("scroll", $54b47fc030b7b21e$var$handleScroll);
    });
}
function $54b47fc030b7b21e$var$onFooterWheel(e) {
    if (!$54b47fc030b7b21e$var$footerReady || $54b47fc030b7b21e$var$isTransitioning) return;
    const { progressBarEl: progressBarEl } = $54b47fc030b7b21e$var$getOrCreateProgressBar();
    if (e.deltaY > 0) $54b47fc030b7b21e$var$footerScrollAccum = Math.min($54b47fc030b7b21e$var$footerScrollAccum + e.deltaY, $54b47fc030b7b21e$var$FOOTER_SCROLL_THRESHOLD);
    else $54b47fc030b7b21e$var$footerScrollAccum = Math.max($54b47fc030b7b21e$var$footerScrollAccum + e.deltaY, 0);
    const pct = $54b47fc030b7b21e$var$footerScrollAccum / $54b47fc030b7b21e$var$FOOTER_SCROLL_THRESHOLD * 100;
    progressBarEl.style.width = pct + "%";
    if ($54b47fc030b7b21e$var$footerScrollAccum >= $54b47fc030b7b21e$var$FOOTER_SCROLL_THRESHOLD) $54b47fc030b7b21e$var$triggerNextPage();
}
// ============================================================
// MAIN - DÉTECTION SCROLL (haut/bas de page)
// ============================================================
function $54b47fc030b7b21e$var$handleScroll() {
    if ($54b47fc030b7b21e$var$isTransitioning) return;
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const windowHeight = window.innerHeight;
    const documentHeight = document.documentElement.scrollHeight;
    if (scrollTop + windowHeight >= documentHeight - 10) {
        const nextPage = $54b47fc030b7b21e$var$getNextPage($54b47fc030b7b21e$var$currentPageNamespace);
        if (nextPage && !$54b47fc030b7b21e$var$footerReady) {
            $54b47fc030b7b21e$var$footerReady = true;
            $54b47fc030b7b21e$var$footerScrollAccum = 0;
            const { progressEl: progressEl } = $54b47fc030b7b21e$var$getOrCreateProgressBar();
            progressEl.classList.add("visible");
            window.addEventListener("wheel", $54b47fc030b7b21e$var$onFooterWheel, {
                passive: true
            });
        }
    } else if ($54b47fc030b7b21e$var$footerReady) $54b47fc030b7b21e$var$resetFooterProgress();
    if (scrollTop <= 0) {
        const prevPage = $54b47fc030b7b21e$var$getPreviousPage($54b47fc030b7b21e$var$currentPageNamespace);
        if (prevPage && !$54b47fc030b7b21e$var$headerReady) {
            $54b47fc030b7b21e$var$headerReady = true;
            $54b47fc030b7b21e$var$headerScrollAccum = 0;
            const { progressEl: progressEl } = $54b47fc030b7b21e$var$getOrCreateHeaderProgressBar();
            progressEl.classList.add("visible");
            window.addEventListener("wheel", $54b47fc030b7b21e$var$onHeaderWheel, {
                passive: true
            });
        }
    } else if ($54b47fc030b7b21e$var$headerReady) $54b47fc030b7b21e$var$resetHeaderProgress();
}
// ============================================================
// MAIN - BARBA (transitions de pages)
// ============================================================
(0, (/*@__PURE__*/$parcel$interopDefault($f233fb7ce3af900a$exports))).init({
    debug: false,
    preventRunning: true,
    transitions: [
        {
            name: "slide-transition",
            async once (data) {
                $54b47fc030b7b21e$var$currentPageNamespace = data.next.namespace;
                const container = data.next.container;
                (0, $4AGbv.default).set(container.querySelectorAll(".image-block"), {
                    y: 50,
                    opacity: 0
                });
                $54b47fc030b7b21e$export$6243399072c0c4e3();
                (0, $656174d208695581$export$498d0fb7ade0687)();
                $54b47fc030b7b21e$var$initPatriciaHangingImage();
                $54b47fc030b7b21e$var$initAfterSectionZoom();
                $54b47fc030b7b21e$var$initSliderAnimation();
                $54b47fc030b7b21e$var$initCursor(data.next.namespace);
                $54b47fc030b7b21e$var$initFooterSlowScroll();
                (0, $656174d208695581$export$b37588a3eee0f6fd)();
                (0, $656174d208695581$export$4836633f5520d527)(data.next.namespace);
                $54b47fc030b7b21e$var$setScrollSpeed(data.next.namespace);
                $54b47fc030b7b21e$var$initS3Overlay();
                (0, $bbda2dbb38b850b8$export$88099837baf9f921)();
                (0, $bbda2dbb38b850b8$export$9ed29f8b75578d20)();
                (0, $6a63b9da8492a4cf$export$315e6a39609a32c4)();
                (0, $6a63b9da8492a4cf$export$641db4a1a1211ca3)();
                (0, $592a78804c8b1cca$export$180426490a8b0f51)();
                (0, $4e74ac1112ac791b$export$6a1f221ffca70c82)();
                $54b47fc030b7b21e$var$initBubbleClick();
                requestAnimationFrame($54b47fc030b7b21e$var$initCadre);
                setTimeout(()=>{
                    window.addEventListener("scroll", $54b47fc030b7b21e$var$handleScroll);
                }, 1000);
                const transitionDir = sessionStorage.getItem("barba-transition");
                if (transitionDir) {
                    sessionStorage.removeItem("barba-transition");
                    const overlay = document.querySelector(".transition-overlay");
                    (0, $4AGbv.default).set(overlay, {
                        y: 0
                    });
                    await $54b47fc030b7b21e$var$gsapPromise(overlay, {
                        y: transitionDir === "back" ? "100%" : "-100%",
                        duration: 1.2,
                        ease: "power3.inOut",
                        delay: 0.4
                    });
                    (0, $4AGbv.default).set(overlay, {
                        y: "100%"
                    });
                }
                (0, $d5da25764ebe9a7c$export$49096fa2ca92ad92)();
                (0, $7su0d.initInfoPanel)();
            },
            async leave (data) {
                window.removeEventListener("scroll", $54b47fc030b7b21e$var$handleScroll);
                const tlNav = document.getElementById("tl-nav");
                if (tlNav) tlNav.classList.add("hidden");
                (0, $656174d208695581$export$4836633f5520d527)(null);
                const toggle = document.getElementById("info-toggle");
                if (toggle) {
                    document.body.classList.remove("panel-open");
                    toggle.textContent = "i";
                }
                (0, $iNA1s.ScrollTrigger).getAll().forEach((st)=>st.kill());
                (0, $4AGbv.default).killTweensOf("*");
                const overlay = document.querySelector(".transition-overlay");
                const currentContainer = data.current.container;
                await $54b47fc030b7b21e$var$gsapPromise(currentContainer, {
                    opacity: 0,
                    duration: 0.3
                });
                (0, $4AGbv.default).set(currentContainer, {
                    visibility: "hidden",
                    position: "absolute"
                });
                if ($54b47fc030b7b21e$var$isGoingBack) (0, $4AGbv.default).set(overlay, {
                    y: "-100%"
                });
                await $54b47fc030b7b21e$var$gsapPromise(overlay, {
                    y: 0,
                    duration: 1.2,
                    ease: "power3.inOut"
                });
                sessionStorage.setItem("barba-transition", $54b47fc030b7b21e$var$isGoingBack ? "back" : "forward");
                window.location.href = data.next.url.href;
                await new Promise(()=>{});
            },
            async enter (data) {
                $54b47fc030b7b21e$var$currentPageNamespace = data.next.namespace;
                window.scrollTo(0, 0);
                $54b47fc030b7b21e$var$lenis.scrollTo(0, {
                    immediate: true
                });
                const overlay = document.querySelector(".transition-overlay");
                const container = data.next.container;
                const toggle = document.getElementById("info-toggle");
                if (toggle) {
                    document.body.classList.remove("panel-open");
                    toggle.textContent = "i";
                }
                (0, $4AGbv.default).set(container, {
                    opacity: 0,
                    visibility: "visible",
                    position: "relative"
                });
                (0, $4AGbv.default).set(container.querySelectorAll(".image-block"), {
                    y: 50,
                    opacity: 0
                });
                (0, $4AGbv.default).set(container.querySelectorAll("[data-animate-text]"), {
                    opacity: 0,
                    y: 20
                });
                await $54b47fc030b7b21e$var$gsapPromise(overlay, {
                    y: $54b47fc030b7b21e$var$isGoingBack ? "100%" : "-100%",
                    duration: 1.2,
                    ease: "power3.inOut",
                    delay: 0.6
                });
                (0, $4AGbv.default).set(overlay, {
                    y: "100%"
                });
                $54b47fc030b7b21e$var$isGoingBack = false;
                await $54b47fc030b7b21e$var$gsapPromise(container, {
                    opacity: 1,
                    duration: 0.5
                });
                (0, $4AGbv.default).to(container.querySelectorAll("[data-animate-text]"), {
                    opacity: 1,
                    y: 0,
                    duration: 0.8,
                    stagger: 0.1,
                    ease: "power2.out"
                });
                $54b47fc030b7b21e$export$6243399072c0c4e3();
                (0, $656174d208695581$export$498d0fb7ade0687)();
                $54b47fc030b7b21e$var$initPatriciaHangingImage();
                $54b47fc030b7b21e$var$initAfterSectionZoom();
                $54b47fc030b7b21e$var$initSliderAnimation();
                $54b47fc030b7b21e$var$initCursor(data.next.namespace);
                setTimeout(()=>(0, $7su0d.initInfoPanel)(), 100);
                $54b47fc030b7b21e$var$initLogoWiggle();
                $54b47fc030b7b21e$var$initFooterSlowScroll();
                (0, $656174d208695581$export$b37588a3eee0f6fd)();
                (0, $656174d208695581$export$4836633f5520d527)(data.next.namespace);
                $54b47fc030b7b21e$var$setScrollSpeed(data.next.namespace);
                $54b47fc030b7b21e$var$initS3Overlay();
                (0, $bbda2dbb38b850b8$export$88099837baf9f921)();
                (0, $bbda2dbb38b850b8$export$9ed29f8b75578d20)();
                (0, $6a63b9da8492a4cf$export$315e6a39609a32c4)();
                (0, $6a63b9da8492a4cf$export$641db4a1a1211ca3)();
                (0, $592a78804c8b1cca$export$180426490a8b0f51)();
                (0, $4e74ac1112ac791b$export$6a1f221ffca70c82)();
                $54b47fc030b7b21e$var$initBubbleClick();
                requestAnimationFrame($54b47fc030b7b21e$var$initCadre);
                $54b47fc030b7b21e$var$isTransitioning = false;
                setTimeout(()=>{
                    window.addEventListener("scroll", $54b47fc030b7b21e$var$handleScroll);
                }, 1000);
            }
        }
    ]
});
// ============================================================
// MAIN - BOUTONS MAGNÉTIQUES
// ============================================================
function $54b47fc030b7b21e$var$initMagneticButtons() {
    const buttons = document.querySelectorAll("#info-toggle, #audio-toggle");
    const radius = 80;
    const maxIconMove = 7;
    buttons.forEach((btn)=>{
        if (!btn.querySelector("span")) btn.innerHTML = `<span style="display:inline-flex;pointer-events:none">${btn.innerHTML}</span>`;
        const icon = btn.querySelector("span");
        document.addEventListener("mousemove", (e)=>{
            const rect = btn.getBoundingClientRect();
            const cx = rect.left + rect.width / 2;
            const cy = rect.top + rect.height / 2;
            const dx = e.clientX - cx;
            const dy = e.clientY - cy;
            const dist = Math.sqrt(dx * dx + dy * dy);
            if (dist < radius) {
                const factor = 1 - dist / radius;
                const tx = Math.max(-maxIconMove, Math.min(maxIconMove, dx * 0.35 * factor));
                const ty = Math.max(-maxIconMove, Math.min(maxIconMove, dy * 0.35 * factor));
                (0, $4AGbv.default).to(icon, {
                    x: tx,
                    y: ty,
                    duration: 0.3,
                    ease: "power2.out"
                });
                (0, $4AGbv.default).to(btn, {
                    scale: 1.08,
                    duration: 0.3,
                    ease: "power2.out"
                });
            } else {
                (0, $4AGbv.default).to(icon, {
                    x: 0,
                    y: 0,
                    duration: 0.6,
                    ease: "elastic.out(1, 0.4)"
                });
                (0, $4AGbv.default).to(btn, {
                    scale: 1,
                    duration: 0.6,
                    ease: "elastic.out(1, 0.4)"
                });
            }
        });
    });
}
$54b47fc030b7b21e$var$initMagneticButtons();
// ============================================================
// MAIN - INIT LIGNES SVG AU CHARGEMENT
// ============================================================
document.querySelectorAll(".ligne-h").forEach((el)=>$54b47fc030b7b21e$var$initSVGLine(el, "y"));
document.querySelectorAll(".vertical-line-svg").forEach((el)=>$54b47fc030b7b21e$var$initSVGLine(el, "x"));
// ============================================================
// MAIN - INIT AU CHARGEMENT (DOMContentLoaded)
// ============================================================
if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", ()=>{
    $54b47fc030b7b21e$export$6243399072c0c4e3();
    (0, $656174d208695581$export$498d0fb7ade0687)();
    $54b47fc030b7b21e$var$initPatriciaHangingImage();
    $54b47fc030b7b21e$var$initAfterSectionZoom();
    $54b47fc030b7b21e$var$initSliderAnimation();
    (0, $656174d208695581$export$474c7158c4247004)();
    $54b47fc030b7b21e$var$initLogoWiggle();
    $54b47fc030b7b21e$var$initFooterSlowScroll();
    (0, $656174d208695581$export$b37588a3eee0f6fd)();
    (0, $592a78804c8b1cca$export$180426490a8b0f51)();
    (0, $4e74ac1112ac791b$export$6a1f221ffca70c82)();
});
else {
    $54b47fc030b7b21e$export$6243399072c0c4e3();
    (0, $656174d208695581$export$498d0fb7ade0687)();
    $54b47fc030b7b21e$var$initPatriciaHangingImage();
    $54b47fc030b7b21e$var$initAfterSectionZoom();
    $54b47fc030b7b21e$var$initSliderAnimation();
    (0, $656174d208695581$export$474c7158c4247004)();
    $54b47fc030b7b21e$var$initLogoWiggle();
    $54b47fc030b7b21e$var$initFooterSlowScroll();
    (0, $656174d208695581$export$b37588a3eee0f6fd)();
    initIndexLogoFall();
    (0, $592a78804c8b1cca$export$180426490a8b0f51)();
    (0, $4e74ac1112ac791b$export$6a1f221ffca70c82)();
}
// ============================================================
// MAIN - LOGO WIGGLE
// ============================================================
function $54b47fc030b7b21e$var$initLogoWiggle() {
    const logo = document.getElementById("logo");
    if (!logo) return;
    logo.addEventListener("click", ()=>{
        if (logo.classList.contains("shaking")) return;
        logo.classList.add("shaking");
        logo.addEventListener("animationend", ()=>logo.classList.remove("shaking"), {
            once: true
        });
    });
}
// ============================================================
// MAIN - BUBBLE CLICK
// ============================================================
function $54b47fc030b7b21e$var$initBubbleClick() {
    const bubble = document.getElementById("bubble");
    if (!bubble) return;
    let animating = false;
    bubble.style.cursor = "pointer";
    bubble.addEventListener("click", ()=>{
        if (animating) return;
        animating = true;
        (0, $4AGbv.default).timeline({
            onComplete: ()=>animating = false
        }).to(bubble, {
            scale: 1.25,
            duration: 0.25,
            ease: "power2.out"
        }).to(bubble, {
            scale: 1,
            duration: 0.5,
            ease: "elastic.out(1, 0.4)"
        });
    });
}
// ============================================================
// MAIN - VITESSE DE SCROLL PAR PAGE
// ============================================================
function $54b47fc030b7b21e$var$setScrollSpeed(namespace) {
    const speeds = {
        maladie: 0.45,
        autoportrait: 0.3
    };
    $54b47fc030b7b21e$var$lenis.options.wheelMultiplier = speeds[namespace] ?? 1;
}
// ============================================================
// MAIN - FOOTER SLOW SCROLL + PARALLAXE IMAGE
// ============================================================
function $54b47fc030b7b21e$var$initFooterSlowScroll() {
    const footer = document.querySelector(".footer");
    if (!footer) return;
    (0, $iNA1s.ScrollTrigger).create({
        trigger: footer,
        start: "top bottom",
        end: "bottom bottom",
        onEnter: ()=>{
            $54b47fc030b7b21e$var$lenis.options.wheelMultiplier = 0.3;
        },
        onLeaveBack: ()=>{
            $54b47fc030b7b21e$var$lenis.options.wheelMultiplier = 1;
        }
    });
    const footerImg = footer.querySelector(".footerimg img");
    if (!footerImg) return;
    (0, $4AGbv.default).fromTo(footerImg, {
        y: 60
    }, {
        y: 0,
        ease: "none",
        scrollTrigger: {
            trigger: footer,
            start: "top bottom",
            end: "top 30%",
            scrub: 1.5
        }
    });
}
// ============================================================
// MAIN - S3 OVERLAY SCROLL
// ============================================================
function $54b47fc030b7b21e$var$initS3Overlay() {
    const s3 = document.querySelector("#s3");
    if (!s3) return;
    (0, $4AGbv.default).fromTo(s3, {
        y: "40vh"
    }, {
        y: 0,
        ease: "none",
        scrollTrigger: {
            trigger: s3,
            start: "top bottom",
            end: "top top",
            scrub: true
        }
    });
}
// ============================================================
// MAIN - CADRES SVG HERO (créés dynamiquement)
// ============================================================
function $54b47fc030b7b21e$var$initCadre() {
    const r = 27;
    const cs = getComputedStyle(document.documentElement);
    const colorBg = cs.getPropertyValue("--bg").trim();
    const colorMaladie = cs.getPropertyValue("--sombre-maladie").trim();
    const colorAuto = cs.getPropertyValue("--auto-text").trim();
    function setupCadre(el, svgEl, color) {
        if (!el || !svgEl) return;
        let pathEl = svgEl.querySelector("path");
        if (!pathEl) {
            pathEl = document.createElementNS("http://www.w3.org/2000/svg", "path");
            svgEl.appendChild(pathEl);
        }
        pathEl.style.fill = "none";
        pathEl.style.stroke = color || "#fff";
        pathEl.style.strokeWidth = "2";
        pathEl.setAttribute("vector-effect", "non-scaling-stroke");
        function draw() {
            const W = el.clientWidth;
            const H = el.clientHeight;
            const d = [
                `M ${r},0`,
                `L ${W - r},0`,
                `A ${r},${r} 0 0 0 ${W},${r}`,
                `L ${W},${H - r}`,
                `A ${r},${r} 0 0 0 ${W - r},${H}`,
                `L ${r},${H}`,
                `A ${r},${r} 0 0 0 0,${H - r}`,
                `L 0,${r}`,
                `A ${r},${r} 0 0 0 ${r},0`,
                `Z`
            ].join(" ");
            svgEl.setAttribute("viewBox", `0 0 ${W} ${H}`);
            pathEl.setAttribute("d", d);
        }
        draw();
        new ResizeObserver(draw).observe(el);
    }
    [
        [
            "heroIndex",
            "heroIndexSvg",
            colorBg
        ],
        [
            "monCadre",
            "cadreSvg",
            colorBg
        ],
        [
            null,
            "heroSvgDante",
            colorBg
        ],
        [
            null,
            "heroSvgConversation",
            colorBg
        ],
        [
            null,
            "heroSvgMaladie",
            colorMaladie
        ],
        [
            null,
            "heroSvgAutoportrait",
            colorAuto
        ]
    ].forEach(([elId, svgId, color])=>{
        const svgEl = document.getElementById(svgId);
        const el = elId ? document.getElementById(elId) : svgEl?.parentElement;
        setupCadre(el, svgEl, color);
    });
}


//# sourceMappingURL=index.6dd72cbd.js.map
